const it: Record<string, string> = {
  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). IT gate copy
  //     translated from the approved DE/EN mockups (Om signs off wording in QA).
  //     Testimonial names/quotes/roles + photos are verbatim from the Webflow
  //     CMS (Janik 2026-06-11).
  'og.title.trust.lead': 'Prova Leadscraper ',
  'og.title.trust.grad': '3 giorni gratis',
  'og.title.trust.tail': ' con 50 lead reali.',
  'og.subtitle.trust':
    'Oggi non ti addebitiamo nulla. Provi con lead reali del tuo mercato di riferimento, e se non fa al caso tuo, chiudi la prova con un clic. Senza chiamate, senza preavviso.',
  'og.trust.demo.tag': 'Demo dal vivo · non un video di marketing',
  'og.trust.demo.title': 'Guarda come Leadscraper trova i tuoi lead',
  'og.trust.demo.body':
    'Ricerca reale, dashboard reale, risultati reali: il fondatore Janik ti accompagna nell’intero processo, dalla descrizione del tuo mercato di riferimento alla lista lead finita.',
  'og.trust.demo.play': 'Riproduci il video demo',
  'og.trust.demo.close': 'Chiudi',
  'og.trust.timeline.1.when': 'Oggi',
  'og.trust.timeline.1.body':
    'Scegli un piano, aggiungi un metodo di pagamento. {s}: i tuoi 50 crediti sono subito disponibili.',
  'og.trust.timeline.1.strong': '0 € addebitati',
  'og.trust.timeline.2.when': 'Giorni 1–3',
  'og.trust.timeline.2.body':
    'Provi con lead reali. Non sei convinto? {s} chiude la prova all’istante, senza contatti, senza spiegazioni.',
  'og.trust.timeline.2.strong': 'Un clic nel tuo account',
  'og.trust.timeline.3.when': 'Dal giorno 3',
  'og.trust.timeline.3.body':
    'Solo ora parte il tuo abbonamento nel piano scelto. {s}, nessuna durata minima.',
  'og.trust.timeline.3.strong': 'Disdici ogni mese',
  'og.trust.ctaNote': 'Oggi 0 € · Disdici = 1 clic',
  'og.trust.proof.head': 'Team commerciali che sono già passati a Leadscraper',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Recensioni su {platform}',
  'og.trust.bar.card.title': '0 € oggi',
  'og.trust.bar.card.body': 'Carta, PayPal o addebito SEPA, in sicurezza tramite Stripe',
  'og.trust.bar.cancel.title': 'Disdetto in 5 secondi',
  'og.trust.bar.cancel.body': '1 clic nel tuo account, senza contatti, effetto immediato',
  'og.trust.bar.gdpr.title': 'Solo dati pubblici',
  'og.trust.bar.gdpr.body': 'GDPR by design · server nell’UE · solo fonti pubbliche',
  'og.trust.founderLine.title': 'Realizzato ad Amburgo, Germania',
  'og.trust.founderLine.name': ' · Janik Deimann, Fondatore',
  'og.trust.founderLine.sub':
    'Ingegneria tedesca, protezione dati UE. E quando ci scrivi ti risponde una persona vera.',
  'og.trust.founderLine.ask':
    'Ancora indeciso? Scrivici: support@leadscraper.eu, ti risponde una persona vera.',

  // --- Paywall revisione 19 (approvata da Janik l'11/09/2026) ---
  // Il tedesco è l'originale approvato: mantieni il «fino a 50» qualificato e
  // la nota sui crediti aggiuntivi in tutte le traduzioni.
  'og.r19.accountReady': 'Account creato · Attiva la tua prova',
  'og.r19.headline.lead': 'Trova fino a',
  'og.r19.headline.grad': '50 lead gratuiti.',
  'og.r19.lead':
    'Inizia oggi con aziende in linea con la tua offerta. La tua prova include {credits} crediti per un massimo di {credits} lead aziendali.',
  'og.r19.offerNote':
    'I contatti e la ricerca sulle aziende consumano crediti aggiuntivi. I crediti usati per questo riducono il numero di aziende.',
  'og.r19.rating.value': '4,8 / 5',
  'og.r19.rating.caption': 'Feedback eccellente degli utenti',
  'og.r19.rating.aria': 'Valutazione dei clienti: 4,8 su 5 stelle',
  'og.r19.product.footnote': 'Decidi tu su quali aziende approfondire la ricerca.',
  'og.r19.picker.title': 'Inizia ora gratuitamente.',
  'og.r19.picker.trialCredits': '{credits} crediti di prova',
  'og.r19.picker.trialPlan': '{plan} · {days} giorni a 0 €, poi {renewal}, disdicibile ogni mese',
  'og.r19.picker.trialPlanAll': '{plan} · prova a 0 €, poi {renewal}, disdicibile ogni mese',
  'og.r19.picker.today': '0 €',
  'og.r19.picker.todayLabel': 'oggi',
  'og.r19.picker.description': 'Scegli il tuo pacchetto per il periodo dopo la prova.',
  'og.r19.credits.title': 'Trovare 1 azienda',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 credito',
  'og.r19.credits.note': 'Contatti e ricerca sulle aziende costano crediti aggiuntivi.',
  'og.r19.credits.info': 'Vedi un esempio di consumo dei crediti',
  'og.r19.credits.example':
    'Esempio: trovi 20 aziende e aggiungi contatti e ricerca sulle aziende per 10 di esse. Sono 40 crediti.',
  'og.r19.credits.exampleRest': 'Ti restano {rest} dei tuoi {credits} crediti di prova.',
  'og.r19.credits.disclaimer':
    '{credits} crediti non sono automaticamente {credits} contatti completamente ricercati.',
  'og.r19.plans.legend': 'Scegli il tuo pacchetto per dopo la prova',
  'og.r19.plans.creditsPerMonth': '{credits} crediti / mese',
  'og.r19.plans.perMonth': '/ mese',
  'og.r19.plans.caption.basic': 'Per iniziare',
  'og.r19.plans.caption.starter': "Per l'acquisizione regolare",
  'og.r19.plans.caption.growth': 'Per un reparto vendite più grande',
  'og.r19.cta': 'Inizia gratis ora',
  'og.r19.renewal': 'Poi {s} per {credits} crediti.',
  'og.r19.renewal.strong': '{price} € / mese',
  'og.r19.renewal.cancel': 'Disdici prima della fine della prova e non pagherai nulla.',
  'og.r19.security': 'Metodo di pagamento nel passaggio successivo',
  'og.r19.help.faq': 'Prova e disdetta',
  'og.r19.help.features': 'Pacchetti in dettaglio',
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'Online',
  'mcp.tok.generate': 'Genera token',
  'mcp.tok.title': 'Connetti un client IA',
  'mcp.tok.intro':
    'Genera un token personale per collegare Claude, Cursor o il tuo agente al tuo account Leadscraper. Il token viene mostrato una sola volta.',
  'mcp.tok.name': 'Nome del token',
  'mcp.tok.generating': 'Generazione…',
  'mcp.tok.once': 'Copia subito questo token: per sicurezza non verrà più mostrato.',
  'mcp.tok.yourToken': 'Il tuo token',
  'mcp.tok.copy': 'Copia',
  'mcp.tok.copied': 'Copiato',
  'mcp.tok.claudeConfig': 'Configurazione Claude Desktop',
  'mcp.tok.copyConfig': 'Copia configurazione',
  'mcp.tok.done': 'Fatto',
  'mcp.tok.limit': 'Limite di token raggiunto: revoca prima uno vecchio.',
  'mcp.tok.mintFailed': 'Impossibile generare il token. Riprova.',
  'mcp.tok.revoked': 'Token "{name}" revocato',
  'mcp.tok.revokeFailed': 'Impossibile revocare il token.',
  'mcp.tok.expires': 'scade',
  'mcp.tok.lastUsed': 'ultimo utilizzo',
  'mcp.tok.neverUsed': 'mai usato',
  'mcp.tok.revoke': 'Revoca',
  // LEA-349 Phase 3: Claude.ai (web) OAuth connect path
  'mcp.claude.connect': 'Collega a Claude',
  'mcp.claude.cardHint': 'Claude.ai (web) si collega con un clic tramite OAuth, senza token.',
  'mcp.claude.intro':
    "Aggiungi Leadscraper a Claude.ai come custom connector. Autorizzi l'accesso una sola volta: nessun token da copiare o incollare.",
  'mcp.claude.cta': 'Apri i connettori di Claude',
  'mcp.claude.urlLabel': "L'URL del tuo server MCP",
  'mcp.claude.step1': 'Clicca "Apri i connettori di Claude", poi "Add custom connector".',
  'mcp.claude.step2': "Incolla l'URL qui sopra e continua.",
  'mcp.claude.step3': 'Autorizza l\'accesso ("Allow"): ora Claude può usare i tuoi lead.',
  'mcp.claude.desktopNote': 'Usi Claude Desktop, Cursor o un tuo agente?',
  'mcp.claude.desktopCta': 'Genera invece un token',
  'acct.bill.addMethod': 'Aggiungi metodo di pagamento',
  'acct.bill.cardEnds': 'Visa termina con •• 4242',
  'acct.bill.cardExpHolder': 'Scadenza 08/2028 · Janik Deimann',
  'acct.bill.col.amount': 'Importo',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.date': 'Data',
  'acct.bill.col.desc': 'Descrizione',
  'acct.bill.col.invoice': 'Fattura',
  'acct.bill.col.status': 'Stato',
  'acct.bill.descSub': 'Abbonamento {plan} · {month} {year}',
  'acct.bill.empty': 'Nessuna transazione trovata',
  'acct.bill.emptySub': 'La cronologia dei tuoi pagamenti apparirà qui dopo il primo acquisto.',
  'acct.bill.filter.30': 'Ultimi 30 giorni',
  'acct.bill.filter.90': 'Ultimi 90 giorni',
  'acct.bill.filter.all': 'Sempre',
  'acct.bill.history': 'Cronologia Transazioni',
  'acct.bill.manageCards': 'Gestisci carte',
  'acct.bill.manageViaStripe': 'Gestione tramite Stripe Customer Portal',
  'acct.bill.methodAutoAdded': "Verrà aggiunto automaticamente dopo l'inizio del periodo di prova.",
  'acct.bill.methodOnFile': 'Metodo di pagamento salvato',
  'acct.bill.methods': 'Metodi di Pagamento',
  'acct.bill.noMethods': 'Nessun metodo di pagamento trovato',
  'acct.bill.paid': 'Pagato',
  'acct.bill.pdfUnavailable': 'Al momento non riusciamo a caricare qui questa fattura in PDF. Puoi aprirla e scaricarla su Stripe.',
  'acct.bill.pdfOpenStripe': 'Apri la fattura su Stripe',
  'acct.bill.primary': 'Primario',
  'acct.dataAccount': 'Dati e Account',
  'acct.deleteAccount.btn': 'Elimina account',
  'acct.deleteAccount.confirmBtn': 'Elimina account definitivamente',
  'acct.deleteAccount.confirmPwLabel': 'Inserisci la password per confermare',
  'acct.deleteAccount.deleting': 'Eliminazione in corso …',
  'acct.deleteAccount.errFailed': 'Eliminazione fallita.',
  'acct.deleteAccount.errPwRequired': 'Inserisci la password.',
  'acct.deleteAccount.modalBody':
    'Il tuo account sarà disattivato ed eliminato definitivamente dopo 30 giorni. Entro questo periodo puoi riattivarlo con email + password. Tutti i tuoi leads, profili e valutazioni saranno poi eliminati irreversibilmente.',
  'acct.deleteAccount.modalTitle': 'Elimina account',
  'acct.deleteAccount.title': 'Elimina account',
  'acct.deleteAccount.warn':
    'Il tuo account sarà eliminato definitivamente tra 30 giorni. Puoi riattivarlo entro questo periodo.',
  'acct.seedimport.title': 'Importa elenco clienti esistenti',
  'acct.seedimport.desc':
    'Carica un file CSV o di testo con i tuoi clienti esistenti — un dominio o URL per riga (o una colonna di domini). Queste aziende non vengono mai consegnate come nuovo lead in NESSUN pubblico.',
  'acct.seedimport.hint': 'CSV o .txt · max 5 MB',
  'acct.seedimport.cta': 'Carica CSV',
  'acct.seedimport.uploading': 'Importazione …',
  'acct.seedimport.report':
    '{rows} righe · {resolved} domini riconosciuti · {added} nuovi · {total} nel tuo elenco',
  'acct.seedimport.unresolved': '{n} righe ignorate (nessun dominio riconoscibile)',
  'acct.seedimport.capped':
    'Limite di importazione raggiunto — non tutti i domini sono stati aggiunti.',
  'acct.seedimport.failed': 'Importazione non riuscita. Controlla il file e riprova.',
  'acct.export.btn': 'Esporta',
  'acct.export.failed': 'Esportazione fallita. Riprova.',
  'acct.export.preparing': 'Preparazione esportazione: può richiedere tempo con molti dati.',
  'acct.export.ready': 'Download avviato.',
  'acct.export.sub': 'GDPR Art. 20 · Tutti i tuoi dati come download JSON.',
  'acct.export.title': 'Esporta dati',
  'acct.int.apiKey': 'Chiave API',
  'acct.int.apiKeyP': 'Dalle impostazioni sviluppatore del tuo CRM',
  'acct.int.autoPush': 'Invio automatico per "Adatto"',
  'acct.int.autoPushSub': 'I Leads vengono inviati automaticamente al CRM non appena li confermi.',
  'acct.int.bulkPush': 'Invia {n} al CRM',
  // LEA-282: HubSpot OAuth strings (Wave 2)
  'acct.int.oauthFail': 'Connessione OAuth fallita',
  'acct.int.reconnect': 'Riconnetti',
  'acct.int.reconnectRequired': 'Riconnessione richiesta',
  'acct.int.connectedVia': 'Connesso via OAuth',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Invio in corso…',
  'det.crmPushFail': 'Push al CRM fallito',
  'det.crmSubRequired': 'Il push al CRM richiede un piano a pagamento.',
  'det.crmDuplicate': 'Già nel CRM',
  'det.crmNotConnected': 'Nessun CRM connesso: configuralo in Account → Integrazioni',
  'det.crmOpenRecord': 'Visualizza record',
  'acct.int.pushFail': 'Push al CRM fallito',
  'acct.int.pushDuplicate': 'Già nel CRM',
  'acct.int.pushSubRequired': 'Il push al CRM richiede un piano a pagamento.',
  'acct.int.bulkSummary': '{pushed} inviati · {skipped} saltati · {failed} falliti',
  'leads.bulkPushBtn': 'Invia {n} a {crm}',
  'leads.bulkPushPickBtn': 'Invia {n} al CRM ▾',
  'leads.bulkPushTitle': 'Invia i lead attualmente visibili (max 50) al tuo CRM',
  'acct.int.cancel': 'Annulla',
  'acct.int.connect': 'Connetti',
  // LEA-317
  'acct.int.subRequired':
    'Le integrazioni CRM sono disponibili solo nei piani a pagamento. Esegui l’upgrade del piano per collegare il tuo CRM.',
  'acct.int.upgradeTitle': 'Esegui l’upgrade per collegare il tuo CRM',
  'acct.int.upgradeCta': 'Esegui l’upgrade',
  'acct.int.connectFirst':
    "Collega il tuo CRM nelle impostazioni dell'account per inviare automaticamente i Leads.",
  'acct.int.connectSuccess': 'Connesso a {name}',
  'acct.int.connected': 'Connesso',
  'acct.int.disconnect': 'Disconnetti',
  'acct.int.disconnectSuccess': 'Connessione a {name} interrotta',
  'acct.int.manage': 'Gestisci',
  'acct.int.mapping': 'Mappatura campi',
  'acct.int.mappingSub': 'Campi Leadscraper → Campi CRM',
  'acct.int.none': 'Nessun CRM connesso',
  'acct.int.notConnected': 'Non connesso',
  'acct.int.notPushedYet': 'Non ancora inviato',
  'acct.int.object': 'Tipo di oggetto',
  'acct.int.openInCRM': 'Apri in {name}',
  'acct.int.owner': 'Responsabile (Owner)',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.pushSuccess': '{n} Lead(s) inviati a {name}',
  'acct.int.pushToCRM': 'Invia al CRM',
  'acct.int.pushedAt': 'Inviato {when}',
  'acct.int.pushedTo': 'In {name}',
  'acct.int.save': 'Salva connessione',
  'acct.int.sectionLead': 'Stato CRM',
  'acct.int.stage': 'Fase per nuovi Leads',
  'acct.int.sub':
    'Collega il tuo CRM e invia Leads adatti automaticamente – o manualmente per ogni Lead.',
  // LEA-334: webhook signing secret + verification handshake
  'acct.int.whsec.title': 'Secret di firma del webhook',
  'acct.int.whsec.sub':
    'Firmiamo ogni invio del webhook con HMAC-SHA256, così il tuo endpoint può verificare che arrivi davvero da Leadscraper.',
  'acct.int.whsec.revealed': 'Copialo ora: viene mostrato una sola volta.',
  'acct.int.whsec.copy': 'Copia',
  'acct.int.whsec.copied': 'Copiato',
  'acct.int.whsec.rotate': 'Rigenera e mostra il secret',
  'acct.int.whsec.rotating': 'Rigenerazione…',
  'acct.int.whsec.rotateHint':
    'La rigenerazione crea un nuovo secret e lo mostra una sola volta, poi aggiorna il tuo endpoint.',
  'acct.int.whsec.fail': 'Impossibile rigenerare il secret di firma.',
  'acct.int.whsec.docs':
    'Verifica: header X-Leadscraper-Signature: t=<unix>,v1=<hex>, dove hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Rifiuta la richiesta se non corrisponde o se il timestamp è scaduto.',
  'acct.int.webhookUrl': 'URL del webhook',
  'acct.int.webhookUrlP': 'https://your-endpoint.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'I nuovi lead vengono inviati al tuo webhook in automatico, non appena i loro contatti sono arricchiti.',
  'acct.int.whverify.title': 'Verifica il tuo endpoint',
  'acct.int.whverify.sub':
    'Un endpoint raggiungibile (che risponde 2xx) non è la stessa cosa di uno verificato. Conferma un codice monouso così sappiamo che i lead arrivano davvero: fino ad allora non ne consegniamo nessuno.',
  'acct.int.whverify.verified': '✓ Verificato',
  'acct.int.whverify.unverified': 'Non verificato',
  'acct.int.whverify.send': 'Invia evento di test',
  'acct.int.whverify.sending': 'Invio…',
  'acct.int.whverify.resend': "Invia di nuovo l'evento di test",
  'acct.int.whverify.sent': 'Evento di test inviato: controlla il codice sul tuo endpoint.',
  'acct.int.whverify.sendFail': "Impossibile inviare l'evento di test.",
  'acct.int.whverify.enter': 'Inserisci il codice (LSWH-…) arrivato al tuo endpoint:',
  'acct.int.whverify.confirm': 'Conferma',
  'acct.int.whverify.ok': 'Webhook verificato: ora i lead possono essere consegnati.',
  'acct.int.whverify.mismatch': 'Il codice non corrisponde. Controlla il tuo endpoint e riprova.',
  'acct.int.whverify.expired': 'Il codice è scaduto: invia un nuovo evento di test.',
  'acct.int.testing': 'Test connessione in corso…',
  'acct.int.title': 'Integrazioni CRM',
  'acct.menu.logout': 'Disconnetti',
  'acct.menu.settings': 'Impostazioni Account',
  'acct.plan.active': 'Attivo',
  'acct.plan.canceled': 'Annullato',
  'acct.plan.refundedEnded':
    'Abbonamento rimborsato: piano terminato. Scegli un piano per continuare.',
  'acct.plan.addOneOff': 'Aggiungi pacchetto una tantum',
  'acct.plan.afterTrial': 'Dopo il periodo di prova',
  'acct.plan.bonusCredits': 'Credits Pacchetto',
  'acct.plan.bonusCreditsTip':
    'Credits pagati da pacchetti una tantum: vengono accreditati in aggiunta alla quota mensile e non scadono.',
  'acct.plan.dayLeft':
    'Ancora 1 giorno di prova gratuita, poi il tuo abbonamento continuerà automaticamente.',
  // LEA-561: Abbuchungsdatum + Ein-Klick-Kuendigung im Trial. Bewusst OHNE
  // Erinnerungs-Versprechen — die Reminder-Mail ist gebaut, aber noch von
  // keinem Scheduler aufgerufen; eine Zusage, die das System nicht halten
  // kann, ist genau der Vertrauensbruch, den LEA-553 abstellen soll.
  'acct.plan.trialFirstCharge': 'Primo addebito il {date}. Disdici quando vuoi con un clic.',
  'acct.plan.daysLeft':
    'Ancora {n} giorni di prova gratuita, poi il tuo abbonamento continuerà automaticamente.',
  'acct.plan.endsToday':
    'Il periodo di prova termina oggi: il tuo abbonamento inizierà automaticamente.',
  'acct.plan.leftOf': 'di {total} rimanenti',
  'acct.plan.monthUsage': 'Leads questo mese',
  'acct.plan.nextBill': 'Prossima fatturazione il {date} · {leads} Leads/mese',
  'acct.plan.cancelsOn': 'Termina il {date}',
  'acct.plan.cancelNote': 'Nessun ulteriore addebito: attivo fino al {date}.',
  'acct.plan.perMonth': '/ mese',
  'acct.plan.secureSub': 'Conferma abbonamento',
  'acct.plan.switch': 'Cambia piano',
  'acct.plan.trial': 'Periodo di prova',
  'acct.plan.trialCredits': 'Credits di Prova',
  'acct.plan.trialCreditsTip':
    'Credits di prova gratuiti dalla tua registrazione: vengono accreditati in aggiunta alla quota mensile e non scadono.',
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'Credits trasferiti',
  'acct.plan.carriedOverCreditsTip':
    'Il tuo saldo di prima del passaggio alla fatturazione per contatto: si aggiunge alla quota mensile e non scade.',
  'acct.plan.trialUsage': 'Leads di prova in questa fase',
  'acct.plan.usedThisMonth': '{used} / {total} utilizzati questo mese · Reset il {date}',
  'acct.plan.your': 'Il Tuo Piano',
  'acct.prof.avatarErr': "Impossibile caricare l'immagine. Riprova.",
  'acct.prof.avatarMime': 'Seleziona un file JPG, PNG o WebP.',
  'acct.prof.avatarSize': 'File troppo grande (max 2 MB).',
  'acct.prof.avatarUpdated': 'Immagine profilo aggiornata.',
  'acct.prof.email': 'Indirizzo email',
  'acct.prof.first': 'Nome',
  'acct.prof.lang': 'Lingua',
  'acct.prof.last': 'Cognome',
  'acct.prof.save': 'Salva',
  'acct.prof.title': 'Informazioni Profilo',
  'acct.prof.upload': 'Carica immagine',
  'acct.prof.uploadHint': 'JPG, PNG o WebP. Max 2 MB.',
  'acct.pw.changing': 'Modifica in corso…',
  'acct.pw.complexity':
    'La nuova password deve contenere almeno 8 caratteri, lettere maiuscole e minuscole, cifre e caratteri speciali (@$!%*?&).',
  'acct.pw.confirm': 'Conferma nuova password',
  'acct.pw.cta': 'Modifica password',
  'acct.pw.current': 'Password attuale',
  'acct.pw.failed': 'Impossibile modificare la password.',
  'acct.pw.minErr': 'Minimo 8 caratteri.',
  'acct.pw.minHint': 'Minimo 8 caratteri',
  'acct.pw.mismatch': 'Le password non corrispondono.',
  'acct.pw.new': 'Nuova password',
  'acct.pw.sameAsCurrent': 'La nuova password deve essere diversa da quella attuale.',
  'acct.pw.success': 'Password modificata ✓',
  'acct.pw.title': 'Cambia password',
  'acct.pw.wrongCurrent': 'La password attuale è errata.',
  'acct.sec.active': 'Attiva',
  'acct.sec.change': 'Modifica',
  'acct.sec.inactive': 'Inattiva',
  'acct.sec.pw': 'Cambia password',
  'acct.sec.pwSub': 'Modifica qui la password del tuo account',
  'acct.sec.title': 'Impostazioni di Sicurezza',
  'acct.sec.twofa': 'Autenticazione a Due Fattori',
  'acct.sec.twofaActivate': 'Attiva 2FA',
  'acct.sec.twofaDeactivate': 'Disattiva 2FA',
  'acct.sec.twofaSoon':
    "L'autenticazione a due fattori (app autenticatore) non è ancora collegata qui: il pulsante finora era solo locale. La vera 2FA arriva prossimamente.",
  'acct.sec.twofaSub':
    "L'autenticazione è disattivata. Attivala per aggiungere un livello di sicurezza aggiuntivo al tuo account.",
  'acct.sub':
    'Gestisci le impostazioni del profilo, modifica i metodi di pagamento e scarica le fatture per le transazioni passate.',
  'acct.tab.billing': 'Fatturazione',
  'acct.tab.integrations': 'Integrazioni',
  'acct.tab.profile': 'Profilo',
  'acct.founder.title': 'Filo diretto con il fondatore',
  'acct.founder.body':
    'Feedback, una domanda, un problema? Il tuo messaggio arriva direttamente a Janik, non in un sistema di ticket.',
  'acct.founder.cta': 'Scrivi a Janik',
  'acct.title': 'Profilo',
  'acct.toast.failed': 'Salvataggio fallito. Riprova.',
  'acct.toast.saved': 'Profilo salvato.',

  'ai.collapse': 'Comprimi',
  'ai.cortex': 'Leadscraper',
  'ai.dismiss': 'Nascondi',
  'ai.errorReply':
    'Non riesco ad accedere ai miei dati al momento. Riprova tra poco, o formula la domanda più brevemente.',
  'ai.footer': 'Leadscraper conosce solo i tuoi target e i feedback: nessun dato esterno.',
  'ai.greeting':
    'Ciao 👋 Sono il tuo assistente Leadscraper. Vedo il tuo profilo attivo "{profile}" e tutti i pattern che il sistema ha imparato. Di cosa hai bisogno?',
  'ai.inputP': "Chiedi qualcosa all'assistente …",
  'ai.ins.edge.cta': 'Guarda lead',
  'ai.ins.edge.fallback':
    'Leadscraper è incerto qui: il tuo giudizio aiuta a perfezionare il pattern.',
  'ai.ins.edge.title': 'Caso limite: {company}',
  'ai.ins.pattern.cta': 'Controlla pattern',
  'ai.ins.pattern.title': 'Nuovo pattern in "{profile}"',
  'ai.ins.tune.body':
    'Tasso di corrispondenza al {rate}%. Posso aiutarti a formulare la prossima ricerca in modo più mirato.',
  'ai.ins.tune.cta': 'Perfeziona ricerca',
  'ai.ins.tune.title': '"{profile}" è ancora in formazione',
  'ai.intro':
    'Monitoro i tuoi profili 24/7 e ti aiuto a formulare ricerche più precise e segnali di apprendimento sicuri.',
  'ai.langHint':
    'Rispondi in italiano. Massimo 3-4 frasi brevi per risposta, eccetto per istruzioni concrete.',
  'ai.moreN': '+{n} altri',
  'ai.now': 'ora',
  'ai.onlinePrefix': 'Online · conosce i tuoi {n} target',
  'ai.openChat': 'Apri chat',
  'ai.quickStart': 'Avvio rapido',
  'ai.seedRefine': 'Proponimi una ricerca affinata per il mio target «{profile}».',
  'ai.send': 'Invia',
  'ai.sp1.label': 'A che punto è il mio target attivo?',
  'ai.sp1.prompt':
    'Riassumimi in 3 frasi quanto bene Leadscraper ha già capito il mio profilo attivo: cosa ha imparato e cosa no?',
  'ai.sp2.label': 'Quali pattern dovrei confermare?',
  'ai.sp2.prompt':
    'Quali pattern appresi dovrei confermare o rifiutare per far sì che il sistema impari più velocemente?',
  'ai.sp3.label': 'Suggerisci ricerca',
  'ai.sp3.prompt':
    'Suggeriscimi una prossima ricerca precisa basata sul mio profilo attivo, con settore, posizione, dimensione e extra.',
  'ai.sp4.label': 'Dove perdo qualità?',
  'ai.sp4.prompt':
    'Dove vedi potenziale per tassi di corrispondenza più alti nei miei profili? Cosa dovrei aggiustare?',
  'ai.tag.confirmed': 'confermato',
  'ai.tag.uncertain': 'incerto',
  'ai.tag.unconfirmed': 'non confermato',
  'ai.thinkingAbout': 'A cosa sto pensando ora',

  'api.confidence.cautiously_optimistic': 'cautamente ottimista',
  'api.confidence.fairly_sure': 'abbastanza sicuro',
  'api.confidence.uncertain': 'incerto',
  'api.confidence.very_sure': 'molto sicuro',

  'apierr.intentParseTimeout': "La nostra IA ha impiegato troppo tempo a leggere la tua descrizione: riprova tra un attimo.",

  'auth.login.docTitle': 'Accedi · Leadscraper',
  'auth.login.email': 'E-mail',
  'auth.login.errCredentials': 'Email o password errata.',
  'auth.login.errEmail': 'Indirizzo email non valido.',
  'auth.login.errEmpty': 'Compila tutti i campi.',
  'auth.login.errGeneric': 'Accesso fallito. Riprova.',
  'auth.login.errUnverified': 'Conferma prima il tuo indirizzo email.',
  'auth.login.forgot': 'Password dimenticata?',
  'auth.login.google': 'Accedi con Google',
  'auth.login.googleBusy': 'Accesso con Google …',
  'auth.login.hidePassword': 'Nascondi password',
  'auth.login.microsoft': 'Accedi con Microsoft',
  'auth.login.microsoftBusy': 'Accesso con Microsoft …',
  'auth.login.noAccount': 'Non hai ancora un account?',
  'auth.login.or': 'Oppure',
  'auth.login.password': 'Password',
  'auth.login.remember': 'Rimani connesso',
  'auth.login.showPassword': 'Mostra password',
  'auth.login.signUp': 'Registrati',
  'auth.login.sub': 'Accedi al tuo account per accedere al tuo profilo.',
  'auth.login.submit': 'Accedi',
  'auth.login.submitting': 'Accesso in corso …',
  'auth.login.title': 'Bentornato',
  'auth.register.docTitle': 'Registrati · Leadscraper',
  'auth.register.email': 'E-mail',
  'auth.register.errEmail': 'Indirizzo email non valido.',
  'auth.register.errEmpty': 'Compila tutti i campi.',
  'auth.register.errBotCheck': 'Completa la verifica anti-bot.',
  'auth.register.errPwMismatch': 'Le password non corrispondono.',
  'auth.register.errPwShort': 'La password deve contenere almeno 8 caratteri.',
  'auth.register.firstName': 'Nome',
  'auth.register.google': 'Registrati con Google',
  'auth.register.googleBusy': 'Registrazione con Google …',
  'auth.register.haveAccount': 'Hai già un account?',
  'auth.register.hidePassword': 'Nascondi password',
  'auth.register.lastName': 'Cognome',
  'auth.register.microsoft': 'Registrati con Microsoft',
  'auth.register.microsoftBusy': 'Registrazione con Microsoft …',
  'auth.register.or': 'Oppure',
  'auth.register.password': 'Password',
  'auth.register.passwordConfirm': 'Conferma password',
  'auth.register.showPassword': 'Mostra password',
  'auth.register.signIn': 'Accedi',
  'auth.register.sub':
    'Prova quanto è semplice generare liste di leads precise oggi grazie agli agenti AI.',
  'auth.register.submit': 'Crea account',
  'auth.register.submitting': 'Creazione in corso …',
  'auth.register.title': 'Crea account gratuito',
  'auth.reset.backToLogin': 'Torna al login',
  'auth.reset.confirmLabel': 'Conferma password*',
  'auth.reset.confirmPlaceholder': 'Reinserisci la password',
  'auth.reset.docTitle': 'Reimposta password · Leadscraper',
  'auth.reset.doneSub': 'Ora puoi accedere con la tua nuova password.',
  'auth.reset.doneTitle': 'Password cambiata con successo',
  'auth.reset.emailLabel': 'Email*',
  'auth.reset.emailPlaceholder': 'Inserisci il tuo indirizzo email',
  'auth.reset.errInvalidEmail': 'Inserisci un indirizzo email valido.',
  'auth.reset.errPwMismatch': 'Le password non corrispondono.',
  'auth.reset.errPwShort': 'La password deve contenere almeno 8 caratteri.',
  'auth.reset.errPwWeak':
    'La password deve contenere lettere maiuscole e minuscole, un numero e un carattere speciale.',
  'auth.reset.pwRules':
    'Almeno 8 caratteri, con lettere maiuscole e minuscole, un numero e un carattere speciale.',
  'auth.reset.errRequest': 'Richiesta fallita. Riprova.',
  'auth.reset.goToLogin': 'Vai al login',
  'auth.reset.haveAccount': 'Hai già un account?',
  'auth.reset.hidePassword': 'Nascondi password',
  'auth.reset.invalidSub':
    'Questo link per reimpostare la password non è più valido. Richiedine uno nuovo.',
  'auth.reset.invalidTitle': 'Link non valido o scaduto',
  'auth.reset.newPwLabel': 'Nuova password*',
  'auth.reset.newPwPlaceholder': 'Almeno 8 caratteri',
  'auth.reset.newPwSub': 'Scegli una nuova password per il tuo account.',
  'auth.reset.newPwTitle': 'Imposta nuova password',
  'auth.reset.requestNew': 'Richiedi nuovo link',
  'auth.reset.oauthTitle': "Questo account usa l'accesso con {provider}",
  'auth.reset.oauthSub': 'Questo account non ha una password. Accedi invece con {provider}.',
  'auth.reset.resetBtn': 'Reimposta password',
  'auth.reset.saving': 'Salvataggio in corso …',
  'auth.reset.send': 'Invia link',
  'auth.reset.sending': 'Invio in corso …',
  'auth.reset.sentSub':
    'Se esiste un account con questa email, ti abbiamo inviato un link per reimpostare la password. Controlla la tua posta (e lo spam).',
  'auth.reset.sentTitle': 'Email inviata',
  'auth.reset.showPassword': 'Mostra password',
  'auth.reset.signIn': 'Accedi',
  'auth.reset.sub':
    'Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.',
  'auth.reset.title': 'Reimposta password',
  'auth.shell.nextSlide': 'Slide successiva',
  // LEA-285: auth slide carousel — mirrors apps/auth/src/lib/i18n.ts.
  'auth.slides.1.headline':
    'Gli agenti IA trovano aziende B2B che corrispondono esattamente al tuo profilo cliente ideale.',
  'auth.slides.2.headline':
    'Ogni lista lead è generata da zero da fonti pubbliche: nessun dato obsoleto o rivenduto.',
  'auth.slides.3.headline':
    'Ogni lead include i decision-maker rilevanti, link alle fonti e una motivazione chiara del perché è in target.',
  'auth.slides.aria.region': 'Caratteristiche prodotto',
  'auth.slides.aria.slide': 'Slide {n} di {total}',
  'auth.slides.aria.goTo': 'Vai alla slide {n}',

  // --- Login + Registrierung, Revision 19 (Janik 17.09.2026) ---
  // Uebersetzung; das deutsche Original ist die Referenz.
  'auth.r19.skip': 'Vai al contenuto',
  'auth.r19.header.haveAccount': 'Hai già un account?',
  'auth.r19.hero.titleLead': 'Trova i',
  'auth.r19.hero.titleGrad': 'clienti',
  'auth.r19.hero.titleTail': 'per cui è pensata la tua offerta.',
  'auth.r19.hero.lead':
    'Descrivi chi vuoi raggiungere. Leadscraper trova le aziende adatte, cerca i referenti e ti mostra da dove iniziare la conversazione.',
  'auth.r19.demo.caption': 'La tua ricerca. Passo dopo passo.',
  'auth.r19.demo.play': 'Guarda il percorso',
  'auth.r19.form.title': 'Inizia con Leadscraper.',
  'auth.r19.form.google': 'Con Google',
  'auth.r19.form.microsoft': 'Con Microsoft',
  'auth.r19.form.separator': 'oppure con la tua e-mail',
  'auth.r19.form.businessEmail': 'E-mail aziendale',
  'auth.r19.form.emailPlaceholder': 'tu@azienda.it',
  'auth.r19.form.show': 'Mostra',
  'auth.r19.form.hide': 'Nascondi',
  'auth.r19.legal.accept':
    'Registrandoti accetti i nostri {terms}. Trovi le informazioni sui tuoi dati nella nostra {privacy}.',
  'auth.r19.legal.privacyLink': 'informativa sulla privacy',
  'auth.r19.proof.founderTitle': 'Seguito personalmente dal fondatore.',
  'auth.r19.proof.founderBody': 'Janik è il tuo referente diretto.',
  'auth.r19.confidence.eyebrow': 'Prima della tua prima conversazione',
  'auth.r19.confidence.title1': 'Sai a chi ti rivolgi.',
  'auth.r19.confidence.title2': 'E perché.',
  'auth.r19.confidence.p1.title': 'Le fonti sono incluse.',
  'auth.r19.confidence.p1.body':
    'Vedi su cosa si basa la ricerca e puoi verificare i dati da solo.',
  'auth.r19.confidence.p2.title': 'Ciò che manca resta visibile.',
  'auth.r19.confidence.p2.body':
    'Se manca un dato, si vede. Così decidi tu come proseguire la ricerca.',
  'auth.r19.confidence.p3.title': 'Ottieni uno spunto.',
  'auth.r19.confidence.p3.body':
    "La conoscenza dell'azienda ti aiuta a preparare il primo contatto partendo da un motivo concreto.",
  'auth.r19.founder.eyebrow': 'Personalmente al tuo fianco',
  'auth.r19.founder.role': 'Fondatore di Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, fondatore di Leadscraper',
  'auth.r19.founder.body':
    'Ti aiuto personalmente nella tua ricerca e con le tue domande su Leadscraper.',
  'auth.r19.founder.contact': 'Chiedi in chat',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Privacy',
  'auth.r19.footer.imprint': 'Note legali',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/it/note-legali',
  'auth.r19.footer.navLabel': 'Informazioni legali',
  'auth.verify.defaultError': 'Si è verificato un errore.',
  // Auth — Set Password (LEA-527)
  'auth.setPw.docTitle': 'Imposta la password · Leadscraper',
  'auth.setPw.loading': 'Un momento …',
  'auth.setPw.greeting': 'Benvenuto, {name}!',
  'auth.setPw.title': 'Il tuo account è pronto',
  'auth.setPw.sub':
    'Imposta la tua password per iniziare — i tuoi lead ti aspettano già nell’account.',
  'auth.setPw.pwLabel': 'Password*',
  'auth.setPw.pwPlaceholder': 'Almeno 8 caratteri',
  'auth.setPw.confirmLabel': 'Conferma password*',
  'auth.setPw.confirmPlaceholder': 'Reinserisci la password',
  'auth.setPw.submit': 'Imposta la password e inizia',
  'auth.setPw.saving': 'Configurazione dell’account …',
  'auth.setPw.errPwShort': 'La password deve contenere almeno 8 caratteri.',
  'auth.setPw.errPwWeak':
    'La password deve contenere lettere maiuscole e minuscole, un numero e un carattere speciale.',
  'auth.setPw.pwRules':
    'Almeno 8 caratteri, con lettere maiuscole e minuscole, un numero e un carattere speciale.',
  'auth.setPw.errPwMismatch': 'Le password non coincidono.',
  'auth.setPw.errGeneric': 'Qualcosa è andato storto. Riprova.',
  'auth.setPw.doneTitle': 'Tutto pronto!',
  'auth.setPw.doneSub': 'Ti stiamo portando nel tuo account …',
  'auth.setPw.invalidTitle': 'Link non valido o scaduto',
  'auth.setPw.invalidSub':
    'Questo link di configurazione non è più valido. Contatta il tuo referente Leadscraper.',
  'auth.setPw.backToLogin': 'Vai all’accesso',
  'auth.setPw.resend': 'Inviami un nuovo link',
  'auth.setPw.resending': 'Invio in corso …',
  'auth.setPw.resentTitle': 'Nuovo link inviato',
  'auth.setPw.resentSub': 'Ti abbiamo inviato un nuovo link via email — è valido per 14 giorni.',
  'auth.setPw.resendErr': 'Invio non riuscito. Riprova.',

  'auth.verify.docTitle': 'Conferma email · Leadscraper',
  'auth.verify.error': 'Conferma fallita',
  'auth.verify.goToDashboard': 'Vai subito alla dashboard',
  'auth.verify.noToken': 'Link di conferma mancante',
  'auth.verify.noTokenSub':
    "Clicca sul link nell'email che ti abbiamo inviato. Se non hai ricevuto l'email, puoi richiederne una nuova.",
  'auth.verify.resendError': 'Richiedi nuova email di conferma',
  'auth.verify.resendFailed': "Impossibile inviare nuovamente l'email.",
  'auth.verify.resendNoToken': 'Invia nuovamente email di conferma',
  'auth.verify.resending': 'Invio in corso …',
  'auth.verify.resent': 'Email inviata nuovamente ✓',
  'auth.verify.success': 'Successo!',
  'auth.verify.successSub':
    'Il tuo indirizzo email è stato confermato. Reindirizzamento alla dashboard …',
  'auth.verify.title': 'Conferma email',
  'auth.verify.toLogin': 'Vai al login',
  'auth.verify.verifying': 'Conferma email in corso …',
  'auth.verify.verifyingSub': 'Un momento per favore.',

  'bill.ret.cancelBody':
    'Non è stato addebitato nulla. Puoi riavviare il processo di pagamento in qualsiasi momento.',
  'bill.ret.cancelCta': 'Torna al Dashboard',
  'bill.ret.cancelTitle': 'Operazione annullata',
  'bill.ret.cta': 'Vai al Dashboard',
  'bill.ret.docTitleCancel': 'Operazione annullata · Leadscraper',
  'bill.ret.docTitleSuccess': 'Pagamento riuscito · Leadscraper',
  'bill.ret.errorBody':
    'Il tuo pagamento potrebbe essere andato a buon fine. Non siamo riusciti a caricare lo stato al momento. Controlla nel tuo account sotto "Fatturazione".',
  'bill.ret.errorTitle': 'Stato non recuperabile',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} disponibili',
  'bill.ret.rowNextRenewal': 'Prossimo rinnovo',
  'bill.ret.rowPlan': 'Piano',
  'bill.ret.seedCta': 'Vai ai miei lead',
  'bill.ret.seedDone': 'Tutti i {delivered} lead sono pronti. Si parte!',
  'bill.ret.seedPartial':
    '{delivered} lead sono pronti. Il resto del tuo saldo resta disponibile per le tue ricerche.',
  'bill.ret.seedWorking':
    '{delivered} di {total} lead sono completati, il resto è in fase di arricchimento. In tutto ci vogliono da 10 a 30 minuti.',
  'bill.ret.seedWorkingCreated':
    'I tuoi {created} lead sono creati. La ricerca dei referenti richiede da 10 a 30 minuti. Meglio esportare quando ci sono tutti.',
  'bill.ret.seedWorkingZero':
    'I tuoi lead sono in fase di creazione. La ricerca dei referenti richiede da 10 a 30 minuti. Meglio esportare quando ci sono tutti.',
  'bill.ret.successBodyCredits': 'I tuoi Credits sono stati accreditati.',
  'bill.ret.successBodySub': 'Il tuo abbonamento è attivo. Ora hai accesso ai tuoi Leads.',
  'bill.ret.successTitle': 'Pagamento riuscito',
  'bill.ret.verifying': 'Pagamento in elaborazione…',
  'bill.ret.verifyingSub': 'Stiamo aggiornando il tuo account. Richiederà solo un momento.',

  'billing.disabled': 'I pagamenti non sono attualmente disponibili. Riprova più tardi.',
  'billing.errorClose': 'Chiudi',
  'billing.errorTitle': 'Qualcosa è andato storto',
  'billing.portalNoCustomer':
    "La gestione dell'abbonamento è disponibile solo dopo il primo acquisto.",
  'billing.trialStarted': "Benvenuto nell'abbonamento {plan}: periodo di prova attivo.",
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    'Il tuo abbonamento è programmato per terminare. Riattivalo prima, poi potrai cambiare piano.',
  'billing.manageInPortal':
    'Questo abbonamento non può essere cambiato ora. Apri il portale di fatturazione per sistemare il pagamento.',
  'billing.unknownError': 'Errore sconosciuto durante il processo di pagamento.',
  'billing.alreadySubscribed': 'Hai già questo abbonamento. Il tuo piano attuale è in Fatturazione.',

  'boot.connectionError': 'Errore di connessione',
  'boot.connectionErrorDesc': 'Impossibile stabilire una connessione al server: {msg}',
  'boot.retry': 'Riprova',
  'boot.reconnecting': 'Riconnessione… (tentativo {n})',

  'common.cancel': 'Annulla',
  'common.collapse': 'Comprimi',
  'common.edit': 'Modifica',
  'common.hide': 'Nascondi',
  'common.loading': 'Caricamento …',
  'common.month.apr': 'Aprile',
  'common.month.aug': 'Agosto',
  'common.month.dec': 'Dicembre',
  'common.month.feb': 'Febbraio',
  'common.month.jan': 'Gennaio',
  'common.month.jul': 'Luglio',
  'common.month.jun': 'Giugno',
  'common.month.mar': 'Marzo',
  'common.month.may': 'Maggio',
  'common.month.nov': 'Novembre',
  'common.month.oct': 'Ottobre',
  'common.month.sep': 'Settembre',
  'common.refresh': 'Aggiorna',
  'common.save': 'Salva',
  'common.saving': 'Salvataggio in corso …',

  'cortex.activeSince': 'Target attivo dal',
  'cortex.confirm': 'Conferma',
  'cortex.confirmed': 'confermato da te',
  'cortex.correct': 'Correggi',
  'cortex.ctaRate': 'Valuta ora i primi Leads',
  'cortex.feedbacks': 'Feedback',
  'cortex.fits': 'Adatto',
  'cortex.fitsNot': 'Non adatto',
  'cortex.footer':
    "Quando correggi o dimentichi un'affermazione, non verrà più utilizzata per ordinare i tuoi Leads.",
  'cortex.forget': 'Dimentica',
  'cortex.hero': 'Questo ha imparato Leadscraper dalle tue {n} valutazioni.',
  'cortex.heroEmpty':
    'Ancora vuoto. Leadscraper inizierà ad apprendere non appena valuterai i primi Leads.',
  'cortex.heroEmptySub':
    'Memory è la memoria del tuo profilo: cosa preferisci, cosa rifiuti e dove il sistema è ancora incerto.',
  'cortex.heroSub':
    'Ogni affermazione puoi confermarla, correggerla o farla dimenticare. Le modifiche si applicano dalla prossima esecuzione di ordinamento.',
  'cortex.learned': 'Quello che Leadscraper ha imparato',
  'cortex.matchRate': 'Tasso di corrispondenza',
  'cortex.medium': 'medio',
  'cortex.mediumNote': 'sotto osservazione',
  'cortex.patterns': 'Pattern appresi',
  'cortex.patternsPending': 'Da confermare',
  'cortex.perWeek': 'alla settimana',
  'cortex.plain': 'In parole semplici, come lo leggeresti tu.',
  'cortex.roi.avgOrder': 'Ø Volume ordine',
  'cortex.roi.disclaimer':
    'Valore calcolato: basato sul tuo tasso di corrispondenza attuale. Man mano che Leadscraper matura, i numeri diventeranno più realistici.',
  'cortex.roi.expectedFits': 'Leads compatibili attesi',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.newCustomers': 'Nuovi clienti',
  'cortex.roi.revenue': 'Fatturato previsto',
  'cortex.roi.revenueSub': 'con lo stato attuale',
  'cortex.roi.sub': 'Quanto potrebbe valere il tuo stato attuale.',
  'cortex.roi.title': 'Stima ROI',
  'cortex.roi.viaRate': 'Ø Tasso di corrispondenza',
  'cortex.roi.winLabel': 'Tasso di successo',
  'cortex.roi.winRate': 'Tasso di successo',
  'cortex.runs.col.action': 'Azione',
  'cortex.runs.col.date': 'Data',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Tasso di corrispondenza',
  'cortex.runs.col.params': 'Parametri di ricerca',
  'cortex.runs.count': 'Esecuzioni',
  'cortex.runs.repeat': 'Ripeti',
  'cortex.runs.sub': 'Tutte le query che hai avviato per questo target.',
  'cortex.runs.title': 'Ricerche',
  'cortex.sinceStart': "dall'inizio",
  'cortex.step': 'Passo',
  'cortex.step1': 'Apri Leads',
  'cortex.step1d': 'Guarda le prime schede nella tua lista.',
  'cortex.step2': 'Adatto / Non adatto',
  'cortex.step2d': 'Valuta ogni Lead. Se rifiuti, fornisci brevemente un motivo.',
  'cortex.step3': 'Leggi qui',
  'cortex.step3d': 'Dopo ~20 feedback qui appariranno le prime valutazioni chiare.',
  'cortex.strong': 'forte',
  'cortex.strongNote': 'pattern affidabili',
  'cortex.tierMedium': 'Medio',
  'cortex.tierStrong': 'Forte',
  'cortex.tierWeak': 'Debole',
  'cortex.title': 'Memory',
  'cortex.uncertain': 'Leadscraper è incerto qui',
  'cortex.weak': 'debole',
  'cortex.weakNote': 'Leadscraper è incerto qui',

  'crm.bald': 'PRESTO',
  'crm.comingSoon': 'Disponibile presto',
  'crm.customAgent': 'Agente personalizzato',
  'crm.history.duplicate': 'Già nel CRM',
  'crm.history.empty': 'Nessun push ancora. Usa "Invia a CRM" su un Lead per iniziare.',
  'crm.history.failed': 'Fallito',
  'crm.history.loading': 'Caricamento…',
  'crm.picker.title': 'A quale CRM?',
  'crm.picker.subtitle':
    'Scegli dove deve atterrare questo lead, puoi cambiare in qualsiasi momento.',
  'crm.history.sent': 'Inviato',
  'crm.history.sub': 'Gli ultimi 50 Leads inviati al tuo CRM, i più recenti prima.',
  'crm.history.title': 'Cronologia Push',
  'crm.mcpComingSoon': 'Disponibile non appena il server MCP sarà online.',
  'crm.mcpSub':
    'Connetti Leadscraper direttamente a Claude, ChatGPT, Cursor o al tuo agente tramite Model Context Protocol. I tuoi Leads, profili e Memory saranno disponibili nativamente come strumenti.',
  'crm.mcpTitle': 'Leadscraper come server MCP',
  'crm.preview.bulkBody':
    'Crea {n} voci di organizzazione (e persone per i Leads con dati di contatto). I duplicati già presenti nel tuo CRM verranno saltati: le tue voci esistenti rimarranno intatte.',
  'crm.preview.bulkSub': '{n} Leads verranno inviati al tuo CRM',
  'crm.preview.dedupNote':
    'Se questo Lead è già nel tuo CRM (confronto per dominio), il push verrà registrato ma non verrà creata una nuova voce, mantieni quello che hai.',
  'crm.preview.noContact': 'Solo Org',
  'crm.preview.plusMore': '+ {n} altri…',
  'crm.preview.pushBtn': 'Invia ora',
  'crm.preview.pushNBtn': 'Invia {n} ora',
  'crm.preview.pushing': 'Invio in corso…',
  'crm.preview.singleSub': 'Questo verrà creato nel tuo CRM',
  'crm.preview.skipPerson': '· saltato (nessuna email o telefono per questo Lead)',
  'crm.preview.title': 'Anteprima: Push a {crm}',
  'crm.preview.willCreate': 'Verrà creato',
  'crm.preview.willCreatePerson': '· contatto primario con email/telefono',
  'crm.preview.withContact': 'Org + Persona',
  'crm.section.available': 'Disponibile',
  'crm.section.comingNext': 'Prossimamente',
  'crm.section.comingNextLabel': 'Presto',
  'crm.section.connected': 'Connesso',
  'crm.section.morePlanned': 'Ulteriori integrazioni in programma',
  'crm.tooltipComingSoon':
    "L'integrazione {name} arriva presto, verrai notificato non appena sarà disponibile.",

  'dash.actNow': 'Apri',
  'dash.action': 'Azione',
  'dash.activeRuns.run': 'Ricerca',
  'dash.activeRuns.runs': 'Ricerche',
  'dash.activeRuns.title': 'Leadscraper sta lavorando per te',
  'dash.avgOrder': 'Ø Volume ordine',
  'dash.cadence.daily': 'giornaliero',
  'dash.cadence.hourly': 'ogni ora',
  'dash.cadence.manual': 'manuale',
  'dash.cadence.monthly': 'mensile',
  'dash.cadence.weekly': 'settimanale',
  'dash.close': 'Chiudi',
  'dash.col.lastRun': 'Ultima esecuzione',
  'dash.col.leads': 'Leads',
  'dash.col.matchrate': 'Tasso di corrispondenza',
  'dash.col.profile': 'Target',
  'dash.col.profileH': 'Target',
  'dash.col.query': 'Gruppo target',
  'dash.col.queryName': 'Query',
  'dash.col.statusH': 'Stato',
  'dash.col.trained': 'Addestrato',
  'dash.col.whenH': 'Quando',
  'dash.company.analyzeBtn': 'Analizza',
  'dash.company.analyzeFresh': '✨ Addestra Leadscraper',
  'dash.company.analyzing': 'Leadscraper sta leggendo…',
  'dash.company.cachedToast': 'Profilo caricato dalla memoria.',
  'dash.company.collapsed':
    'Leadscraper conosce la tua azienda: tutte le giustificazioni sono personalizzate per te.',
  'dash.company.doneToast': '✓ Leadscraper ora ti conosce.',
  'dash.company.editBody':
    'Inserisci il sito della tua azienda. Leadscraper lo legge e memorizza permanentemente cosa offri, a chi vendi, e quali argomenti usi, così ogni giustificazione sui tuoi Leads diventa una strategia di pitch su misura invece di solo "va bene per il settore".',
  'dash.company.editTitle': 'Perché Leadscraper affini i tuoi pitch: dicci cosa vendi',
  'dash.company.emptyBody':
    'Inserisci il sito della tua azienda e Leadscraper capirà in 10 secondi cosa vendi. Da quel momento ogni giustificazione Lead spiegherà concretamente perché la TUA offerta si adatta a QUESTO Lead, invece di solo "va bene per il settore". Questo è il momento eureka.',
  'dash.company.emptyTitle': 'Leadscraper non ti conosce ancora',
  'dash.company.errorFallback': 'Analisi fallita: riprova.',
  'dash.company.setupBadge': 'Setup necessario',
  'dash.company.stage1': 'Caricamento del tuo sito web…',
  'dash.company.stage2': 'Comprensione di cosa offri…',
  'dash.company.stage3': 'Identificazione del tuo target…',
  'dash.company.stage4': 'Collegamento di tutto con il tuo valore…',
  'dash.company.stage5': 'Quasi fatto…',
  'dash.company.urlHint':
    "Inserisci il tuo sito web: appena l'URL è pronto, puoi addestrare Leadscraper.",
  'dash.company.urlPlaceholder': 'https://mia-azienda.it',
  'dash.cortex.reanalyze': 'Rianalizza: Leadscraper esaminerà la pagina da capo',
  'dash.cortex.reanalyzeKeepTitle': 'Mantenere le modifiche manuali?',
  'dash.cortex.reanalyzeKeepBody':
    "Hai modificato manualmente questo profilo aziendale. La nuova analisi può mantenere le tue modifiche e aggiornare solo il resto, oppure reimpostare tutto con i nuovi suggerimenti dell'IA.",
  'dash.cortex.reanalyzeKeepCta': 'Mantieni le mie modifiche',
  'dash.cortex.reanalyzeResetCta': "Reimposta ai suggerimenti dell'IA",
  'dash.cortex.sells': 'Cosa vendi',
  'dash.cortex.title': 'Cosa sa Leadscraper della tua azienda',
  'dash.cortex.toWhom': 'A chi',
  'dash.cortex.valueProps': 'Proposte di valore',
  'dash.date': 'Data',
  'dash.done': 'Completato',
  'dash.empty.defineAudience': '+ Definisci ora il target',
  'dash.empty.noFiltered': 'Nessuna query in questo filtro.',
  'dash.empty.noProfile': 'Nessun target creato finora.',
  'dash.empty.noQueryStartedAll': 'Nessuna query di lead avviata su tutti i target finora.',
  'dash.empty.noQueryStartedForProfile': 'Nessuna query per Leads ancora avviata per "{profile}".',
  'dash.empty.showAll': 'Mostra tutto ({n})',
  'dash.empty.startHint':
    'Clicca "Avvia ricerca" per definire una query (tipo di azienda, regione, ruolo, …).',
  'dash.filter.all': 'Tutti',
  'dash.filter.oneshot': 'Una tantum',
  'dash.filter.running': 'In esecuzione',
  'dash.filter.scheduled': 'Programmati',
  'dash.fmtNext.inDays': 'tra {n}g',
  'dash.fmtNext.inH': 'tra {n}h',
  'dash.fmtNext.inMin': 'tra {n}m',
  'dash.fmtNext.soon': 'inizia a breve',
  'dash.fmtNext.tomorrow': 'domani',
  'dash.funnel.deepened': 'Approfonditi',
  'dash.funnel.evaluated': 'Valutati',
  'dash.funnel.identified': 'Identificati',
  'dash.funnel.ready': 'Pronti',
  'dash.inProgress': 'In elaborazione',
  'dash.inbox.edge': 'Caso limite',
  'dash.inbox.edges': 'Casi limite',
  'dash.inbox.hint': 'Suggerimento',
  'dash.inbox.leadsFrom': '{leads} Leads da {profiles} {profileWord}',
  'dash.inbox.less': 'Mostra meno',
  'dash.inbox.more': '+ {n} altri',
  'dash.inbox.profileWord': 'target',
  'dash.inbox.profilesWord': 'target',
  'dash.inbox.showAll': 'Mostra tutti {n}',
  'dash.inbox.title': 'Da fare oggi',
  'dash.lastQueries.subAll':
    'Le tue ricerche più recenti su tutti i profili. Clicca per aprire i dettagli e ripetere la ricerca.',
  'dash.lastQueries.subForProfile':
    'Le tue ricerche più recenti per "{profile}". Clicca per aprire i dettagli e ripetere la ricerca.',
  'dash.lastQueries.title': 'Ultime query per Leads',
  'dash.lastSearch': 'Ultima ricerca: {result}',
  'dash.lastSearch.error': 'Errore',
  'dash.lastSearch.zero': '0 leads',
  'dash.lastYear': 'Anno scorso',
  'dash.leads': 'Leads',
  'dash.leadsGen': 'Leads generati',
  'dash.leadsGenerated': 'Leads generati',
  'dash.learning.body':
    'Con ogni ✓ "va bene" o ✗ "non va bene" {scope} Leadscraper affina la sua comprensione del tuo Lead ideale, e filtra di conseguenza i prossimi risultati.',
  'dash.learning.cta': 'Valuta {n} Leads',
  'dash.learning.hint': 'Avvia una ricerca sopra. Appena ci sono i Leads, potrai valutarli.',
  'dash.learning.scopeAll': 'nei tuoi target',
  'dash.learning.scopeProfile': 'per "{name}"',
  'dash.learning.title': 'Leadscraper aspetta il tuo primo feedback',
  'dash.maturity.label': 'Livello di maturità: {label}',
  'dash.maturity.next.many': 'Ancora {n} feedback per {stage}.',
  'dash.maturity.next.one': 'Ancora {n} feedback per {stage}.',
  'dash.maturity.stage.calibrated': 'Calibrato',
  'dash.maturity.stage.early': 'Apprendimento',
  'dash.maturity.stage.mature': 'Maturo',
  'dash.maturity.usage':
    'Leadscraper utilizza il tuo feedback con intensità diversa a seconda del livello di maturità nella prossima ricerca.',
  'dash.months': 'Mag,Giu,Lug,Ago,Set,Ott,Nov,Dic,Gen,Feb,Mar,Apr',
  'dash.newBadge': 'nuovo',
  'dash.newCust': 'Nuovi clienti',
  'dash.newCustomers': 'Nuovi clienti',
  'dash.newProfile': 'Nuovo target',
  'dash.nextRun.autoPaused': 'Auto-sospeso · 3 ricerche vuote',
  'dash.nextRun.in': 'Prossima ricerca tra {time}',
  'dash.nextRun.manual': 'Manuale · nessuna pianificazione',
  'dash.nextRun.paused': 'Sospeso',
  'dash.nextRun.pausedCredits': 'Sospeso · Credits esauriti',
  'dash.nextRun.soon': 'A breve',
  'dash.nextUp': 'Prossimo',
  'dash.onlyFavorites': 'Solo preferiti',
  'dash.openLeads': 'Apri Leads →',
  'dash.openProfile': 'Apri Leads',
  'dash.profileDrop.create': 'Crea il primo target',
  'dash.profileDrop.createSub': 'Definisci il target, poi si parte',
  'dash.profiles': 'attivi',
  'dash.progress': 'Progresso',
  'dash.projRevenue': 'Fatturato previsto',
  'dash.projectedRevenue': 'Fatturato previsto',
  'dash.query.businessType': 'Tipo di azienda',
  'dash.query.contact': 'Persona di contatto',
  'dash.query.dashExplain':
    '"—" significa: Leadscraper non ha tracciato il valore (disponibile con la V1.13 come traccia completa dell\'esecuzione).',
  'dash.query.deepAnalysis': 'Analisi approfondita',
  'dash.query.deepAnalysisHint': 'Sito web + note legali analizzati',
  'dash.query.delivered': 'Consegnati',
  'dash.query.deliveredHint': 'Risultati effettivi',
  'dash.query.evaluated': 'Valutati',
  'dash.query.evaluatedHint': 'Applicato il ragionamento di Leadscraper',
  'dash.query.extras': 'Criteri aggiuntivi',
  'dash.query.failedTitle': 'Esecuzione ricerca fallita',
  'dash.query.header': 'Ricerca Leads',
  'dash.query.howWorked': 'Come ha lavorato Leadscraper',
  'dash.query.identified': 'Identificati',
  'dash.query.identifiedHint': 'Aziende trovate da ricerca web + directory',
  'dash.query.leadsSoFar': '{n} Leads finora · ancora in esecuzione',
  'dash.query.loading': 'caricamento…',
  'dash.query.noLeads': 'Nessun Lead trovato',
  'dash.query.profile': 'Target: {name}',
  'dash.query.region': 'Regione / Sede',
  'dash.query.rerun': 'Esegui di nuovo',
  'dash.query.rerunTitle':
    'Rilancia questa query in Leadscraper (es. dopo aggiornamenti del target)',
  'dash.query.restart': 'Riavvia',
  'dash.query.runHistory': 'Cronologia delle ultime esecuzioni',
  'dash.query.runningNoLeads': 'Ancora in esecuzione: i Leads arriveranno presto',
  'dash.query.showLeads': 'Mostra {n} Leads',
  'dash.query.rerunRow': 'Ripeti',
  'dash.query.rerunCta': 'Ripeti ricerca',
  'dash.query.searchedLabel': 'Cosa hai cercato',
  'dash.query.autoRepeat': 'Ripeti automaticamente',
  'dash.query.openSettings': 'Apri impostazioni',
  'dash.query.startedAt': 'Avviata: {date}',
  'dash.query.suggestions': 'Suggerimenti di Leadscraper',
  'dash.query.technicalDetails': 'Dettagli tecnici',
  'dash.query.unfeasibleTitle': 'Leadscraper ritiene la ricerca non realizzabile',
  'dash.query.unnamed': 'Ricerca senza nome',
  'dash.query.whenRuns': 'Quando viene eseguita questa ricerca?',
  'dash.queryHint': 'Suggerimento per la ricerca',
  'dash.queryId': 'Query ID',
  'dash.renameQuery': 'Rinomina query',
  'dash.roi': 'Calcolatore ROI',
  'dash.roiShort': 'ROI',
  'dash.run.audience': 'Target:',
  'dash.run.businessType': 'Tipo di azienda',
  'dash.run.businessTypeP': 'es. produttore scatole pieghevoli con punzonatrice propria',
  'dash.run.cancel': 'Annulla',
  'dash.run.contact': 'Persona di contatto',
  'dash.run.contactP': 'es. direzione generale, responsabile acquisti',
  'dash.run.extras': 'Criteri aggiuntivi',
  'dash.run.extrasP':
    'es. no gruppi, preferibilmente a gestione familiare, certificazione FSC preferita, 50–250 dipendenti',
  'dash.run.forWhich': 'Per quale target?',
  'dash.run.minField': 'Inserisci almeno il tipo di azienda',
  'dash.run.notBackendProfile':
    'Questo target non è ancora registrato nel backend. Creane uno reale tramite',
  'dash.run.notBackendProfileCta': '+ Nuovo target',
  'dash.run.notBackendProfileEnd': ', poi lo scraper sarà operativo.',
  'dash.run.optional': '(opzionale)',
  'dash.run.pastQueries': 'Ultime ricerche Leads',
  'dash.run.pastQueriesHint': 'Clicca per riprendere i valori',
  'dash.run.region': 'Regione / Sede',
  'dash.run.regionHint':
    'Città, regione, area geografica o "nazionale": scrivi come cercheresti normalmente.',
  'dash.run.regionP': 'es. Milano, Lombardia, area metropolitana Roma, o nazionale',
  'dash.run.searchBtn': 'Cerca 10 Leads',
  // LEA-338 Part A / LEA-355 — auto-enrich contact-persons toggle (added in LEA-355).
  'dash.run.withContact.label': 'Arricchisci la persona di contatto in automatico',
  'dash.run.withContact.hint':
    "Ogni nuovo lead viene subito arricchito con le persone di contatto più adatte e i relativi dati. In alternativa puoi prima esaminare i lead e arricchirli singolarmente, consigliabile soprattutto all'inizio.",
  'dash.run.withContact.cost':
    'Fino a {n} crediti: addebitati solo in caso di arricchimento riuscito.',
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Costo: {n} lead = {n} crediti (1 per lead consegnato).',
  'dash.run.cost.extras': 'Contatti e insight: +1 credito/lead ciascuno, solo su richiesta.',
  'lt.next.connectCostHint': 'Solo 1 credito con un contatto raggiungibile, altrimenti gratis.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint': 'Gratis — paghi solo quando sblocchi un referente.',
  // LEA-356 — cascading Phase-3 acquisition-plan toggle.
  'dash.run.withPlan.label': 'Crea piano di acquisizione in automatico',
  'dash.run.withPlan.hint':
    'Per ogni lead arricchito viene creato un piano di acquisizione su misura: un approccio di contatto concreto basato sulle persone di contatto trovate.',
  'dash.run.withPlan.cost':
    'Fino a {n} crediti: addebitati solo se il piano viene generato con successo.',
  'dash.run.sub': '10 Credits · 10 Leads · tipicamente 5–12 min',
  'dash.run.title': 'Avvia ricerca Leads',
  'dash.sched.change': 'modifica',
  'dash.sched.daily': 'Giornaliero',
  'dash.sched.dailySub': '10 leads freschi ogni giorno',
  'dash.sched.manual': 'Manuale',
  'dash.sched.manualSub': 'Nessuna pianificazione: solo su clic',
  'dash.sched.pause': '⏸ Sospendi',
  'dash.sched.resume': '▶ Riprendi',
  'dash.sched.sub': 'Leadscraper raccoglie regolarmente 10 nuovi lead per questo target.',
  'dash.sched.time': 'Pianifica query',
  'dash.sched.title': 'Pianifica query',
  'dash.sched.toast.error': 'Impossibile salvare la pianificazione: {err}',
  'dash.sched.toast.manual': 'Pianificazione rimossa: il target si esegue solo manualmente.',
  'dash.sched.toast.paused': 'Target in pausa: nessuna esecuzione automatica.',
  'dash.sched.toast.set':
    'Pianificazione impostata: Leadscraper funziona automaticamente ({cadence}).',
  'dash.sched.twiceWeekly': 'Lun / Gio',
  'dash.sched.twiceWeeklySub': '2× a settimana, ~20 leads/settimana',
  'dash.sched.weekly': 'Settimanale',
  'dash.sched.weeklySub': '10 leads una volta a settimana',
  'dash.schedInd.nextRun': 'prossima ricerca',
  'dash.schedInfo.everyNh': 'ogni {n} h',
  'dash.schedInfo.hourly': 'ogni ora',
  'dash.schedInfo.oneshot': 'singolo',
  'dash.schedInfo.paused': 'sospeso',
  'dash.simulation': 'Simulazione',
  'dash.startRun': 'Avvia ricerca',
  'dash.startRunDisabledHint': 'Crea prima un target, poi avvia una ricerca',
  'dash.status': 'Stato',
  'dash.status.delivered.many': '{n} Leads consegnati',
  'dash.status.delivered.one': '{n} Lead consegnato',
  'dash.status.deliveredSuffix.many': 'Leads consegnati',
  'dash.status.deliveredSuffix.one': 'Lead consegnato',
  'dash.status.done': 'Completato',
  'dash.status.empty': 'Nessun risultato',
  'dash.status.failed': 'Fallito',
  'dash.status.running': 'In esecuzione',
  'dash.status.runningEllipsis': 'In esecuzione…',
  'dash.status.runningPrefix': 'In esecuzione · ',
  'dash.status.unfeasible': 'Non fattibile',
  'dash.step.delivery': 'Compilazione Leads',
  'dash.step.discovery': 'Identificazione aziende',
  'dash.step.done': 'Completato',
  'dash.step.fallbackProfile': 'Target',
  'dash.step.hydration': 'Analisi approfondita aziende',
  'dash.step.planning': 'Leadscraper ricorda',
  'dash.step.reasoning': 'Leadscraper valuta',
  'dash.step.starting': 'Avvio in corso…',
  'dash.timeline': 'Evoluzione delle metriche nel tempo',
  'dash.totalLeads': 'Totale Leads',
  'dash.whenCell.next': 'prossimo {label}',
  'dash.winRate': 'Tasso di conversione',
  'dash.yourLeads': 'I tuoi Leads',
  'dash.yourProfiles': 'I tuoi target',
  'dash.yourProfilesSub':
    'Tutti i target che stai allenando. Un clic apre i lead di questo target.',

  'det.accepted': 'Accettato',
  'det.back': 'Torna ai risultati di ricerca',
  'det.city': 'Sede',
  'det.companyProfile': 'Profilo aziendale',
  'det.contact': 'Contatto',
  'det.contactsEmpty':
    'Nessun punto di contatto estratto ancora. Leadscraper cerca nelle informazioni legali + LinkedIn.',
  'det.crmSoonTitle':
    "L'integrazione CRM arriva presto, verrai notificato non appena HubSpot, Pipedrive & Co. saranno collegati.",
  'det.decider': 'Decisore',
  'det.delivers': 'Fornisce:',
  'det.draftMail': 'Prepara bozza email',
  'det.draftMailSoonToast': 'Le bozze email dal Lead non sono ancora disponibili, presto.',
  'det.fetched': 'recuperato',
  'det.fits': 'Compatibile',
  'det.fitsNot': 'Non compatibile',
  'det.founded': 'Fondazione',
  'det.markedFit': '✓ Segnato come compatibile',
  'det.rejectAnyway': '↩ Non adatto dopo tutto?',
  'det.markedNotFit': '× Segnato come non compatibile',
  'det.memoryHint': 'Promemoria per la tua memoria',
  'det.memoryHintText':
    'Se accetti o rifiuti questo Lead, influenzerà Leads simili in "{profile}", ma non i tuoi altri profili.',
  'det.open': 'Apri',
  'det.patterns': 'Pattern appresi che si applicano qui',
  'det.publicOnly':
    'Tutte le fonti sono pubblicamente accessibili. Leadscraper non memorizza mai dati provenienti da directory non pubbliche o a pagamento.',
  'det.research.footer':
    "Leadscraper prova diversi percorsi di ricerca (LinkedIn, sito web aziendale, stampa, Xing) prima di ricorrere al fallback dell'amministratore delegato. Così è trasparente perché viene mostrato esattamente questo contatto.",
  'det.research.hit': '✓ Risultato',
  'det.research.label': 'Percorso di ricerca',
  'det.research.noHit': '○ nessun risultato',
  'det.research.resultMany': 'Risultati',
  'det.research.resultOne': 'Risultato',
  'det.research.summaryFallback':
    '{n} percorsi di ricerca tentati: nessun ruolo specifico trovato, amministratore delegato come fallback',
  'det.research.summaryFound': 'Contatto trovato al livello {stage}: {label}',
  'det.research.summaryNoHit': '{n} percorsi di ricerca senza risultati',
  'det.sector': 'Settore',
  'det.shortProfile': 'Profilo breve',
  'det.similar': 'Simile a Leads che hai accettato in precedenza',
  'det.size': 'Dipendenti',
  'det.sourcesCount': 'Fonti',
  'det.sourcesSub':
    'Ogni campo in questo Lead può essere ricondotto a una fonte pubblica specifica.',
  'det.sourcesTitle': 'Da dove provengono queste informazioni',
  'det.trail.searched': 'Cortex ha consultato {n} fonti pubbliche',
  'det.trail.website': 'Sito web',
  'det.trail.register': 'Registro imprese',
  'det.trail.google': 'Ricerca Google',
  'det.trail.press': 'Stampa',
  'det.trail.pages': '{n} pagine',
  'det.trail.profiles': '{n} profili',
  'det.capturedAt': 'rilevato',
  'det.derivedAt': 'dedotto',
  'det.sourcePage': 'Pagina di origine',
  'det.sourcesBelegtCount': '{n} con fonte',
  'det.sourcesTagline': 'Da dove viene ogni dato, aperto e verificabile.',
  'det.sourcesBelegt': '{n} su {total} con fonte',
  'det.sourcesFieldCount': '{n} campi',
  'det.lastChecked': 'ultima verifica',
  'det.sourcesUnsourced': 'Non ancora documentato',
  'det.sourcesHonesty':
    'I dati ufficiali e pubblici sono documentati direttamente; le stime IA sono chiaramente indicate come tali. Leadscraper non usa banche dati a pagamento.',
  'det.sourcesFlex':
    'Altri nascondono da dove vengono i loro dati. Noi mostriamo ogni fonte, verificabile.',
  'ld.tier.officialName': 'Fonte ufficiale',
  'ld.tier.officialSub': 'Registro ufficiale e dati obbligatori per legge',
  'ld.tier.publicName': 'Fonte pubblica',
  'ld.tier.publicSub': 'Consultabile pubblicamente sul web',
  'ld.tier.inferredName': 'Dedotto da Cortex',
  'ld.tier.inferredSub': 'Stima: verifica prima di inviare',
  'ld.tier.officialFallback': 'Fonte ufficiale',
  'ld.tier.publicFallback': 'Fonte pubblica',
  'ld.tier.inferredFallback': 'Dedotto da Cortex',
  'ld.tier.legendOfficial': 'ufficiale',
  'ld.tier.legendPublic': 'pubblico',
  'ld.tier.legendInferred': 'dedotto · verifica',
  'ld.tier.legendUnsourced': 'da documentare',
  'ld.srcLabel.dork': 'Ricerca web pubblica',
  'ld.srcLabel.icypeas_finder': 'E-mail dedotta',
  'ld.srcLabel.role_match': 'Corrispondenza ruolo',
  'ld.srcLabel.cortexNace': 'Analisi di settore Cortex',
  'ld.field.vatId': 'P. IVA',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'Paese',
  'ld.field.contactPhone': 'Telefono (referente)',
  'det.toCRM': 'Importa in CRM',
  'det.webExcerpts': 'Estratti sito web',
  'det.website': 'Sito web',
  'det.whyFits': 'Perché è adatto a te',
  'det.whyFitsSub': 'basato su quello che Leadscraper ha imparato su di te',

  'error.account_deleted': 'Questo account è stato eliminato.',
  'error.email_unverified':
    "Verifica prima il tuo indirizzo email (link nell'email di registrazione).",
  'error.demo_read_only': 'Questa azione è disattivata nella demo. Non è stato modificato nulla.',
  'error.impersonate_target_not_found':
    "Account di test non trovato: l'UID non esiste in questo ambiente DB (Mini / Staging / Production).",
  'error.invalidInput': 'Input non valido.',
  'error.noProfile': 'Nessun target selezionato.',
  'error.profileNotRegistered':
    'Target non ancora registrato nel backend. Apro la procedura guidata.',
  'error.unauthenticated': 'Non sei autenticato. Ricarica la pagina e accedi di nuovo.',

  'expired.body':
    'Il tuo accesso è in pausa. Riattiva il tuo abbonamento per tornare a cercare Leads e far girare i tuoi profili target.',
  'expired.readOnly':
    'Puoi ancora vedere ed esportare i tuoi Leads. Nuove ricerche e ricerche dei contatti richiedono un abbonamento attivo.',
  'expired.creditsKept': 'I tuoi {credits} Credits sono congelati, non eliminati.',
  'expired.cta': 'Riattiva abbonamento',
  'expired.ctaLoading': 'Caricamento…',
  'expired.title': 'Il tuo abbonamento è terminato',
  // LEA-704: welcome-back screen for expired accounts moved into the reveal model.
  'revealMigration.title': 'Bentornato',
  'revealMigration.subtitle': 'Leadscraper ora fattura per contatto',
  'revealMigration.free': 'La ricerca di aziende e contatti è gratuita',
  'revealMigration.payPerContact': 'Paghi solo quando sblocchi un referente',
  'revealMigration.units': 'Il tuo saldo resta: {n} contatti da sbloccare',
  'revealMigration.unitsOne': 'Il tuo saldo resta: 1 contatto da sbloccare',
  'revealMigration.unitsNone': 'Acquista contatti a pacchetti quando ti servono',
  'revealMigration.cta': 'Continua',
  'revealMigration.ctaLoading': 'Un momento…',
  'revealMigration.error': 'Non ha funzionato. Riprova.',

  'fb.blocked.headline': 'La query è troppo generica',
  'fb.blocked.subline':
    'Leadscraper troverebbe principalmente portali, associazioni o società di consulenza, non vere aziende individuali.',
  'fb.cta.adjust': 'Modifica query',
  'fb.cta.bypass': 'Avvia comunque',
  'fb.cta.bypassTitle': 'La query verrà elaborata da Leadscraper comunque, a tuo rischio',
  'fb.cta.sharpen': 'Torna indietro e affina',
  'fb.field.ansprechpartner': 'Persona di contatto',
  'fb.field.ort': 'Località',
  'fb.field.rawQuery': 'Testo libero',
  'fb.field.region': 'Regione',
  'fb.field.unternehmensart': 'Tipo di azienda',
  'fb.field.zusatz': 'Criteri aggiuntivi',
  'fb.fieldWarnings': 'Campi con avvisi',
  'fb.suggestions': 'Formulazioni più specifiche',
  'fb.suggestionsHint':
    'Copia uno dei suggerimenti nel campo o formula tu stesso: questo migliora notevolmente il tasso di corrispondenza.',
  'fb.warning.headline': 'Questa query è molto specifica',
  'fb.warning.subline':
    'Con questa combinazione di filtri Leadscraper potrebbe trovare pochi o nessun risultato. Puoi comunque avviare la ricerca o rendere la query meno restrittiva.',

  'find.amount': 'Numero di Leads',
  'find.amountHint': 'Il valore deve essere tra 1 e 1000',
  'find.businessType': 'Tipo di azienda',
  'find.businessTypeP': 'es. Ristorante, Avvocato, Commercialista',
  'find.contact': 'Referente',
  'find.contactP': 'es. Proprietario, Addetto alle vendite, Amministratore delegato',
  'find.creditNote': '(1 Lead = 1 Credit)',
  'find.extras': 'Limitazioni aggiuntive',
  'find.extrasP': 'Definisci il tuo gruppo target ancora più precisamente',
  'find.forProfile': 'Per quale target?',
  'find.forProfileHint': 'Le tue valutazioni allenano Leadscraper per questo target.',
  'find.location': 'Località',
  'find.locationP': 'es. Milano, Roma, Napoli',
  'find.start': 'Avvia Leadscraper',
  'find.title': 'Trova nuovi Leads',
  'find.trainsProfile': 'Addestra',

  'hero.eyebrow': 'Leadscraper ti conosce',
  'hero.stat.feedbacks': 'Feedback totali',
  'hero.stat.matchrate': '⌀ Tasso di corrispondenza',
  'hero.stat.profiles': 'target attivi',
  'hero.sub':
    'Ogni "Adatto / Non adatto" perfeziona quali Leads saranno in cima domani. Queste sono le tue metriche attuali.',
  'hero.title': 'Su tutti i target, Leadscraper diventa più preciso a ogni feedback.',

  'inbox.sched.body': 'Prossima esecuzione {rel}: nuovi Leads arriveranno automaticamente {where}.',
  'inbox.sched.cta': 'Visualizza',
  'inbox.sched.inCRM': 'nel CRM',
  'inbox.sched.inList': 'nella tua lista',
  'inbox.sched.title': '{n} ricerche programmate attive',

  'ld.aggregatorWarn':
    "Il sito web aziendale proprio è ancora in fase di determinazione. Nel frattempo mostriamo l'URL di origine (directory/stampa) da cui proviene questa azienda.",
  'ld.comingSoon': '· in arrivo',
  'ld.company': 'Azienda',
  'ld.companySite': 'Sito Aziendale',
  'ld.contactPhoneUnknown': 'Numero diretto non pubblico',
  'ld.contacts': 'Contatti',
  'ld.decisionMaker': '· Decision Maker',
  'ld.email.apply': 'Applica pattern',
  'ld.email.confGuessed': 'stimata',
  'ld.email.confLikely': 'probabile',
  'ld.email.confPlausible': 'plausibile',
  'ld.email.copied': 'Email stimata copiata negli appunti.',
  'ld.email.derivedFrom':
    'Derivata da {n} email{s} sul sito aziendale. {conf}: verifica prima di inviare.',
  'ld.email.noDirectExplain':
    "Non abbiamo trovato l'email diretta di {first} {last}. Abbiamo però identificato il pattern email dell'azienda: cliccando ti mostreremo l'indirizzo probabile. La responsabilità è tua.",
  'ld.email.notFound': 'Nessuna email diretta trovata per questo contatto.',
  'ld.emailLabel': 'E-Mail',
  'ld.emailPattern': 'Pattern Email',
  'ld.emailPattern.confHigh': 'alta',
  'ld.emailPattern.confLow': 'bassa',
  'ld.emailPattern.confMid': 'media',
  'ld.emailPattern.hint':
    'Tutti i contatti di questa azienda probabilmente seguono questo pattern.',
  'ld.emailPattern.noPattern': 'Le email trovate ({n}) non seguono un pattern chiaro.',
  'ld.emailPattern.noSamples': 'Nessuna email di dipendenti trovata sul sito web.',
  'ld.emailPattern.notFound': 'Nessun pattern trovato',
  'ld.emailPattern.notRecognized': 'non riconosciuto',
  'ld.emailPattern.sourceMany': 'Fonti',
  'ld.emailPattern.sourceOne': 'Fonte',
  'ld.fetchedThisWeek': 'questa settimana',
  'ld.field.acquisitionHook': 'Hook di Acquisizione Leadscraper',
  'ld.field.centralEmail': 'Email centrale',
  'ld.field.centralPhone': 'Telefono centrale',
  'ld.field.certs': 'Certificati',
  'ld.field.city': 'Città',
  'ld.field.companyName': 'Nome azienda',
  'ld.field.customerRefs': 'Referenze Clienti',
  'ld.field.description': 'Profilo breve',
  'ld.field.email': 'Email (Decision Maker)',
  'ld.field.employees': 'Numero dipendenti',
  'ld.field.firstName': 'Nome (decisore)',
  'ld.field.foundedYear': 'Anno di fondazione',
  'ld.field.hrNumber': 'Numero registro commerciale',
  'ld.field.jobSnapshot': 'Posizioni Aperte',
  'ld.field.lastName': 'Cognome (Decision Maker)',
  'ld.field.legalForm': 'Forma legale',
  'ld.field.linkedin': 'LinkedIn (Decision Maker)',
  'ld.field.locations': 'Sedi',
  'ld.field.nace': 'Settore NACE',
  'ld.field.ownership': 'Proprietari / Storia',
  'ld.field.revenueRange': 'Range fatturato',
  'ld.field.role': 'Ruolo (Decision Maker)',
  'ld.field.sizeClass': 'Classe dimensionale',
  'ld.field.street': 'Via',
  'ld.field.triggerEvent': 'Evento Trigger',
  'ld.field.website': 'URL sito web',
  'ld.field.xing': 'XING (Decision Maker)',
  'ld.field.deciderProfile': 'Profilo del referente',
  'ld.field.zip': 'CAP',
  'ld.linkedinPublic': 'LinkedIn · pubblico',
  'ld.match.borderline': 'caso limite',
  'ld.match.excellent': 'eccellente',
  'ld.match.solid': 'match solido',
  'ld.match.strong': 'match forte',
  'ld.sparkle.certs': 'Certificati & Premi',
  'ld.sparkle.customers': 'Referenze Clienti',
  'ld.sparkle.hookFake':
    'Puoi fare leva qui perché {company} mostra un profilo aziendale classico con bisogni concreti: si adatta direttamente alla tua offerta.',
  'ld.sparkle.hookLabel': 'Hook di Acquisizione Leadscraper',
  'ld.sparkle.hookUnlockLink': 'il tuo sito web aziendale',
  'ld.sparkle.hookUnlockPost': ', Leadscraper genererà poi un hook personalizzato per ogni Lead.',
  'ld.sparkle.hookUnlockPre': 'Inserisci nel dashboard sopra ',
  'ld.sparkle.jobs': 'Snapshot Posizioni',
  'ld.sparkle.jobsBadge': '{n} posizioni aperte',
  'ld.sparkle.locations': 'Sedi',
  'ld.sparkle.locked': '· bloccato',
  'ld.sparkle.ownerSince': 'dal {year}',
  'ld.sparkle.ownership': 'Struttura Proprietaria',
  'ld.sparkle.staleAction':
    'Riavvia la query nel dashboard: genereremo per QUESTO Lead un hook di acquisizione personalizzato più tutti i segnali di vendita (eventi trigger, posizioni aperte, clienti, …).',
  'ld.sparkle.staleMsg':
    'Questo Lead è stato generato prima che il tuo profilo aziendale fosse registrato su Leadscraper.',
  'ld.sparkle.sub': '· Segnali di Vendita da Analisi Web Live',
  'ld.sparkle.title': 'Leadscraper Magic',
  'ld.sparkle.trigger': 'Evento Trigger',
  'ld.sparkle.waitLabel': '· in attesa di Re-Run',
  'ld.specialization': 'Specializzazione',
  'ld.srcDesc.firecrawl': 'Homepage del sito aziendale (cached).',
  'ld.srcDesc.footer': 'Footer del sito: sedi, certificazioni, canali di contatto alternativi.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper ha estratto campi strutturati dal contenuto del sito web processato (descrizione, clienti, eventi trigger).',
  'ld.srcDesc.handelsregister':
    'Registro ufficiale delle imprese tedesche: numero HRB, sede, data di registrazione.',
  'ld.srcDesc.impressum':
    'Pagina informazioni obbligatorie con nome azienda, forma legale, indirizzo, management. Viene recuperata e analizzata.',
  'ld.srcDesc.json_ld': 'Metadati Schema.org leggibili automaticamente del sito web (profilo org).',
  'ld.srcDesc.karriere':
    'Pagina carriere: posizioni aperte, profili ricercati (segnale di crescita).',
  'ld.srcDesc.kontakt':
    'Pagina contatti/sedi: numeri di telefono, indirizzi email, eventuali referenti.',
  'ld.srcDesc.llm_haiku':
    'Leadscraper ha estratto campi strutturati dal contenuto del sito web processato (descrizione, clienti, eventi trigger).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper ha valutato il lead rispetto al tuo target + memoria.',
  'ld.srcDesc.news': 'Pagina stampa/news: eventi recenti, espansioni, premi.',
  'ld.srcDesc.regex_derived':
    'Derivato da altri dati: es. pattern email da email aziendale nota + nome.',
  'ld.srcDesc.serp': 'Risultati Google per ricerca mirata di dominio o persona.',
  'ld.srcDesc.team': 'Pagina team/dipendenti: persone e ruoli.',
  'ld.srcDesc.ueber_uns': 'Descrizione aziendale: storia, proprietari, valori, referenze clienti.',
  'ld.srcDesc.user_feedback':
    'Hai confermato o scartato manualmente questo Lead: massimo livello di fiducia.',
  'ld.srcLabel.firecrawl': 'Sito aziendale (homepage)',
  'ld.srcLabel.footer': 'Footer del sito',
  'ld.srcLabel.haiku_extracted': 'Estrazione AI',
  'ld.srcLabel.handelsregister': 'Registro commerciale',
  'ld.srcLabel.impressum': 'Note legali',
  'ld.srcLabel.json_ld': 'Dati strutturati (Schema.org)',
  'ld.srcLabel.karriere': 'Pagina carriere',
  'ld.srcLabel.kontakt': 'Pagina contatti',
  'ld.srcLabel.llm_haiku': 'Estrazione AI',
  'ld.srcLabel.llm_sonnet': 'Valutazione AI',
  'ld.srcLabel.news': 'Stampa / News',
  'ld.srcLabel.regex_derived': 'Derivazione pattern',
  'ld.srcLabel.serp': 'Ricerca Google',
  'ld.srcLabel.team': 'Pagina team',
  'ld.srcLabel.ueber_uns': 'Pagina chi siamo',
  'ld.srcLabel.user_feedback': 'Il tuo feedback',
  'ld.toast.accepted': '„{company}" salvata come Adatta.',
  'ld.toast.feedbackErr': 'Feedback non salvato: riprova.',
  'ld.toast.rejected': '„{company}" marcata come Non Adatta.',
  'ld.trust.inferred': '🔵 Derivato AI',
  'ld.trust.inferredTitle': "Derivato dall'AI di Leadscraper: non fonte ufficiale.",
  'ld.trust.official': '🛡 Ufficiale',
  'ld.trust.officialTitle': 'Fonte legalmente autorevole (Registro imprese/Imprint).',
  'ld.trust.public': '🟡 Pubblico',
  'ld.trust.publicTitle': 'Pubblicamente visibile sul sito web aziendale.',
  'ld.uncertainty': 'Leadscraper è qui {score}: {text}.',
  'ld.unverified.body':
    'Match settoriale generico: la specializzazione non è stata menzionata nel contenuto del sito web. Se strettamente necessario, precisa la query (es. „negozio specializzato in {token}").',
  'ld.unverified.title': '„{token}" non verificabile da Leadscraper su questa azienda',
  'ld.viaCentralPhone': 'Tramite centralino',
  'ld.websiteExcerpt': 'Estratto Sito Web',
  'ld.xingPublic': 'XING · pubblico',

  'leads.act.cancel': 'Annulla',
  'leads.act.details': 'Dettagli',
  'leads.act.fits': 'È adatto',
  'leads.act.fitsDone': 'Salvato come adatto',
  'leads.act.fitsNot': 'Non è adatto',
  'leads.act.fitsNotDone': 'Salvato come non adatto',
  'leads.act.reason': 'Scegli motivo',
  'leads.allProfiles': 'Tutti i target',
  'leads.allProfilesHeader': 'Tutti i target',
  'leads.allProfilesShow': 'Mostra tutti i target',
  'leads.backToActive': '← torna al target attivo',
  'leads.cardView': 'Schede',
  'leads.chip.edge': 'Caso limite · Valutazione?',
  'leads.chip.pattern': 'Crea un pattern',
  'leads.col.actions': 'Azioni',
  'leads.col.centralEmail': 'E-mail',
  'leads.col.centralPhone': 'Telefono',
  'leads.col.city': 'Sede',
  'leads.col.company': 'Azienda',
  'leads.col.crm': 'CRM',
  'leads.col.decider': 'Decision maker',
  'leads.col.founded': 'Fondazione',
  'leads.col.lastActivity': 'Ultima attività',
  'leads.col.legalForm': 'Forma giuridica',
  'leads.col.match': 'Match',
  'leads.col.nace': 'Settore',
  'leads.col.phase': 'Fase',
  'leads.col.phone': 'Telefono',
  'leads.col.profile': 'Target',
  'leads.col.revenue': 'Fatturato',
  'leads.col.sector': 'Sotto-settore',
  'leads.col.size': 'Dipendenti',
  'leads.col.status': 'Stato',
  'leads.col.website': 'Sito web',
  'leads.cols.btn': 'Colonne',
  'leads.cols.fixed': 'Fisso',
  'leads.cols.reset': 'Reset',
  'leads.cols.sub': 'Visualizza solo quello che ti serve.',
  'leads.cols.title': 'Mostra colonne',
  'leads.count': '{shown} di {total} leads',
  'leads.crm.push': 'Invia',
  'leads.crm.notSynced': 'Non sincronizzato',
  'leads.crm.syncedTo': 'Sincronizzato con {crm}',
  'leads.crm.pushFailed': 'Invio non riuscito',
  'leads.crossOverview.many': '{n} lead · tutti i target',
  'leads.crossOverview.one': '{n} lead · tutti i target',
  'leads.daysAgo': '{n} giorni fa',
  'leads.empty':
    'Nessun lead per questo profilo: avvia una nuova ricerca tramite "Trova nuovi leads".',
  'leads.exp.memoryRefs': 'Dalla tua memoria',
  'leads.exp.uncertain': 'Leadscraper è {score} qui: {note}.',
  'leads.exp.whyShown': 'Perché Leadscraper ti mostra questo lead',
  'leads.export': 'Export',
  'leads.filter.all': 'Tutti',
  'leads.filter.fits': 'Adatti',
  'leads.filter.fitsNot': 'Non adatti',
  'leads.filter.unrated': 'Non valutati',
  'leads.filterBy': 'Filtra per target',
  'leads.footerHint':
    'Clicca su una riga per vedere l\'insight breve. Il pulsante "Dettagli" apre la vista a 360°.',
  'leads.searchP': 'Azienda, settore, sede, decision maker …',
  'leads.status.accepted': 'È adatto',
  'leads.status.rejected': 'Non è adatto',
  'leads.status.unseen': 'Non visto',
  'leads.sub':
    "{n} Leads · raggruppati per i tuoi profili. Un clic apre la vista a 360° dell'azienda.",
  'leads.tableView': 'Tabella',
  'leads.title': 'I tuoi Leads',
  'leads.toast.accepted': '"{c}" salvato come adatto. Leadscraper impara da questo.',
  'leads.toast.export': 'Funzione export in arrivo.',
  'leads.toast.rejected':
    '"{c}" rifiutato · Motivo: {r}. Leadscraper impara per le prossime ricerche.',

  'lp.card.examplesHint': '(ID Lead dalla tua cronologia valutazioni per questo cluster)',
  'lp.card.hideExamples': 'Nascondi esempi',
  'lp.card.showExamplesMany': 'Mostra {n} Leads di esempio',
  'lp.card.showExamplesOne': 'Mostra {n} Lead di esempio',
  'lp.cl.age': 'Età azienda',
  'lp.cl.age.mock': 'Aziende consolidate fondate prima del 2010 preferite',
  'lp.cl.bizModel': 'Modello di business',
  'lp.cl.bizModel.mock': 'Fornitori operativi, no agenzie o intermediari',
  'lp.cl.buyingSignals': 'Segnali di acquisto',
  'lp.cl.buyingSignals.mock': 'Cercati eventi trigger attivi (crescita, assunzioni)',
  'lp.cl.domainBlock': 'Blocco domini',
  'lp.cl.domainBlock.mock': 'Domini concorrenti vengono costantemente esclusi',
  'lp.cl.geo': 'Posizione',
  'lp.cl.geo.mock': 'NRW + BaWü fortemente preferiti, Germania orientale meno',
  'lp.cl.industry': 'Settore',
  'lp.cl.industry.mock': "Preferisce settore servizi (M-N) rispetto all'industria",
  'lp.cl.ownership': 'Proprietà',
  'lp.cl.ownership.mock': 'Aziende familiari >> Controllate PE e gruppi',
  'lp.cl.role': 'Contatto',
  'lp.cl.role.mock': 'Livello amministratore delegato atteso, responsabile reparto troppo junior',
  'lp.cl.size': 'Dimensioni azienda',
  'lp.cl.size.mock': 'Tendenza verso operatori più piccoli (10-50 dipendenti)',
  'lp.cl.techStack': 'Stack tecnologico',
  'lp.cl.techStack.mock': 'Certe tecnologie vengono costantemente cercate/evitate',
  'lp.cta.count': 'Valuta {n} Leads',
  'lp.cta.open': 'Apri Leads',
  'lp.cta.rate': 'Valuta Leads',
  'lp.error.load': 'Errore nel caricamento',
  'lp.evidence.many': '{n} evidenze',
  'lp.evidence.one': '{n} evidenza',
  'lp.journey.active': 'Personalizzazione attiva',
  'lp.journey.matchRate': 'Tasso di corrispondenza',
  'lp.journey.matched': 'erano adatti',
  'lp.journey.notMatched': 'non erano adatti',
  'lp.journey.preview': 'Primo addestramento',
  'lp.journey.title': '{n} valutazioni · {accepted} adatti · {rejected} non adatti',
  'lp.loading': 'Caricamento stato apprendimento…',
  'lp.locked.pill': 'da {n} valutazioni',
  'lp.ps.bizModel.analyse':
    'Leadscraper ha il filtro standard attivo: agenzie, distributori e marketplace vengono automaticamente deprioritizzati nel reasoning quando non corrispondono alla richiesta.',
  'lp.ps.bizModel.content': 'Fornitori operativi (non meri intermediari)',
  'lp.ps.bodyDefault':
    'Queste carte mostrano quello che Leadscraper ha **analizzato** concretamente dal tuo profilo + i Leads confermati. Valuta più specificatamente con motivazione così i cluster si affineranno.',
  'lp.ps.bodyHigh':
    'Con solo {rejected} {rejectWord} Leadscraper non può formare cluster di esclusione forti: queste carte mostrano quello che Leadscraper ha **analizzato** concretamente dal tuo profilo + i {accepted} Leads confermati. Non appena rifiuti più specificatamente, i cluster matureranno in filtri forti.',
  'lp.ps.footerBody':
    'A partire da **50 valutazioni** Leadscraper considera in ogni nuova ricerca non solo il tuo input e quello che la tua azienda vende, ma anche il tuo **profilo appreso come tendenza**: settore, classe dimensionale, ubicazione, ruolo, struttura proprietaria. Non come filtro rigido, ma come peso aggiuntivo nel reasoning. Questo significa che una nuova query per "commercialista Amburgo" non cerca genericamente tutti gli studi commerciali, ma preferisce automaticamente studi commerciali di medie dimensioni gestiti dai proprietari, analogamente al profilo che hai costruito qui.',
  'lp.ps.footerTitle': 'Come questo influisce sulle tue prossime ricerche',
  'lp.ps.geo.analyseNo':
    'Leadscraper priorizza i risultati da questa regione e cura i risultati limitrofi quando la regione principale si assottiglia.',
  'lp.ps.geo.analyseYes':
    "Leadscraper ha confermato {n} aziende di questa regione come appropriate: l'ancoraggio geografico è preciso.",
  'lp.ps.geo.fallback': 'Area DACH',
  'lp.ps.industry.analyseNo':
    'Leadscraper cerca sistematicamente aziende che corrispondono alla tua descrizione del settore.',
  'lp.ps.industry.analyseYes':
    'Leadscraper conferma questo settore attraverso {n} Leads accettati: la delimitazione del settore è precisa.',
  'lp.ps.industry.anyBranche':
    'Il tuo profilo è aperto a tutti i settori: Cortex deriva la tendenza effettiva dalle tue valutazioni. Attualmente {n} leads accettati come riferimento. Più valutazioni ci sono, più precisa diventa la tendenza settoriale derivata.',
  'lp.ps.industry.fallback': 'Derivato dal tuo profilo-intent',
  'lp.ps.ownership.analyseHigh':
    'Leadscraper riconosce dai Leads confermati che il tuo focus è su aziende gestite dai proprietari: le filiali di gruppi vengono proposte più cautamente.',
  'lp.ps.ownership.analyseLow':
    'Valuta concretamente una filiale di gruppo con "non adatta" così Leadscraper può formare qui un cluster proprietario forte.',
  'lp.ps.ownership.contentHigh': 'Profilo proprietario/medio-aziendale confermato',
  'lp.ps.ownership.contentLow': 'Mix di strutture proprietarie e piccoli gruppi aziendali',
  'lp.ps.ownership.label': 'Struttura proprietaria',
  'lp.ps.rejectionMany': 'rifiuti',
  'lp.ps.rejectionOne': 'rifiuto',
  'lp.ps.role.analyseHigh':
    'Leadscraper scrive attivamente secondo questo ruolo nel reasoning: Impressum + pagine carriere + LinkedIn vengono filtrati specificamente per questo.',
  'lp.ps.role.analyseLow':
    "Leadscraper cerca nell'Impressum + sulle pagine carriere specificamente questi ruoli, ricade sui direttori generali solo quando il ruolo speciale non è pubblicizzato.",
  'lp.ps.role.fallback': 'Livello direttivo',
  'lp.ps.size.analyseHigh':
    'Con il {pct}% di match rate Leadscraper vede che la tua classe dimensionale desiderata viene centrata stabilmente: nessuna necessità di correzione rilevata.',
  'lp.ps.size.analyseLow':
    "Leadscraper adatta l'intervallo di dipendenti più finemente alla tua visione con ogni rifiuto.",
  'lp.ps.size.contentHigh': 'Leadscraper centra precisamente la classe dimensionale',
  'lp.ps.size.contentLow': 'Tendenza medio-aziendale dai Leads confermati',
  'lp.ps.titleDefault': 'Quello che Leadscraper comprende dalle tue valutazioni',
  'lp.ps.titleHigh': 'Leadscraper capisce il tuo target · {pct}% di successo',
  'lp.ps.understands': 'Leadscraper comprende',
  'lp.s0.body':
    'Con {preview} Leads valutati ti mostriamo la prima impressione. Con {active} Leadscraper cerca attivamente per TE, basandosi sui tuoi modelli specifici.',
  'lp.s0.eyebrow': 'Leadscraper impara con te',
  'lp.s0.headline': 'Leadscraper sta costruendo il tuo target',
  'lp.s0.openMany': '{n} Leads ancora non valutati: valutali per progredire più velocemente.',
  'lp.s0.openOne': '{n} Lead ancora non valutato: valutalo per progredire più velocemente.',
  'lp.s1.body':
    'Le prime tendenze sono visibili: con {n} valutazioni questo influirà attivamente sulle tue ricerche.',
  'lp.s1.eyebrow': 'Prima impressione',
  'lp.s1.headline': 'Leadscraper sta ancora raccogliendo evidenze',
  'lp.s1.morePatterns': 'Altri modelli: saranno visibili con {n} valutazioni',
  'lp.s1.strongestLabel': 'Tendenza più forte finora',
  'lp.s2.headline': 'Leadscraper cerca per TE',
  'lp.s2.ignoredMany':
    '{n} valutazioni erano "già conosciamo" o "dati sbagliati": queste non vengono incluse nell\'apprendimento intenzionalmente.',
  'lp.s2.ignoredOne':
    '{n} valutazione era "già conosciamo" o "dati sbagliati": questa non viene inclusa nell\'apprendimento intenzionalmente.',
  'lp.s2.pillActive': 'Personalizzato attivo',
  'lp.s2.pillSharp': 'Target ben definito',
  'lp.s2.pillUpdating': 'Aggiornamento in corso',
  'lp.s2.reanalysisAgo': 'Ultima ri-analisi: {n} valutazioni fa · Prossima a {next}',
  'lp.s2.reanalysisCurrent': 'Ri-analisi in corso · Prossima a {n}',
  'lp.s2.weakLabel': 'Tendenze deboli: diventeranno più forti con più dati',
  'lp.sq.activeSubS1':
    'Basato sulle tue prime {n} valutazioni: diventeranno più precise con ogni step di ri-analisi.',
  'lp.sq.activeSubS2': 'Aggiornato dopo {n} valutazioni · Rianalisi ogni {interval} valutazioni.',
  'lp.sq.activeTitle': 'Leadscraper propone queste ricerche',
  'lp.sq.badge.crossSell': 'Cross-Sell',
  'lp.sq.badge.expansion': 'Espansione',
  'lp.sq.badge.pattern': 'Pattern',
  'lp.sq.badge.salesFit': 'Sales-Fit',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.emptyBody':
    'Le proposte saranno calcolate con la tua prossima ri-analisi pattern (ogni {n} valutazioni).',
  'lp.sq.eyebrow': 'Query di ricerca ottimizzate',
  'lp.sq.launch': 'Avvia ricerca',
  'lp.sq.loading': 'Leadscraper sta calcolando proposte…',
  'lp.sq.lockedBody':
    'Non appena avrai valutato {n} Leads, Leadscraper proporrà 3–5 query di ricerca: strutturate come i tuoi input, con probabilità di match e breve motivazione.',
  'lp.sq.lockedTitle': 'Leadscraper sta preparando proposte concrete',
  'lp.sq.mockA.contact': 'Direzione',
  'lp.sq.mockA.rationale': 'Proposta di esempio di come Leadscraper suggerisce ricerche.',
  'lp.sq.mockA.region': 'Baviera',
  'lp.sq.mockA.type': 'Costruttori di macchine medio-aziendali',
  'lp.sq.mockB.rationale': 'Proposta di esempio di come Leadscraper suggerisce ricerche.',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.type': 'Pianificatori TGA settore ospedaliero',
  'lp.sq.tier.hypothesis': 'Ipotesi di test',
  'lp.sq.tier.solid': 'Solido',
  'lp.sq.tier.strong': 'Forte',
  'lp.sq.tier.veryStrong': 'Molto forte',
  'lp.tone.drop': 'FORTE SCARTO',
  'lp.tone.keep': 'FORTE MANTIENI',
  'lp.tone.softDrop': 'LEGGERO SCARTO',
  'lp.tone.softKeep': 'LEGGERO MANTIENI',

  'lt.badge.soft': 'possibile',
  'lt.dashHint1': 'Nel Dashboard trovi un suggerimento al riguardo (simbolo',
  'lt.dashHint2': 'accanto allo stato).',
  'lt.exp.btn': 'Export',
  'lt.exp.csvHint': '.csv (separato da virgole)',
  'lt.exp.fail': 'Export fallito: {err}',
  'lt.exp.ing': 'Esportazione in corso…',
  'lt.exp.noRows': "Nessun Lead trovato per l'export.",
  'lt.exp.success': '{n} righe esportate come {fmt}.',
  'lt.exp.tipNoLeads': 'Esportabili solo i lead con referenti o un piano completato',
  'lt.exp.tipReady': 'Esporta {n} Leads',
  'lt.exp.tipWrongFilter':
    'Solo i Leads adatti possono essere esportati. Passa al filtro "Adatto".',
  'lt.exp.toastNoLeads':
    'Sono esportabili solo i lead con referenti o un piano di acquisizione completato.',
  'lt.exp.unknownErr': 'Errore sconosciuto',
  'lt.expH.city': 'Sede',
  'lt.expH.company': 'Azienda',
  'lt.expH.companyEmail': 'Email aziendale',
  'lt.expH.companyPhone': 'Telefono aziendale',
  'lt.expH.contact': 'Contatto',
  'lt.expH.direct': 'diretto',
  'lt.expH.email': 'Email',
  'lt.expH.emailSource': 'Fonte email',
  'lt.expH.guessed': 'stimato ({n}%)',
  'lt.expH.profile': 'Target',
  'lt.expH.role': 'Ruolo',
  'lt.expH.sector': 'Settore',
  'lt.feedbackFail': 'Impossibile salvare il feedback: riprova.',
  'lt.naceF.A': 'Agricoltura, silvicoltura e pesca',
  'lt.payoff.avoided': 'Il dossier ora evita:',
  'lt.payoff.flowsIn': 'Confluisce nella prossima analisi.',
  'lt.naceF.B': 'Attività estrattive',
  'lt.naceF.C': 'Attività manifatturiere',
  'lt.naceF.D': 'Fornitura di energia elettrica, gas, vapore',
  'lt.naceF.E': 'Fornitura di acqua; reti fognarie, gestione rifiuti',
  'lt.naceF.F': 'Costruzioni',
  'lt.naceF.G': 'Commercio; riparazione di autoveicoli e motocicli',
  'lt.naceF.H': 'Trasporto e magazzinaggio',
  'lt.naceF.I': 'Attività dei servizi di alloggio e ristorazione',
  'lt.naceF.J': 'Servizi di informazione e comunicazione',
  'lt.naceF.K': 'Attività finanziarie e assicurative',
  'lt.naceF.L': 'Attività immobiliari',
  'lt.naceF.M': 'Attività professionali, scientifiche e tecniche',
  'lt.naceF.N': 'Noleggio, agenzie di viaggio, servizi di supporto',
  'lt.naceF.O': 'Pubblica amministrazione, difesa; sicurezza sociale',
  'lt.naceF.P': 'Istruzione',
  'lt.naceF.Q': 'Sanità e assistenza sociale',
  'lt.naceF.R': 'Arte, spettacolo e divertimento',
  'lt.naceF.S': 'Altre attività di servizi',
  'lt.naceF.T': 'Attività di famiglie e convivenze',
  'lt.naceF.U': 'Organizzazioni ed enti extraterritoriali',
  'lt.naceS.A': 'Agricolt./Forest.',
  'lt.naceS.B': 'Attiv. estrattive',
  'lt.naceS.C': 'Attiv. manifatt.',
  'lt.naceS.D': 'Energia',
  'lt.naceS.E': 'Acqua/Rifiuti',
  'lt.naceS.F': 'Costruzioni',
  'lt.naceS.G': 'Commercio',
  'lt.naceS.H': 'Trasporti/Magazz.',
  'lt.naceS.I': 'Alberghi/Ristor.',
  'lt.naceS.J': 'IT/Media',
  'lt.naceS.K': 'Finanz./Assicur.',
  'lt.naceS.L': 'Immobiliare',
  'lt.naceS.M': 'Prof. tecnico-sci.',
  'lt.naceS.N': 'Altri servizi',
  'lt.naceS.O': 'Pubbl. amminist.',
  'lt.naceS.P': 'Istruzione',
  'lt.naceS.Q': 'Sanità',
  'lt.naceS.R': 'Arte/Spettacolo',
  'lt.naceS.S': 'Altri servizi',
  'lt.naceS.T': 'Famiglie priv.',
  'lt.naceS.U': 'Extraterritoriale',
  'lt.next.title': 'Prossimi passi',
  'lt.next.verifyContacts': 'Verifica contatti',
  'lt.next.verifyingContacts': 'Verifica dei contatti …',
  'lt.next.contactsVerified': '{n} contatti verificati',
  'lt.next.contactVerified': 'Contatto verificato',
  'lt.next.openPlan': 'Apri piano',
  'lt.next.generatingPlan': 'Generazione del piano di acquisizione …',
  'lt.next.credit': '1 credito',
  'lt.next.retry': 'Riprova',
  'lt.next.verifyFirst': 'Verifica prima i contatti',
  'lt.next.failedHint': "L'ultimo tentativo non è riuscito: puoi riprovare.",
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSub': '{n} lead · tutte le query di questo target arrivano qui',
  'lt.profileSubOne': '1 lead · tutte le query di questo target arrivano qui',
  'lt.queryClear': 'Rimuovi filtro',
  'lt.queryLabel': 'Filtrato su Query:',
  'lt.resetToast': 'Valutazione per {c} ripristinata',
  'lt.ring.match': 'Match {pct}%',
  'lt.ring.rejected': 'Rifiutato: valutato come 0',
  'lt.rm.cancel': 'Annulla',
  'lt.rm.header': 'Scarta Lead',
  'lt.rm.noteOptional': 'Nota per Leadscraper (opzionale)',
  'lt.rm.noteRequired': 'Descrivere brevemente (obbligatorio)',
  'lt.rm.placeholderOpt':
    'Cosa ha trascurato o valutato male Leadscraper? (Più concreto è, meglio impara il sistema.)',
  'lt.rm.placeholderReq': 'Es. "Concorrente: vende soluzione simile"',
  'lt.rm.sub': 'Dicci perché: Leadscraper impara e fornisce risultati migliori la prossima volta.',
  'lt.rm.submit': 'Scarta Lead',
  'lt.rr.already_known': 'Già conosciuto',
  'lt.rr.already_known.hint': 'Già nel CRM o già contattato (nessun segnale di apprendimento)',
  'lt.rr.bad_data': 'Dati sbagliati',
  'lt.rr.bad_data.hint': 'Indirizzo, nome o info contatto non corretti',
  'lt.rr.no_buying_signal': 'Nessuna necessità riconoscibile',
  'lt.rr.no_buying_signal.hint': 'Nessun evento scatenante, posizioni aperte o segnale di crescita',
  'lt.rr.not_operator': 'Non è operatore',
  'lt.rr.not_operator.hint': 'Agenzia, intermediario o costruttore invece di fornitore operativo',
  'lt.rr.other': 'Altro motivo',
  'lt.rr.other.hint': 'Scrivi brevemente il perché (testo libero)',
  'lt.rr.wrong_industry': 'Settore sbagliato',
  'lt.rr.wrong_industry.hint': 'Leadscraper ha identificato male il settore di business',
  'lt.rr.wrong_ownership': 'Struttura proprietà sbagliata',
  'lt.rr.wrong_ownership.hint':
    'Filiale di gruppo invece di azienda familiare, forma giuridica sbagliata ecc.',
  'lt.rr.wrong_region': 'Posizione sbagliata',
  'lt.rr.wrong_region.hint': 'Sede/regione non adatta alla ricerca',
  'lt.rr.wrong_role': 'Contatto sbagliato',
  'lt.rr.wrong_role.hint': 'La persona o il ruolo non è il decisore',
  'lt.rr.wrong_size': 'Dimensione azienda sbagliata',
  'lt.rr.wrong_size.hint': 'Troppo piccola, troppo grande o gruppo invece di media impresa',
  'lt.tip.accepted': 'Accettato: clicca per annullare',
  'lt.tip.contacts': 'Mostra {n} contatti',
  'lt.tip.dragCol': 'Trascina larghezza colonna',
  'lt.tip.openCompany': 'Apri dettagli azienda',
  'lt.tip.openLead': 'Apri dettagli Lead',
  'lt.tip.rejected': 'Scartato: clicca per annullare',
  'lt.tip.softKeep': "Possibilmente rilevante: Leadscraper ha un'incertezza qui, vedi dettagli",
  'lt.tip.unseen': 'Ancora non visto',
  // AddCompanyManualModal — inserimento manuale tramite URL
  'lt.manual.modal.eyebrow': 'Pipeline · manuale',
  'lt.manual.modal.title': 'Aggiungi azienda',
  'lt.manual.modal.desc':
    "Leadscraper verifica il sito web ed estrae i dati di base dell'azienda. Il lead finisce poi in {phase}, da dove puoi ottenere contatti + un piano di acquisizione.",
  'lt.manual.modal.phase': '«Azienda aggiunta»',
  'lt.manual.modal.websiteLabel': 'Sito web',
  'lt.manual.modal.placeholder': 'es. heuerlogistics.de',
  'lt.manual.modal.hint':
    'Proveremo a raggiungere il sito web. In caso di errore non viene addebitato alcun credito.',
  'lt.manual.modal.cancel': 'Annulla',
  'lt.manual.modal.close': 'Chiudi',
  'lt.manual.modal.submit': 'Aggiungi',
  'lt.manual.modal.submitting': 'Aggiunta in corso …',
  'lt.manual.modal.creditOne': '{n} credito',
  'lt.manual.modal.creditMany': '{n} crediti',
  'lt.manual.modal.errEmpty': 'Inserisci un sito web.',
  'lt.manual.modal.errInvalid': 'Questo non sembra un sito web valido (es. heuerlogistics.de).',

  'mem.cancel': 'Annulla',
  'mem.editHint': 'Leadscraper userà questa affermazione dalla prossima analisi.',
  'mem.editKicker': 'Correggi ipotesi appresa',
  'mem.editTitle': 'Come dovrebbe apprendere Leadscraper?',
  'mem.param.contact': 'Contatto',
  'mem.param.extras': 'Extra',
  'mem.param.leads': 'Leads',
  'mem.param.location': 'Ubicazione',
  'mem.param.sector': 'Settore',
  'mem.profile': 'Profil',
  'mem.save': 'Salva ipotesi',
  'mem.screenLabel': 'Memory',
  'mem.screenLabelEmpty': 'Memory · vuoto',
  'mem.toast.confirmed': 'Ipotesi confermata.',
  'mem.toast.corrected': 'Correzione salvata.',
  'mem.toast.forgotten': 'Ipotesi dimenticata.',
  'mem.today': 'Oggi',

  'mob.abo': 'Piano & Credits',
  'mob.acct.aria': 'Il mio account',
  'mob.active': 'Attivo',
  'mob.back': '← Indietro',
  'mob.changePassword': 'Cambia password',
  'mob.changePlan': 'Cambia piano',
  'mob.detail.contacts': 'Contatti ({n})',
  'mob.detail.fits': '✓ Adatto',
  'mob.detail.label.email': 'Email',
  'mob.detail.label.phone': 'Telefono',
  'mob.detail.label.website': 'Sito web',
  'mob.detail.notFitting': '✗ Non adatto',
  'mob.detail.rejected': '✗ Rifiutato',
  'mob.detail.section.company': 'Azienda',
  'mob.fb.fits': '✓ Adatto',
  'mob.fb.rejected': '✗ Rifiutato',
  'mob.home.activeProfile': 'Target attivo',
  'mob.home.cta.newSearch': 'Avvia nuova ricerca',
  'mob.home.emptyHint': 'Avvia una nuova ricerca o cambia target.',
  'mob.home.newLeads': 'Nuovi Leads',
  'mob.home.stat.fits': 'Adatti',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.matchRate': 'Tasso di corrispondenza',
  'mob.home.viewAll': 'Vedi tutti →',
  'mob.leads.cta.newSearch': 'Avvia nuova ricerca',
  'mob.leads.filter.all': 'Tutti',
  'mob.leads.filter.fits': 'Adatti',
  'mob.leads.filter.open': 'Aperti',
  'mob.leads.filter.rejected': 'Rifiutati',
  'mob.leads.new': '＋ Nuovo',
  'mob.leads.title': 'Leads',
  'mob.logout': 'Disconnetti',
  'mob.logoutConfirm': 'Confermi la disconnessione?',
  'mob.more.help': 'Aiuto & Contatti',
  'mob.more.invoices': 'Fatture',
  'mob.more.label.email': 'Email',
  'mob.more.plan.monthly': 'Abbonamento mensile',
  'mob.more.plan.trial': 'Trial',
  'mob.more.section.account': 'Il mio account',
  'mob.more.section.help': 'Aiuto & App',
  'mob.more.title': 'Altro',
  'mob.more.toDesktop': 'Passa al desktop',
  'mob.more.toDesktop.value': 'Funzionalità complete',
  'mob.nav.account': 'Account',
  'mob.nav.home': 'Home',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Target',
  'mob.onDesktop': 'Su desktop',
  'mob.profile.active': 'Attivo',
  'mob.profile.leadsCount': '{n} Leads',
  'mob.profile.newCount': '{n} nuovi',
  'mob.profile.stat.match': 'Corrispondenza',
  'mob.profile.switchTo': 'Passa a',
  'mob.profile.title': 'Target',
  'mob.queryPlaceholder': 'es. Panetterie, Commercialisti, Negozi di scarpe',
  'mob.search.askWho': 'Chi stai cercando?',
  'mob.search.cancel': 'Annulla',
  'mob.search.profileLabel': 'Target: {name}',
  'mob.search.region': 'Regione (opzionale)',
  'mob.search.regionPlaceholder': 'es. Lombardia, Lazio, Veneto',
  'mob.search.start': 'Avvia ricerca',
  'mob.search.title': 'Nuova ricerca',
  'mob.toast.accepted': '✓ Marcato come adatto',
  'mob.toast.rejected': '✗ Rifiutato',
  'mob.toast.runStarted': 'Ricerca avviata · risultati in ~2 min',
  'mob.trialLeads': 'Leads di prova rimasti',
  'mob.upgrade': 'Upgrade a Pro',
  'mob.upgradeHint': 'Più Leads + Pianificazione',
  'mob.wizardHint':
    'Crea il tuo primo profilo da desktop: il wizard non è ancora disponibile su mobile.',

  'mobile.empty.noContactData': 'Dati di contatto non disponibili.',
  'mobile.empty.noOpenLeads': 'Nessun lead aperto.',
  'mobile.empty.noProfileSelected': 'Nessun target selezionato.',
  'mobile.empty.noProfileShort': 'Nessun target.',
  'mobile.empty.nothingFound': 'Nessun risultato.',
  'mobile.note.label': 'Nota:',
  'mobile.note.scheduleDesktop': 'Pianificazioni e memoria del target si modificano da desktop.',
  'mobile.tip.label': 'Suggerimento:',
  'mobile.tip.profilesDesktop': 'Crei più target (es. per settore o regione) da desktop.',

  'ms.aud.computingBody':
    'In pochi secondi Leadscraper descriverà qui il tuo target con le proprie parole.',
  'ms.aud.computingEyebrow': 'Leadscraper analizza le tue valutazioni',
  'ms.aud.computingTitle': 'Riconoscimento pattern in corso…',
  'ms.aud.derivedFrom': 'Derivato dalle tue {n} valutazioni',
  'ms.aud.eyebrowS1': 'Prima valutazione di Leadscraper',
  'ms.aud.eyebrowS2': 'Valutazione attuale di Leadscraper',
  'ms.aud.fallbackBody':
    'Non appena la rianalisi sarà completata (in pochi secondi), apparirà qui una descrizione concreta del tuo target.',
  'ms.aud.fallbackEyebrow': 'Prima valutazione di Leadscraper',
  'ms.aud.fallbackTitle':
    'Leadscraper sta aggiornando la valutazione con le tue ultime {n} valutazioni.',
  'ms.aud.learnedLabel': 'Appreso concretamente',
  'ms.aud.lockedEyebrow': 'Target nelle parole di Leadscraper',
  'ms.aud.lockedMock':
    'Cerchi piccoli operatori in NRW con assunzioni attive, contatti a livello GF, a conduzione familiare con chiara tendenza settoriale verso la meccanica.',
  'ms.aud.lockedPill': 'da {n} valutazioni',
  'ms.aud.nextReanalysis': ' · Prossima rianalisi a {n}',
  'ms.aud.recomputeEyebrow': 'Leadscraper aggiorna la sua valutazione',
  'ms.aud.recomputeTitle': 'La valutazione viene ricalcolata con le tue ultime valutazioni…',
  'ms.aud.trainS1':
    'Continua ad addestrare lo scraper e otterrai **risultati davvero potenti**: ogni valutazione rende Leadscraper più preciso.',
  'ms.aud.trainS2':
    'Continua ad addestrare Leadscraper: **ogni valutazione affina le ricerche** che ora vengono eseguite automaticamente per te.',
  'ms.card.label': 'Stato Leadscraper',
  'ms.card.ratings': '{n} / {threshold} valutazioni',
  'ms.card.s2active': '{n} valutazioni · attivo nel reasoning',
  'ms.card.s2reanalysis': '{n} valutazioni · in rianalisi',
  'ms.cv.age': 'Età azienda: {rule}',
  'ms.cv.bizModel': 'Modello di business: {rule}',
  'ms.cv.buyingSignals': 'Segnali di acquisto: {rule}',
  'ms.cv.domainBlock': 'Esclusione: {rule}',
  'ms.cv.geo': 'Regione: {rule}',
  'ms.cv.industry': 'Settore: {rule}',
  'ms.cv.ownership': 'Proprietà: {rule}',
  'ms.cv.role': 'Contatto: {rule}',
  'ms.cv.size': 'Dimensione: {rule}',
  'ms.cv.techStack': 'Tech Stack: {rule}',
  'ms.donut.match': 'adatto',
  'ms.donut.matchRate': 'Tasso di corrispondenza',
  'ms.donut.noMatch': 'non adatto',
  'ms.donut.ratings': 'Valutazioni',
  'ms.donut.title': 'Stato valutazioni',
  'ms.error': 'Errore',
  'ms.msg.s0': 'Impara con te · {n}/{threshold} per anteprima',
  'ms.msg.s1': 'Prima impressione · {n}/{threshold} per attivare',
  'ms.msg.s2active': 'Personalizzazione attiva · {n} valutazioni',
  'ms.msg.s2reanalysis': 'In fase di rianalisi · {n}',
  'ms.stage0.eyebrow': 'Impara con te',
  'ms.stage1.eyebrow': 'Prima impressione',
  'ms.stage2.eyebrow': 'Personalizzazione attiva',

  'nace.A': 'Agricoltura, silvicoltura e pesca',
  'nace.B': 'Estrazione di minerali da cave e miniere',
  'nace.C': 'Attività manifatturiere',
  'nace.D': 'Fornitura di energia elettrica, gas, vapore e aria condizionata',
  'nace.E': 'Fornitura di acqua; reti fognarie, attività di gestione dei rifiuti',
  'nace.F': 'Costruzioni',
  'nace.G': "Commercio all'ingrosso e al dettaglio; riparazione di autoveicoli e motocicli",
  'nace.H': 'Trasporto e magazzinaggio',
  'nace.I': 'Attività dei servizi di alloggio e di ristorazione',
  'nace.J': 'Servizi di informazione e comunicazione',
  'nace.K': 'Attività finanziarie e assicurative',
  'nace.L': 'Attività immobiliari',
  'nace.M': 'Attività professionali, scientifiche e tecniche',
  'nace.N': 'Noleggio, agenzie di viaggio, servizi di supporto alle imprese',
  'nace.O': 'Amministrazione pubblica e difesa; assicurazione sociale obbligatoria',
  'nace.P': 'Istruzione',
  'nace.Q': 'Sanità e assistenza sociale',
  'nace.R': 'Attività artistiche, sportive, di intrattenimento e divertimento',
  'nace.S': 'Altre attività di servizi',
  'nace.T': 'Attività di famiglie e convivenze',
  'nace.U': 'Organizzazioni ed organismi extraterritoriali',

  'naceShort.A': 'Agricoltura',
  'naceShort.B': 'Minerario',
  'naceShort.C': 'Manifatturiero',
  'naceShort.D': 'Energia',
  'naceShort.E': 'Acqua/Rifiuti',
  'naceShort.F': 'Costruzioni',
  'naceShort.G': 'Commercio',
  'naceShort.H': 'Trasporti',
  'naceShort.I': 'Ristorazione',
  'naceShort.J': 'IT/Media',
  'naceShort.K': 'Finanza/Assic.',
  'naceShort.L': 'Immobiliare',
  'naceShort.M': 'Professionale',
  'naceShort.N': 'Altri servizi',
  'naceShort.O': 'P.A.',
  'naceShort.P': 'Istruzione',
  'naceShort.Q': 'Sanità',
  'naceShort.R': 'Arte/Intratt.',
  'naceShort.S': 'Altri servizi',
  'naceShort.T': 'Famiglie',
  'naceShort.U': 'Extraterrit.',

  'nav.activeProfile': 'Target attivo',
  'nav.apiStatus.checking': 'Controllo stato API…',
  'nav.apiStatus.down': 'API non raggiungibile: ricarica la pagina',
  'nav.apiStatus.ok': 'API raggiungibile',
  'nav.apiStatus.slow': 'API risponde lentamente',
  'nav.buyLeads': 'Acquista Leads ora',
  'nav.cortex': 'Target',
  'nav.credits': 'Credits Disponibili',
  'nav.credits.available': 'Disponibili',
  'nav.credits.label': 'Saldo Account',
  'nav.credits.remaining': 'Rimanenti',
  'nav.credits.total': 'Totale',
  'nav.credits.upgrade': 'Upgrade',
  'nav.dashboard': 'Dashboard',
  'nav.deleteProfile': 'Elimina target',
  'nav.deleteProfileBody':
    'Tutti i lead, le valutazioni e i pattern appresi per «{name}» verranno eliminati definitivamente. Questa azione è irreversibile.',
  'nav.deleteProfileBusy': 'Eliminazione in corso…',
  'nav.deleteProfileCta': 'Elimina definitivamente',
  'nav.deleteProfileError': 'Impossibile eliminare il target. Riprova.',
  'nav.deleteProfileInFlight': 'È in corso una ricerca per questo target. Attendi che termini.',
  'nav.deleteProfileSuccess': 'Target eliminato.',
  'nav.deleteProfileTitle': 'Eliminare il target?',
  'nav.feedbacks': 'Feedback',
  'nav.leads': 'Leads',
  'nav.matchRate': 'Tasso di corrispondenza',
  'nav.rated': 'valutati',
  'nav.open': 'aperti',
  'nav.rateNudge.title': 'Vai ai Leads non ancora valutati',
  'nav.allRated': 'Tutti valutati',
  'nav.newProfile': 'Crea nuovo target',
  'nav.onboardingRequired': 'Completa prima i 3 passaggi di onboarding.',
  'nav.openSettings': 'Apri impostazioni e apprendimenti di "{name}"',
  'nav.profileName': 'Nome del target',
  'nav.profileNameP': 'es. Fornitori IT DACH',
  'nav.renameProfile': 'Rinomina target',
  'nav.renameProfileSub': 'Scegli un nuovo nome per questo target.',
  'nav.runs.footer': 'Clicca su un target per vedere lo stato. Puoi continuare a lavorare.',
  'nav.runs.leadsReady': '{n} Lead{s} pronti',
  'nav.runs.many': '{n} ricerche in corso',
  'nav.runs.one': '1 ricerca in corso',
  'nav.runs.title': 'Ricerche in corso',
  'nav.startSubscription': 'Avvia abbonamento',
  'nav.switchProfiles': 'Cambia target',

  'notif.act.edge': 'Vedi casi limite',
  'notif.act.pattern': 'Conferma in Leadscraper',
  'notif.act.review': 'Vai ai leads',
  'notif.dismiss': 'Nascondi',
  'notif.edge.body':
    '{n} leads incerti per {profile}: la tua valutazione migliora Leadscraper al massimo.',
  'notif.edge.title': 'I casi limite richiedono la tua valutazione',
  'notif.empty.sub': 'Leadscraper sta imparando.',
  'notif.empty.title': 'Tutto fluisce.',
  'notif.kind.edge': 'Caso limite',
  'notif.kind.pattern': 'Pattern',
  'notif.kind.review': 'Review',
  'notif.pattern.back': 'Indietro',
  'notif.pattern.badge': 'Pattern appreso',
  'notif.pattern.confirmedLabel': 'Pattern confermato.',
  'notif.pattern.needsConfirm': 'È corretto?',
  'notif.pattern.no': 'No, rifiuta',
  'notif.pattern.rejectedLabel': 'Pattern rifiutato.',
  'notif.pattern.saveAndClose': 'Salva',
  'notif.pattern.stage2': 'Salvato',
  'notif.pattern.title': 'Pattern riconosciuto',
  'notif.pattern.whyLabel': 'Perché? (opzionale)',
  'notif.pattern.whyPlaceholder':
    'Aiuta Leadscraper a imparare la sfumatura, ma non è obbligatorio.',
  'notif.pattern.yes': 'Sì, corretto',
  'notif.review.body': 'Hai ancora {n} leads non valutati.',
  'notif.review.cta': 'Rivedi ora',
  'notif.review.title': 'Valuta i nuovi leads',
  'notif.sub': 'Suggerimenti per rendere Leadscraper più preciso.',
  'notif.title': 'Notifiche',

  'np.abort': 'Annulla',
  'np.audience': 'Descrivi il target',
  'np.audienceHint':
    'Più concreto è, migliore sarà il primo sorting. Puoi sempre modificarlo successivamente.',
  'np.audienceHintLong':
    'Scrivilo come lo spiegheresti a un nuovo addetto alle vendite. Leadscraper lo usa come base per la valutazione, e impara da ogni feedback.',
  'np.audienceLabel': 'Descrizione target',
  'np.audienceP':
    'Esempio: Vogliamo conquistare studi fiscali di medie dimensioni con la nostra soluzione di recruiting. Obiettivo: un primo colloquio con la direzione.',
  'np.back': 'Indietro',
  'np.briefingHelp.q1': 'Qual è il tuo obiettivo con questo target?',
  'np.briefingHelp.q2': 'Cosa offri?',
  'np.briefingHelp.q3': 'Perché la tua offerta è rilevante per questo target?',
  'np.briefingHelp.q4': 'Qual è la tua USP più forte?',
  'np.briefingHelp.q5': 'Quali problemi risolvi?',
  'np.briefingHelp.q6': 'Chi vuoi contattare per primo?',
  'np.briefingHelp.q7': 'Quale canale funziona per te: email, telefono, LinkedIn?',
  'np.briefingHelp.q8':
    'Quale dovrebbe essere il prossimo passo: risposta, appuntamento, demo, offerta?',
  'np.briefingHelp.q9': "Cosa dovrebbe essere evitato nell'approccio?",
  'np.briefingHelpFooter':
    'Questi non sono campi obbligatori: solo orientamento per il testo libero.',
  'np.briefingHelpTitle': 'Utile per Leadscraper',
  'np.coldStart': 'Cold start · nessun parametro iniziale',
  'np.coldStartDesc':
    'Il profilo inizia completamente vuoto. Dopo ~20 feedback appaiono le prime indicazioni in Leadscraper.',
  'np.companySize': 'Dimensione azienda',
  'np.companySizeP': 'es. 50–250 dipendenti',
  'np.continue': 'Continua',
  'np.create': 'Crea target',
  'np.created': 'Target creato. Leadscraper è pronto.',
  'np.creating': 'Creazione in corso…',
  'np.header': 'Nuovo target',
  'np.headline': 'Definisci il target',
  'np.suggHeading': 'Suggerimenti per il tuo target',
  'np.suggHint':
    'Un clic applica il suggerimento, puoi alternare tra loro, scrivere il tuo testo o creare direttamente.',
  'np.draftWriting': 'Leadscraper sta scrivendo il tuo briefing …',
  'np.draftErrorLabel': 'Nota:',
  'np.draftErrorFallback':
    'Impossibile generare la bozza del briefing: puoi continuare a scrivere manualmente.',
  'np.industry': 'Settore',
  'np.industryP': 'es. Imballaggio, scatole pieghevoli',
  'np.name': 'Nome del target',
  'np.nameP': 'es. Produttori di scatole pieghevoli NRW',
  'np.notes': 'Note aggiuntive',
  'np.notesP': 'Esclusioni, tipi di clienti, parole chiave…',
  'np.nothingYet': '· niente di predefinito. Leadscraper sarà formato dal tuo feedback.',
  'np.optional': 'Opzionale',
  'np.region': 'Regione / Stato',
  'np.regionP': 'es. NRW, DACH, tutta la Germania',
  'np.skip': 'Salta',
  'np.step1Sub':
    'Dai al tuo profilo un nome chiaro. Leadscraper usa questa descrizione come punto di partenza, prima che il tuo feedback affini il modello.',
  'np.step1Title': 'Chi o cosa stai cercando?',
  'np.step2Sub':
    'Opzionale: Leadscraper usa queste indicazioni come base. Il profilo impara quando valuti i Leads.',
  'np.step2Title': 'Parametri iniziali',
  'np.stepOf': 'Passaggio {n} di 2',
  'np.summaryTitle': 'Leadscraper inizia con',
  'np.title': 'Crea nuovo target',
  'np.whatHappens': 'Cosa succede dopo?',
  'np.whatHappensBody':
    'Nella dashboard avvii una <b>ricerca</b> e definisci settore, regione e dimensione. Leadscraper trova aziende e referenti adatti e crea da questo briefing un piano di acquisizione per ogni Lead.',

  'offer.beta.pricing.intro': 'Invito Beta · Sconto del 55% sul primo mese',

  'og.beta.cardCta': 'Attiva pacchetto Beta',
  'og.beta.cardFeature.1': '500 Leads / mese con funzionalità Growth',
  'og.beta.cardFeature.2': 'Attivazione immediata · senza prova',
  'og.beta.cardFeature.3': 'Cancellabile in qualsiasi momento con 1 clic',
  'og.beta.cardFoot': 'Carta richiesta · pagamento sicuro tramite Stripe',
  'og.beta.cardName': 'Il tuo pacchetto Beta',
  'og.beta.feature.1.bold': '500 Leads',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.tail': ' al mese · e-mail e numeri di telefono verificati',
  'og.beta.feature.2': 'Targeting AI in linguaggio naturale',
  'og.beta.feature.3': 'Integrazioni CRM + esportazione CSV/Excel',
  'og.beta.feature.4': "Conforme GDPR · Dati nell'UE",
  'og.beta.feature.5.bold': 'WhatsApp a Janik',
  'og.beta.feature.5.lead': 'Accesso diretto ',
  'og.beta.feature.5.tail': ' per domande',
  'og.beta.narrativeBody':
    'Cerchiamo {profis} che usino il nostro sistema fin da subito, diano feedback onesto e contribuiscano a decidere come si sviluppa Leadscraper. In cambio paghi {price} per il tuo primo mese del pacchetto Growth, invece dei normali 490 € — poi si applica il prezzo normale, disdici quando vuoi.',
  'og.beta.narrativePrice': 'solo 220 €',
  'og.beta.narrativeProfis': '30 professionisti di vendita attivi',
  'og.beta.narrativeTitle': 'Perché questa offerta?',
  'og.beta.priceNowSuffix': '/ primo mese',
  'og.beta.priceFootnote': 'poi {n} €/mese · disdici quando vuoi',
  'og.beta.priceOld': '{n} € / mese normale',
  'og.beta.savings': 'Risparmi {n} € nel primo mese',
  'og.cancelAny': 'Cancellabile in qualsiasi momento',
  'og.cta': 'Prova gratis 3 giorni · {plan}',
  'og.ctaBeta': 'Ottieni accesso Beta · {price} € / mese',
  'og.ctaPlain': 'Continua con {plan}',
  'og.ctaSub':
    'Nessun pagamento nei primi 3 giorni · Dopo {price},00 € / mese · {leads} Leads di prova inclusi',
  'og.ctaSubPlain': '{price},00 € / mese · attivazione immediata',
  'og.dsgvo': 'Conforme GDPR · Server DE',
  'og.eyebrow.beta': 'Invito Beta personale',
  'og.eyebrow.trial50': '50 Credits in regalo',
  'og.hlBanner.trial50.body':
    'Dopo la selezione del piano ricevi immediatamente {credits} sul tuo account. Utilizzali nei prossimi 3 giorni: se non cancelli, passi automaticamente al piano scelto.',
  'og.hlBanner.trial50.credits': '{n} Credits',
  'og.hlBanner.trial50.title': 'Come funziona la tua prova:',
  'og.later': 'Decidere più tardi →',
  'og.leadsIncl': '{n} Leads al mese inclusi',
  'og.maiOffer.cta': 'Offerta maggio: 100 Leads B2B per 49 € ora',
  'og.maiOffer.detail': 'Perfetto per iniziare, senza vincoli.',
  'og.maiOffer.feature.1': 'Email e numeri di telefono verificati',
  'og.maiOffer.feature.2': 'Targeting AI in linguaggio naturale',
  'og.maiOffer.feature.3': 'Integrazioni CRM + Export CSV/Excel',
  'og.maiOffer.feature.4': "Conforme GDPR · Dati nell'UE",
  'og.maiOffer.feature.5': 'Dal 2° mese: 190 €/mese · cancellabile con 1 clic',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'Leads / mese',
  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.price': '49 €',
  'og.maiOffer.priceNote': '0,49 € invece di 1,90 € per Lead · solo questo mese.',
  'og.maiOffer.priceOriginal': 'Invece di 190 € / mese',
  'og.maiOffer.priceSuffix': '/ mese',
  'og.moneyBack': 'Rimborso garantito 14 giorni',
  'og.perMonth': '€ / mese',
  'og.plan': 'Piano',
  'og.planBadge.recommended': 'Consigliato',
  'og.planCta.loading': 'Vai al pagamento …',
  'og.planCta.pick.basic': 'Scegli Basic',
  'og.planCta.pick.growth': 'Scegli Growth',
  'og.planCta.pick.starter': 'Scegli Starter',
  'og.planCta.trial.basic': 'Prova gratis per 3 giorni',
  'og.planCta.trial.growth': 'Prova gratis per 3 giorni',
  'og.planCta.trial.starter': 'Prova gratis per 3 giorni',
  'og.planDetail.basic': 'Per piccoli team di vendita che seguono in modo mirato.',
  'og.planDetail.growth': "Per team che vogliono scalare l'outbound.",
  'og.planDetail.starter': 'Miglior rapporto qualità-prezzo per team attivi.',
  'og.planFeature.basic.1': 'E-mail e numeri di telefono verificati',
  'og.planFeature.basic.2': 'Targeting AI in linguaggio naturale',
  'og.planFeature.basic.3': 'Integrazioni CRM + Export CSV/Excel',
  'og.planFeature.basic.4': "Conforme GDPR · Dati nell'UE",
  'og.planFeature.growth.1': 'Tutto da Starter',
  'og.planFeature.growth.2': '5× più Leads al mese',
  'og.planFeature.growth.3': 'Call di onboarding personalizzato',
  'og.planFeature.growth.4': 'Supporto premium diretto con Janik',
  'og.planFeature.starter.1': 'Tutto da Basic',
  'og.planFeature.starter.2': '2,5× più Leads al mese',
  'og.planFeature.starter.3': 'Coda Leads prioritaria',
  'og.planFeature.starter.4': 'Supporto e-mail < 4 h',
  'og.planLeadsUnit': 'Leads / mese',
  'og.planPriceNote.basic.default': 'Corrisponde a 1,90 € per Lead',
  'og.planPriceNote.basic.trial': 'Poi {price}\u00A0€/mese · 100 Credits inclusi',
  'og.planPriceNote.growth.default': 'Corrisponde a 0,98 € per Lead · Risparmia il 48%',
  'og.planPriceNote.growth.trial':
    'Poi {price}\u00A0€/mese · 500 Credits inclusi · Risparmia il 48%',
  'og.planPriceNote.starter.default': 'Corrisponde a 1,16 € per Lead · Risparmia il 39%',
  'og.planPriceNote.starter.trial':
    'Poi {price}\u00A0€/mese · 250 Credits inclusi · Risparmia il 39%',
  'og.planPriceSuffix.default': '/ mese',
  'og.planPriceSuffix.trial': '/ mese dopo Trial',
  'og.planPriceSuffix.trialToday': 'oggi',
  'og.ready': 'Il tuo account è pronto',
  'og.recommended': 'Consigliato',
  'og.split.badge.start': 'Perfetto per iniziare',
  'og.split.rating.note': '· Feedback utenti eccellente',
  'og.split.rating.score': '4.8 / 5.0',
  'og.split.trust.cancel': 'Disdetta con 1 clic',
  'og.split.trust.gdpr': 'Conforme GDPR',
  'og.step.activateBeta': 'Attiva pacchetto Beta',
  'og.step.created': 'Account creato',
  'og.step.pickPlan': 'Scegli piano',
  'og.step.start': 'Inizia',
  'og.step.startTrial': 'Prova gratis 3 giorni',
  'og.sub1': 'Scegli il tuo piano per testare Leadscraper',
  'og.sub1b': 'gratis per 3 giorni',
  'og.sub2':
    'Nessun pagamento ora: puoi cancellare in qualsiasi momento durante il periodo di prova.',
  'og.subtitle.beta':
    'Come tester Beta ottieni il nostro pacchetto più potente (500 Leads al mese) a un prezzo speciale: il tuo primo mese costa 220 € invece di 490 €. Nessuna durata minima, disdici quando vuoi.',
  'og.subtitle.default':
    'Tre piani, stessa qualità dei dati. Scegli quanti Leads ti servono al mese, puoi cambiare e cancellare in qualsiasi momento con un clic.',
  'og.subtitle.mai':
    'Risparmia il 74% nel primo mese, poi cambia o disdici con 1 clic quando vuoi.',
  'og.subtitle.trial50': '50 Leads in regalo: prova 3 giorni, disdici quando vuoi.',
  'og.title.beta.grad': 'selezionato personalmente',
  'og.title.beta.lead': 'Sei stato ',
  'og.title.beta.tail': ' per la Beta.',
  'og.title.default.grad': 'inizia in 60 secondi',
  'og.title.default.lead': 'Scegli il tuo piano e ',
  'og.title.default.tail': '.',
  'og.title.mai.grad': 'vantaggio competitivo sleale',
  'og.title.mai.lead': 'Il tuo ',
  'og.title.mai.tail': ' inizia qui.',
  'og.title.trial50.grad': 'ora in regalo',
  'og.title.trial50.lead': '50 Leads B2B del valore di 100 €, ',
  'og.title.trial50.tail': '.',
  'og.trial': 'Prova gratis 3 giorni',
  'og.trial50v2.cta': 'Assicurati 50 Credits gratis',
  'og.trial50v2.detail': 'Credits sufficienti per testare completamente Leadscraper.',
  'og.trial50v2.feature.1': 'E-mail e numeri telefono verificati',
  'og.trial50v2.feature.2': 'Targeting AI in linguaggio naturale',
  'og.trial50v2.feature.3': 'Integrazioni CRM + Export CSV/Excel',
  'og.trial50v2.feature.4': "Conforme GDPR · Dati nell'UE",
  'og.trial50v2.feature.5': 'Continua dopo 3 giorni · disdetta con 1 clic',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'Leads in 3 giorni',
  'og.trial50v2.planName': 'Trial',
  'og.trial50v2.price': 'Gratis',
  'og.trial50v2.priceNote': 'Termina dopo 3 giorni o continua · disdetta con 1 clic.',
  'og.trialIncl': 'incl.',
  'og.trialLeadsN': '{n} Leads di prova',
  'og.trust.beta.lock.body': 'nessun costo nascosto',
  'og.trust.beta.lock.title': 'Prezzo speciale Beta nel primo mese',
  'og.trust.cancel.body.default': 'Nessuna durata minima',
  'og.trust.cancel.body.trial': 'Gratuito durante il Trial',
  'og.trust.cancel.title.default': 'Disdetta con 1 clic',
  'og.trust.card.body.default': 'Pagamento sicuro tramite Stripe',
  'og.trust.card.body.trial': 'Addebito solo dopo 3 giorni',
  'og.trust.card.title.default': 'Carta richiesta',
  'og.trust.card.title.trial': "Carta per l'attivazione",
  'og.trust.gdpr.body': "Server nell'UE · solo fonti pubbliche",
  'og.trust.gdpr.title': 'Conforme GDPR',
  'og.welcome': 'Benvenuto, Janik.',

  'onb.step1Done': "Leadscraper ora conosce la tua offerta: vedi l'analisi qui sotto",

  'onb.heroTitle': 'Il tuo vantaggio competitivo inizia qui',

  'onb.heroDesc':
    'In 3 passi ai tuoi primi 10 Lead. Leadscraper ti conosce davvero e ti fornisce finalmente Lead che fanno al caso tuo.',

  'onb.helpCardTitle': 'Nuovo su Leadscraper?',
  'onb.helpCardDesc':
    "La nostra guida rapida ti porta in pochi minuti dall'account e dall'e-mail al tuo primo pubblico target.",
  'onb.helpCardCta': 'Leggi i primi passi',
  'onb.helpCardDismissAria': 'Nascondi avviso',

  'onb.stepLabel': 'Passo {n}',

  'onb.b2cLead': 'Leadscraper trova solo aziende: nessun cliente privato.',

  'onb.b2cBody':
    "L'analisi del tuo sito indica che vendi a consumatori finali. I suggerimenti qui sotto puntano quindi a moltiplicatori B2B (es. costruttori, amministratori immobiliari) anziché ai privati direttamente. Se non hai un livello B2B adatto, Leadscraper probabilmente non è lo strumento giusto per la tua attività.",

  'onb.step2LabelDone': 'Primo target pronto: Leadscraper lo ha salvato',

  'onb.step2LabelPending':
    'Definisci il tuo primo gruppo target: chi vuoi esattamente come clienti?',

  'onb.step2Cta': 'Crea target',

  'onb.step2Badge': 'Crea ora',

  'onb.step2Locked': 'In attesa del passo 1',

  'onb.step3Title': 'Prima ricerca',

  'onb.step3DescFull':
    'Appena il tuo primo profilo è pronto, avvii la ricerca qui direttamente. Leadscraper trova 10 Lead in 30-90 secondi: esattamente il gruppo target che hai appena creato.',

  'onb.step3Cta': 'Avvia ricerca',

  'onb.step3Badge': 'Avvia ora',

  'onb.step3Locked': 'In attesa del passo 2',
  'onb.step1Pending':
    'Racconta brevemente a Leadscraper di te: basta uno sguardo al tuo sito web perché capisca cosa vendi',
  'onb.step2Desc':
    "Descrivi i tuoi clienti ideali in 1-2 frasi: ad es. 'Commercialisti in Lombardia, 3-15 dipendenti, amministratori delegati'. Da qui Leadscraper costruisce le tue query di ricerca, impara da ogni feedback, e il profilo diventa più preciso nel tempo.",
  'onb.step2Title': 'Crea il tuo primo target',
  'onb.step3Done': 'Prima ricerca in corso: Leadscraper ti fornirà subito i primi 10 Leads',
  'onb.step3Pending': 'Ricerca per il tuo target: Leadscraper fornisce 10 Leads su misura',

  'pd.activeSince': 'Attivo dal {date}',
  'pd.company.analyze': 'Analizza',
  'pd.company.analyzed': 'Leadscraper ha analizzato la tua azienda (Confidence {n}%).',
  'pd.company.analyzedAt': 'Analizzato il {date}',
  'pd.company.analyzing': 'Analizzando…',
  'pd.company.cached': 'Profilo caricato dalla cache.',
  'pd.company.cancel': 'Annulla',
  'pd.company.change': 'Modifica',
  'pd.company.confidence': '{n}% sicuro',
  'pd.company.costHint':
    'Costo ~$0.015 per analisi. Re-analisi automatica ogni 30 giorni se il tuo sito cambia.',
  'pd.company.error': 'Analisi fallita: riprova.',
  'pd.company.inputDesc1':
    'Leadscraper legge la tua pagina aziendale e ricorda cosa vendi, a chi vendi, e quali argomenti usi. Per ogni Lead, Leadscraper scrive poi ',
  'pd.company.inputDesc2': ' invece di solo "adatto al settore".',
  'pd.company.inputDescStrong': 'la tua strategia di pitch su misura',
  'pd.company.inputTitle': 'Inserisci il tuo sito web',
  'pd.company.knownTitle': 'Cosa Leadscraper sa della tua azienda',
  'pd.company.placeholder': 'https://mia-azienda.it',
  'pd.company.reanalyze': 'Re-analizza ora',
  'pd.company.reanalyzing': 'Re-analisi in corso…',
  'pd.company.sellLabel': 'Cosa vendi',
  'pd.company.staleAt': 'Re-analisi prevista {date}',
  'pd.company.targetLabel': 'A chi',
  'pd.company.techDetails': 'Dettagli Tecnici',
  'pd.company.valueLabel': 'Value Proposition',
  'pd.cortex.comingSoon': 'presto disponibile',
  'pd.cortex.sub': 'Dove Leadscraper è più preciso nel tuo targeting',
  'pd.cortex.title': 'Target Leadscraper',
  'pd.curve.coldSub': 'Cold',
  'pd.curve.currentRate': 'tasso di corrispondenza attuale',
  'pd.curve.highPct':
    'Leadscraper centra con {n}% molto precisamente: la curva di apprendimento si delinea non appena arrivano dati storici nel tempo. ',
  'pd.curve.highPctStrong': 'Tutto secondo i piani.',
  'pd.curve.inWeeks': 'in {n} settimane',
  'pd.curve.learningActive': 'Leadscraper sta imparando attivamente',
  'pd.curve.liftLabel': "Miglioramento dall'inizio",
  'pd.curve.liftSub': 'tasso di corrispondenza assoluto',
  'pd.curve.lockLabel': 'da 50 valutazioni',
  'pd.curve.lowPct':
    'Leadscraper raccoglie la cronologia dalle tue {n} valutazioni. Con più dati la linea di tendenza diventerà precisa.',
  'pd.curve.midPct':
    'Dalle tue {n} valutazioni Leadscraper costruisce la cronologia: la curva di apprendimento diventa più visibile con ogni ricerca aggiuntiva.',
  'pd.curve.milestone200': '200 Valutazioni',
  'pd.curve.milestone200Sub': 'Modello stabilizzato',
  'pd.curve.milestone50': '50 Valutazioni',
  'pd.curve.milestone50Sub': 'primi pattern',
  'pd.curve.mockAxisEnd': '50 valutazioni',
  'pd.curve.mockTitle': 'Tasso di corrispondenza delle ultime 50 valutazioni',
  'pd.curve.noData': 'Dati ancora insufficienti.',
  'pd.curve.start': 'Inizio',
  'pd.curve.sub': 'Come si è evoluto il tasso di corrispondenza con ogni valutazione.',
  'pd.curve.subShort': 'Come evolve il tasso di corrispondenza con ogni valutazione',
  'pd.curve.title': 'Curva di Apprendimento',
  'pd.curve.today': 'Oggi',
  'pd.curve.todaySub': '{n} valutazioni',
  'pd.decisions.checked': '{n} candidati controllati',
  'pd.decisions.checkedSg': '{n} candidato controllato',
  'pd.decisions.delivered': '{n} consegnati',
  'pd.decisions.hint':
    'Vedi un pattern errato? Riformula la query: Leadscraper usa tutte queste decisioni come esempi di apprendimento per la prossima esecuzione, non appena confermi la memoria del target.',
  'pd.decisions.more': '+ {n} altri …',
  'pd.decisions.rejected': '{n} rifiutati',
  'pd.decisions.showAll': 'Mostra tutti i rifiutati',
  'pd.decisions.showLess': 'Mostra meno',
  'pd.decisions.title': 'Decisioni Leadscraper · ultima ricerca',
  'pd.empty.cta': 'Vai alla Dashboard',
  'pd.empty.desc1': 'Un target è ',
  'pd.empty.desc2':
    ': Leadscraper vi raccoglie tutti gli apprendimenti dai tuoi feedback. Crea il tuo primo target nella dashboard, poi qui troverai tutti i pattern, le ipotesi, i motivi di rifiuto e lo storico delle esecuzioni.',
  'pd.empty.descStrong': 'un contenitore di apprendimento',
  'pd.empty.title': 'Nessun target creato finora',
  'pd.hex.bizModel': 'Modello Biz',
  'pd.hex.industry': 'Settore',
  'pd.hex.location': 'Posizione',
  'pd.hex.ownership': 'Proprietà',
  'pd.hex.role': 'Ruolo',
  'pd.hex.size': 'Dimensione',
  'pd.leads.sub': 'Anteprima: la lista completa si trova nella scheda Leads.',
  'pd.leads.title': 'Ultimi Leads',
  'pd.leads.viewAll': 'Visualizza tutti',
  'pd.learn.calibratedHint': 'Leadscraper ora integra attivamente i tuoi pattern nel ragionamento.',
  'pd.learn.coldStartHint':
    'Valuta più Leads perché Leadscraper inizi a riconoscere i tuoi pattern.',
  'pd.learn.earlyHint':
    'Con ogni valutazione aggiuntiva, il riconoscimento dei pattern diventa più preciso.',
  'pd.learn.emptyDesc1': 'Non appena clicchi su ',
  'pd.learn.emptyDesc2': ' o ',
  'pd.learn.emptyDesc3':
    ' nella lista Leads, Leadscraper impara le tue preferenze e ti mostra qui cosa ne deduce.',
  'pd.learn.emptyFit': 'adatto',
  'pd.learn.emptyNotFit': 'non adatto',
  'pd.learn.emptyTitle': 'Nessun feedback fornito ancora',
  'pd.learn.fits': 'Adatto',
  'pd.learn.lastRating': 'Ultima valutazione ',
  'pd.learn.loadError': 'Errore durante il caricamento',
  'pd.learn.loading': 'Caricamento stato apprendimento feedback…',
  'pd.learn.matchRate': 'Tasso di corrispondenza',
  'pd.learn.matchRateSub': 'adatto / valutato',
  'pd.learn.matureMsg':
    'Profilo completamente calibrato: Leadscraper tratta i tuoi pattern quasi come regole.',
  'pd.learn.morePrefix': 'Ancora ',
  'pd.learn.moreSuffix': ' valutazioni fino al livello ',
  'pd.learn.narrativeHide': "Nascondi lettera all'AI",
  'pd.learn.narrativeShow': "Mostra lettera all'AI",
  'pd.learn.narrativeSub':
    "Esattamente questo testo verrà trasmesso all'AI di Leadscraper nella prossima ricerca, letteralmente.",
  'pd.learn.negative': 'negativo',
  'pd.learn.noData': 'Nessun dato di feedback disponibile.',
  'pd.learn.noRating': 'Nessuna valutazione ancora',
  'pd.learn.notFits': 'Non adatto',
  'pd.learn.positive': 'positivo',
  'pd.learn.rated': 'Valutato',
  'pd.learn.ratingStatus': 'Stato valutazioni',
  'pd.learn.recentTitle': 'Valutazioni recenti',
  'pd.learn.stageCali': 'Calibrato',
  'pd.learn.stageEarly': 'Apprendimento',
  'pd.learn.stageMature': 'Maturo',
  'pd.learn.stageNext': 'livello successivo',
  'pd.learn.topReasons': 'Motivi di rifiuto più frequenti',
  'pd.learn.topReasonsDesc1': 'Dai tuoi ',
  'pd.learn.topReasonsDesc2':
    ' rifiuti: Leadscraper ricorda questi pattern e spinge verso il basso candidati simili nella prossima ricerca.',
  'pd.learn.totalSub': '{n} in totale',
  'pd.openLeads': 'Apri Leads',
  'pd.pat.actions': 'Azioni',
  'pd.pat.confirm': 'Conferma',
  'pd.pat.confirmT': 'Conferma: adotta come regola',
  'pd.pat.reject': 'Rifiuta',
  'pd.pat.rejectT': 'Rifiuta: elimina pattern',
  'pd.pat.remove': 'Rimuovi',
  'pd.pat.weaken': 'Indebolisci',
  'pd.patterns.medium': 'Medio: plausibile, viene monitorato',
  'pd.patterns.strong': 'Forte: regole affidabili',
  'pd.patterns.sub': 'Le tue preferenze: estratte da ogni valutazione Adatto / Non adatto.',
  'pd.patterns.title': 'Cosa ha imparato Leadscraper',
  'pd.patterns.weak': 'Debole: segnali iniziali',
  'pd.queries.dailyLegacy': 'Giornaliera (legacy)',
  'pd.queries.daysAgo': 'avviata {n} giorni fa',
  'pd.queries.emptySub': 'Non appena avvii una ricerca, apparirà qui, inclusa la pianificazione.',
  'pd.queries.emptyTitle': 'Nessuna ricerca avviata per questo target finora.',
  'pd.queries.everyH': 'Ogni {n} h',
  'pd.queries.filterEmpty': 'Nessuna query in questo filtro.',
  'pd.queries.hourly': 'Ogni ora',
  'pd.queries.inDays': 'tra {n} giorni',
  'pd.queries.inHours': 'tra {n} h',
  'pd.queries.inMinutes': 'tra {n} min',
  'pd.queries.leadsDelivered': '{n} Leads consegnati',
  'pd.queries.manual': 'Una tantum',
  'pd.queries.monthlyLegacy': 'Mensile (legacy)',
  'pd.queries.newSearch': 'Avvia nuova ricerca',
  'pd.queries.overdue': 'in ritardo',
  'pd.queries.paused': 'in pausa',
  'pd.queries.showAll': 'Mostra tutto',
  'pd.queries.sub': 'Clicca per aprire dettagli, pianificazione e cronologia della ricerca.',
  'pd.queries.title': 'Query di ricerca di questo target',
  'pd.queries.tomorrow': 'domani',
  'pd.queries.unnamed': 'Ricerca senza nome',
  'pd.queries.weeklyLegacy': 'Settimanale (legacy)',
  'pd.ratings': '{n} Valutazioni',
  'pd.rej.agency_not_operator': 'Agenzia invece di operatore',
  'pd.rej.consultant_not_operator': 'Consulente invece di operatore',
  'pd.rej.duplicate_previous_session': 'Già fornito',
  'pd.rej.insufficient_data': 'Dati insufficienti',
  'pd.rej.learned_rejection_pattern': 'Corrisponde al tuo pattern di rifiuto',
  'pd.rej.low_confidence': 'Troppo incerto',
  'pd.rej.outside_radius': 'Fuori raggio',
  'pd.rej.wrong_company_form': 'Forma giuridica sbagliata',
  'pd.rej.wrong_industry': 'Settore sbagliato',
  'pd.rej.wrong_region': 'Regione sbagliata',
  'pd.rej.wrong_role': 'Ruolo sbagliato',
  'pd.rej.wrong_size': 'Dimensione sbagliata',
  'pd.runs': '{n} Ricerche',
  'pd.screenLabel': 'Dettagli del target',
  'pd.side.accepted': '({n} idonei)',
  'pd.side.feedbacks': 'Valutazioni',
  'pd.side.firstRun': 'Primo ciclo',
  'pd.side.focus': 'Focus di ricerca',
  'pd.side.lastRun': 'Ultimo ciclo',
  'pd.side.lastRunLeads': '{n} Leads',
  'pd.side.leadsTotal': 'Leads totali',
  'pd.side.matchMiss': 'Idoneo / No',
  'pd.side.matchRate': 'Tasso di corrispondenza',
  'pd.side.next1.d':
    'Con il {pct}% di tasso di corrispondenza vale la pena ottenere 50–100 nuovi leads.',
  'pd.side.next1.t': 'Avvia ricerca',
  'pd.side.next2.d': 'Così Leadscraper impara più velocemente.',
  'pd.side.next2.t': 'Verifica pattern non confermati',
  'pd.side.next3.d': 'Più valutazioni ci sono, più preciso diventa.',
  'pd.side.next3.t': 'Continua a fornire feedback',
  'pd.side.patterns': 'Patterns',
  'pd.side.patternsSub': '{strong} forti · {medium} medi',
  'pd.side.reasons': 'Motivi di rifiuto frequenti',
  'pd.side.recommended': 'Consigliato',
  'pd.side.snapshot': "A colpo d'occhio",
  'pd.target.contacts': 'Contatti',
  'pd.target.excluded': 'Esclusi',
  'pd.target.industry': 'Settore',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Pattern',
  'pd.target.queries': 'Query',
  'pd.target.region': 'Regione',
  'pd.target.size': 'Dimensioni',
  'pd.target.sub': 'Quello su cui si basa Leadscraper per ogni ricerca.',
  'pd.target.title': 'Target',
  'pd.time.daysAgo': '{n} giorni fa',
  'pd.time.hoursAgo': '{n} h fa',
  'pd.time.justNow': 'proprio ora',
  'pd.time.minsAgo': '{n} min fa',
  'pd.toast.confirmed': 'Pattern confermato: verrà applicato come regola affidabile da ora in poi',
  'pd.toast.rejected': 'Pattern rifiutato',
  'pd.toast.removed': 'Pattern rimosso',
  'pd.toast.weakened': 'Pattern indebolito: verrà osservato nuovamente',

  'price.afterThen': 'Poi {price} / mese · cancellabile in qualsiasi momento',
  'price.badge.popular': 'Popolare',
  'price.badge.recommended': 'Consigliato',
  'price.badge.yourPlan': 'Il tuo piano',
  'price.ctaStartTrial': 'Inizia 3 giorni gratuiti',
  'price.ctaSwitchPlan': 'Cambia abbonamento',
  'price.ctaCurrentPlan': 'Piano attuale',
  'price.ctaTopUp': 'Ricarica ora',
  'price.heroSub': 'Più Leads, esattamente quando ti servono.',
  'price.heroTrial': 'Il tuo vantaggio competitivo sleale inizia qui.',
  'price.leads': 'Leads',
  'price.monthlyCancelable': 'cancellabile mensilmente',
  'price.oneTime': 'una tantum',
  'price.pack.1000.tag': 'Perfetto per iniziare',
  'price.pack.10000.tag': 'Per generazione leads continua',
  'price.pack.5000.tag': 'Per prime campagne scalate',
  'price.pack.50000.tag': 'Per alti volumi e team',
  'price.perLead': '€ / Lead',
  'price.perMonth': '/mese',
  'price.perMonthLong': '/ mese',
  'price.plan.basic.f1': '100 Leads qualificati al mese',
  'price.plan.basic.f2': '1 target attivo',
  'price.plan.basic.f3': 'AI Leadscraper con apprendimento continuo',
  'price.plan.basic.f4': 'Integrazioni CRM (HubSpot, Pipedrive, Salesforce …)',
  'price.plan.basic.f5': 'Supporto via email',
  'price.plan.basic.tag': 'Per iniziare con un target',
  'price.plan.growth.f1': '500 Leads qualificati al mese',
  'price.plan.growth.f2': 'Target illimitati',
  'price.plan.growth.f3': 'AI Leadscraper con Memory del team',
  'price.plan.growth.f4': 'Tutte le integrazioni CRM + Webhooks',
  'price.plan.growth.f5': 'Account Manager dedicato',
  'price.plan.growth.f6': 'Accesso API',
  'price.plan.growth.tag': 'Per team commerciali in crescita',
  'price.plan.starter.f1': '250 Leads qualificati al mese',
  'price.plan.starter.f2': '3 target attivi',
  'price.plan.starter.f3': 'AI Leadscraper con apprendimento prioritario',
  'price.plan.starter.f4': 'Tutte le integrazioni CRM',
  'price.plan.starter.f5': 'Supporto prioritario',
  'price.plan.starter.f6': 'Export in CSV, XLSX, JSON',
  'price.plan.starter.tag': 'Perfetto per iniziare',
  'price.selected': 'Selezionato:',
  'price.subOneoffDesc':
    'Leads aggiuntivi come pacchetto una tantum: nessuna durata, nessun vincolo. I Credits non scadono.',
  'price.subTrialDesc':
    'Prova gratuita per 3 giorni: con Leads reali, i tuoi profili, il tuo Memory Leadscraper. Leads inutilizzabili? Te li restituiamo senza domande.',
  'price.tab.afterSub': '(dopo abbonamento)',
  'price.tab.lockNote': "Disponibile dopo l'inizio dell'abbonamento",
  'price.tab.oneoff': 'Pacchetti una tantum',
  'price.tab.sub': 'Abbonamenti',
  'price.testLeads': 'Leads di prova',
  'price.then': 'poi',
  'price.trial3days': '3 giorni gratuiti',
  'price.trialIncl': 'incl.',
  'price.trust.cancel.s':
    'Cancellabile mensilmente, nessuna commissione nascosta, nessuna durata minima.',
  'price.trust.cancel.t': 'Cancellabile in qualsiasi momento',
  'price.trust.gdpr.s':
    "Tutti i dati ospitati nell'UE, crittografati, nessuna condivisione con terze parti.",
  'price.trust.gdpr.t': 'Conforme GDPR',
  'price.trust.refund.s': 'Se un Lead non è adatto, ricevi immediatamente il Credit di rimborso.',
  'price.trust.refund.t': 'Leads inutilizzabili? Rimborso.',

  'pricing.beta.headline': 'Il tuo accesso Beta a Leadscraper',
  'pricing.beta.subText':
    'Piano Growth con il 55% di sconto sul primo mese, esclusivo per i tester Beta.',
  'pricing.mai.headline': 'Il tuo vantaggio competitivo sleale inizia qui.',
  'pricing.mai.subText':
    'Risparmia il 74% nel primo mese, poi cambia o disdici con 1 clic quando vuoi.',
  'pricing.trial50.headline': '50 Leads B2B del valore di 100 €, ora in regalo.',
  'pricing.trial50.subText': '50 Leads in regalo: prova 3 giorni, disdici quando vuoi.',

  'reject.alreadyKnown': 'Già conosciuta',
  'reject.alreadyKnown.hint':
    'Già nel tuo CRM o già contattato: nessun segnale di apprendimento e non incide sul tasso di corrispondenza.',
  'reject.badData': 'Dati errati',
  'reject.badData.hint': 'Indirizzo, nome o info di contatto non corretti',
  'reject.noBuyingSignal': 'Nessuna esigenza riconoscibile',
  'reject.noBuyingSignal.hint': 'Nessun evento trigger, posizioni aperte o segnale di crescita',
  'reject.notOperator': 'Non è operatore',
  'reject.notOperator.hint': 'Agenzia, intermediario o costruttore invece di fornitore operativo',
  'reject.other': 'Altro motivo',
  'reject.other.hint': 'Scrivi brevemente il perché sotto (testo libero)',
  'reject.wrongIndustry': 'Settore sbagliato',
  'reject.wrongIndustry.hint': 'Leadscraper ha identificato erroneamente il campo di attività',
  'reject.wrongOwnership': 'Struttura proprietà sbagliata',
  'reject.wrongOwnership.hint':
    'Filiale di gruppo invece di azienda familiare, forma giuridica sbagliata ecc.',
  'reject.wrongRegion': 'Ubicazione sbagliata',
  'reject.wrongRegion.hint': 'Sede/regione non corrisponde alla ricerca',
  'reject.wrongRole': 'Contatto sbagliato',
  'reject.wrongRole.hint': 'La persona o il ruolo non è il decisore',
  'reject.wrongSize': 'Dimensione azienda sbagliata',
  'reject.wrongSize.hint': 'Troppo piccola, troppo grande o gruppo invece di PMI',

  'rel.daysAgo': '{n} giorni fa',
  'rel.hAgo': '{n} h fa',
  'rel.minAgo': '{n} min fa',
  'rel.now': 'ora',
  'rel.weeksAgo': '{n} settimane fa',
  'rel.yesterday': 'ieri',

  'repeat.amountHint': 'Più Leads = copertura più ampia, meno Leads = qualità più alta per Lead.',
  'repeat.amountLabel': 'Quanti Leads vuoi?',
  'repeat.cancel': 'Annulla',
  'repeat.paramsLabel': 'Parametri di questa esecuzione',
  'repeat.prediction.basedOn': 'basato sul tuo attuale tasso di corrispondenza',
  'repeat.prediction.credits': 'Credits',
  'repeat.prediction.matches': 'corrispondenze previste',
  'repeat.prediction.time': 'tempo di esecuzione stimato',
  'repeat.prediction.title': 'Risultato previsto',
  'repeat.preset': 'Suggerimenti',
  'repeat.start': 'Avvia ricerca',
  'repeat.sub': 'I parametri sono precompilati: modificali o avvia direttamente.',
  'repeat.title': 'Ripeti ricerca',
  'repeat.toast': 'Ricerca avviata · risultati tra pochi minuti.',

  'res.acceptedNote': 'Leadscraper impara da questa accettazione.',
  'res.breadcrumb': 'Risultati di ricerca · {profile}',
  'res.cancel': 'Annulla',
  'res.density.comfortable': 'Comodo',
  'res.density.compact': 'Compatto',
  'res.employees': 'Dipendenti',
  'res.fb.all': 'Tutti',
  'res.fb.new': 'Nuovo per te',
  'res.fb.status': 'Stato feedback',
  'res.filter': 'Filtro',
  'res.fit': 'Adatto',
  'res.footer':
    'Leadscraper ha esaminato altri 406 risultati. I {count} mostrati qui sono quelli che corrispondono meglio al tuo feedback precedente.',
  'res.fromMem': 'dalla tua memoria: "{text}"',
  'res.learning.body':
    'Nuovo segnale nelle ultime due settimane: accetti più spesso aziende con proprie tecnologie di stampa o punzonatura rispetto ai puri confezionatori.',
  'res.learning.title': 'Cosa sta imparando Leadscraper',
  'res.location': 'Località',
  'res.new': 'Nuovo',
  'res.notFit': 'Non adatto',
  'res.openDetails': 'Apri dettagli →',
  'res.pickReason': 'Scegli motivo →',
  'res.reasonHint': 'Un click è sufficiente: il tuo motivo affina quello che vedrai domani.',
  'res.rejectedNote': 'Motivo salvato. Questo affina la tua memoria.',
  'res.sector': 'Settore',
  'res.summary':
    '{count} Leads esaminati su 412. Ognuno arriva con una frase sul perché si adatta a te: il tuo "Adatto / Non adatto" affina quello che vedrai domani.',
  'res.title': 'Leads · {profile}',
  'res.toast.accepted': '«{company}» salvato come Adatto. Leadscraper affina il tuo target.',
  'res.toast.rejected': 'Motivo "{reason}" salvato. Leads simili appariranno meno spesso.',
  'res.uncertainty': 'Leadscraper è {score}: {text}.',
  'res.whyNotTitle': 'Perché questo Lead non è adatto?',

  'run.complete': 'Ricerca completata: {count} Leads forniti.',
  'run.completeEmpty':
    "Ricerca completata: nessuna azienda pertinente trovata. Precisa il tuo target o prova un'altra regione.",
  'run.cta.broaden_query': 'Amplia la query',
  'run.cta.edit_query': 'Modifica query',
  'run.cta.retry': 'Riprova',
  'run.failed.body':
    "Problema tecnico nell'ultima ricerca. Aspetta 1-2 minuti e riprova. Se si blocca di nuovo, faccelo sapere.",
  'run.failed.title': 'Leadscraper si è bloccato',
  'run.no_leads_delivered': 'Nessun Lead pertinente fornito',
  'run.no_results.body':
    'Le tue parole chiave non restituiscono aziende B2B italiane pertinenti su Google. Prova termini più comuni: ad es. "falegnameria" invece di "manifattura mobili", o espandi la regione.',
  'run.no_results.title': 'Nessun risultato trovato per la tua query sul web',
  'run.partial_yield.body':
    'Leadscraper ha trovato meno di 10 risultati. Per più volume: formula la descrizione in modo più ampio o scegli una regione più vasta.',
  'run.partial_yield.title': '{delivered}/{total} Leads forniti',
  'run.searching': '🧠 Leadscraper sta cercando per te…',
  'run.too_strict.body':
    'Leadscraper ha trovato aziende, ma nessuna corrisponde perfettamente al tuo target. Forse la tua descrizione è troppo specifica: prova una regione più ampia, allenta il numero di dipendenti o rimuovi alcuni dettagli.',
  'run.too_strict.title': '{reasoned} candidati valutati: nessuno corrispondeva al tuo target',

  'runs.delivered': '{n} Leads consegnati',
  'runs.deliveredOne': '1 Lead consegnato',
  'runs.empty': 'Nessuna esecuzione ancora per questa ricerca.',
  'runs.evaluated': '{n} valutati',
  'runs.failed': 'fallito',
  'runs.harvested.body':
    'I precedenti suchlauf hanno già fornito {n} aziende adatte: Leadscraper conosce già i risultati trovati. Nuovi risultati si generano quando nuove aziende del tuo target diventano visibili online. Lo schedule le rileva automaticamente.',
  'runs.harvested.title': 'Target temporaneamente esaurito',
  'runs.last': 'ultimo',
  'runs.loadError': 'Errore nel caricamento',
  'runs.loadFailed': 'Impossibile caricare cronologia: {err}',
  'runs.loading': 'Caricamento cronologia…',
  'runs.noHits': 'nessun risultato',
  'runs.running': 'in esecuzione ora',
  'runs.unfeasible': 'non fattibile',

  'sched.autoPush': 'Invia automaticamente nuovi Leads al CRM',
  'sched.autoPushNoCRM':
    "Devi prima collegare un CRM nelle impostazioni dell'account per utilizzare l'invio automatico.",
  'sched.autoPushSub':
    "Non appena Leadscraper completa un'esecuzione programmata, tutti i Leads trovati vengono automaticamente inviati al tuo CRM collegato.",
  'sched.daily': 'Giornalmente',
  'sched.dailySub': 'Ogni giorno alla stessa ora',
  'sched.day.fri': 'Venerdì',
  'sched.day.fri.short': 'Ven',
  'sched.day.mon': 'Lunedì',
  'sched.day.mon.short': 'Lun',
  'sched.day.sat': 'Sabato',
  'sched.day.sat.short': 'Sab',
  'sched.day.sun': 'Domenica',
  'sched.day.sun.short': 'Dom',
  'sched.day.thu': 'Giovedì',
  'sched.day.thu.short': 'Gio',
  'sched.day.tue': 'Martedì',
  'sched.day.tue.short': 'Mar',
  'sched.day.wed': 'Mercoledì',
  'sched.day.wed.short': 'Mer',
  'sched.dayOfMonth': 'Giorno del mese',
  'sched.monthly': 'Mensilmente',
  'sched.monthlySub': 'Ogni mese nella data selezionata',
  'sched.nextRun': 'Prossima esecuzione',
  'sched.once': 'Una tantum',
  'sched.onceSub': 'Esegui ora una sola volta',
  'sched.rel.inDays': 'tra {n} giorni',
  'sched.rel.overdue': 'scaduto',
  'sched.rel.soon': 'presto',
  'sched.rel.tomorrow': 'domani',
  'sched.section': 'Ripetizione',
  'sched.sectionSub':
    'Lascia che Leadscraper esegua questa ricerca automaticamente su base regolare.',
  'sched.time': 'Ora di avvio',
  'sched.toast.created': 'Ricerca programmata creata: continuerà automaticamente.',
  'sched.toast.deleted': 'Esecuzione programmata eliminata.',
  'sched.toast.paused': 'Esecuzione programmata sospesa.',
  'sched.toast.resumed': 'Esecuzione programmata riattivata.',
  'sched.weekday': 'Giorno della settimana',
  'sched.weekly': 'Settimanalmente',
  'sched.weeklySub': 'Ogni settimana nel giorno selezionato',

  'schedCard.creditsHint':
    'max. {n} Credits / giorno: non appena non vengono più trovati nuovi Leads nel tuo target, Leadscraper continua a girare a vuoto senza consumi.',
  'schedCard.errorToast': 'Salvataggio fallito: {err}',
  'schedCard.freq.every': 'Ogni {n} ore',
  'schedCard.freq.everyShort': 'ogni {n} h',
  'schedCard.freq.hourly': 'Ogni ora',
  'schedCard.freq.everyMinute': 'Ogni minuto (test)',
  'schedCard.minuteTestHint':
    'Modalità test: parte ~ogni minuto quando gira il tick dello scheduler. Solo staging.',
  'schedCard.freq.hourlyShort': 'ogni ora',
  'schedCard.leadsPerDay': '~{n} Leads / giorno',
  'schedCard.nextLabel': 'prossima esecuzione {when}',
  'schedCard.nextRun.days': 'tra {n} giorni',
  'schedCard.nextRun.hours': 'tra {n} h',
  'schedCard.nextRun.min': 'tra {n} min',
  'schedCard.nextRun.overdue': 'in ritardo',
  'schedCard.nextRun.tomorrow': 'domani',
  'schedCard.noRepeat': 'Nessuna ripetizione',
  'schedCard.offBody': 'Una tantum: avvii tu quando vuoi.',
  'schedCard.onBody':
    'Funziona in background. I nuovi risultati finiscono automaticamente nella tua lista Leads.',
  'schedCard.perWeek': '≈ {n} / settimana',
  'schedCard.repeat': 'Ripeti questa ricerca',
  'schedCard.save': 'Salva',
  'schedCard.savedToast': 'Pianificazione salvata.',
  'schedCard.saving': 'Salvataggio…',

  'schedRuns.col.action': '',
  'schedRuns.col.crm': 'Invio CRM',
  'schedRuns.col.frequency': 'Frequenza',
  'schedRuns.col.leads': 'Leads/Esecuzione',
  'schedRuns.col.nextRun': 'Prossima esecuzione',
  'schedRuns.col.params': 'Parametri',
  'schedRuns.count': 'attive',
  'schedRuns.crm.no': 'Disattivo',
  'schedRuns.crm.yes': 'Attivo',
  'schedRuns.delete': 'Elimina',
  'schedRuns.empty.sub':
    'Attiva "Ripetizione" nella prossima ricerca per ricevere regolarmente nuovi Leads.',
  'schedRuns.empty.title': 'Nessuna ricerca programmata ancora',
  'schedRuns.freq.daily': 'Giornalmente · {time}',
  'schedRuns.freq.monthly': '{day} del mese · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.pause': 'Sospendi',
  'schedRuns.resume': 'Riprendi',
  'schedRuns.status.paused': 'Sospeso',
  'schedRuns.sub':
    'Esecuzioni ricorrenti che aggiungono automaticamente nuovi lead a questo target.',
  'schedRuns.title': 'Ricerche programmate',

  'so.close.btn': 'Lascia in esecuzione in background',
  'so.close.hint':
    'Puoi continuare a lavorare: Leadscraper ti avviserà quando i nuovi leads saranno pronti.',
  'so.close.trust': 'Solo fonti pubbliche · ogni dato è documentato nel Lead.',
  'so.funnel.analyzed': 'Analizzate in dettaglio',
  'so.funnel.evaluated': 'Valutate',
  'so.funnel.identified': 'Identificate',
  'so.funnel.ready': 'Pronte',
  'so.hero.elapsed': "Tempo dall'inizio:",
  'so.hero.inFocus': 'Aziende nel mirino',
  'so.hero.preparing': 'Leadscraper sta verificando la tua richiesta',
  'so.hero.reflecting': 'Leadscraper sta elaborando un nuovo piano',
  'so.hero.round': '(Round {n})',
  'so.hero.searching': 'Leadscraper sta cercando per te',
  'so.live.title': 'Leadscraper sta lavorando in tempo reale',
  'so.query.title': 'La tua richiesta di ricerca',
  'so.reflector.title': 'Leadscraper ha scartato il primo approccio',
  'so.step.delivery.sub': 'Le migliori corrispondenze vengono ordinate e consegnate',
  'so.step.delivery.title': 'Compila leads',
  'so.step.discovery.sub': 'Top candidati da fonti web tedesche',
  'so.step.discovery.title': 'Identifica aziende',
  'so.step.done.sub': 'Ricerca completata',
  'so.step.done.title': 'Completato',
  'so.step.enriching.sub': 'Piano di acquisizione, punteggi + ricerca approfondita sui 10 leads',
  'so.step.enriching.title': 'Cortex sta ancora arricchendo',
  'so.step.enriching.title.light': 'Verifica dei dati di base',
  'so.step.hydration.sub': 'Siti web + Impressum + Carriere + Team + News',
  'so.step.hydration.title': 'Analizza aziende in profondità',
  'so.step.planning.sub': 'Analizza i tuoi apprendimenti + pianifica strategie di ricerca',
  'so.step.planning.title': 'Leadscraper si ricorda',
  'so.step.reasoning.sub': 'Leadscraper valuta ogni candidato rispetto al tuo target',
  'so.step.reasoning.title': 'Leadscraper valuta',

  'src.derived': 'Da Leadscraper',
  'src.directory': 'Directory',
  'src.news': 'Stampa specializzata',
  'src.official': 'Ufficiale',
  'src.web': 'Sito web aziendale',

  'trial.afterNote':
    'Dopodiché il tuo abbonamento {plan} continuerà automaticamente, cancellabile in qualsiasi momento.',
  'trial.day1': '1 giorno rimasto',
  'trial.daysN': '{n} giorni rimasti',
  'trial.freeTest': 'prova gratuita.',
  'trial.leadsLeft': '{left} / {total} Leads di prova rimasti',
  'trial.phase': 'Fase di prova',
  'trial.secureSub': 'Ottieni abbonamento',
  // LEA-324: SEPA subscription "payment processing" banner.
  'bill.sepaProcessing.badge': 'Pagamento in corso',
  'bill.sepaProcessing.title':
    'Il tuo pagamento SEPA è in elaborazione: il tuo accesso è già attivo.',
  'bill.sepaProcessing.note':
    "L'addebito può richiedere 2–5 giorni lavorativi. Puoi usare Leadscraper completamente già ora.",

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: machine-translated from de.ts/en.ts. Informal "tu" register to
  // match existing app strings. Native-speaker review pending before
  // production rollout (see staging-verification runbook).
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Fondatore, Leadscraper',
  'email.shared.reply_note': 'Domande? Rispondi a questa e-mail.',
  'email.sepa-payment-failed.subject': 'Il tuo pagamento SEPA non è riuscito',
  'email.sepa-payment-failed.preheader': 'L’addebito di {{amount_formatted}} è stato respinto.',
  'email.sepa-payment-failed.badge': 'Pagamento non riuscito',
  'email.sepa-payment-failed.hero': 'Il tuo addebito<br>è stato respinto.',
  'email.sepa-payment-failed.greeting': 'Ciao {{first_name}},',
  'email.sepa-payment-failed.intro':
    'l’addebito SEPA per il tuo pacchetto di crediti non è andato a buon fine presso la tua banca.',
  'email.sepa-payment-failed.credits_line':
    'Abbiamo quindi rimosso {{credits_revoked}} crediti dal tuo account.',
  'email.sepa-payment-failed.retry_line':
    'Se ti servono i crediti, puoi semplicemente riacquistare il pacchetto nel tuo account.',
  'email.sepa-payment-failed.button': 'Apri Leadscraper',
  'email.sepa-payment-failed.detail.pack_label': 'Pacchetto',
  'email.sepa-payment-failed.detail.amount_label': 'Importo',
  'email.shared.footer.transactional':
    'Ricevi questa email perché ti sei registrato a un account Leadscraper. Questo messaggio transazionale fa parte del rapporto contrattuale e non può essere disiscritto.',
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Amburgo &middot; Germania<br />Amministratore Delegato: Janik Deimann &middot; HRB 164162 (AG Amburgo) &middot; P.IVA DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome ───────────────────────────────────────
  'email.welcome.subject': 'Benvenuto su Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Benvenuto su Leadscraper',
  'email.welcome.preheader': 'Benvenuto a bordo: i tuoi primi lead in 5 minuti.',
  'email.welcome.badge': 'Account pronto',
  'email.welcome.hero': 'Felice di averti qui,<br>{{first_name}}.',
  'email.welcome.subhead':
    'Il tuo account è configurato e i tuoi primi crediti sono pronti, partiamo!',
  'email.welcome.steps.title': 'Inizia in 5 passi',
  'email.welcome.steps.1.title': 'Aggiungi il tuo sito web',
  'email.welcome.steps.1.body':
    "Così l'agente capisce dove sta andando la tua attività, e a cosa fare attenzione.",
  'email.welcome.steps.2.title': 'Definisci il tuo pubblico target',
  'email.welcome.steps.2.body':
    'Settore, regione, dimensione aziendale, ruolo: più sei preciso, migliori sono i risultati.',
  'email.welcome.steps.3.title': 'Lancia la tua prima ricerca di lead',
  'email.welcome.steps.3.body':
    "L'agente ricerca, arricchisce e consegna le prime aziende direttamente nella tua dashboard.",
  'email.welcome.steps.4.title': 'Valuta i lead',
  'email.welcome.steps.4.body':
    "Pollice in alto o in basso: l'agente impara da ogni feedback cosa si adatta a te.",
  'email.welcome.steps.5.title': 'Lancia la prossima ricerca',
  'email.welcome.steps.5.body':
    'A ogni esecuzione i risultati diventano sensibilmente più precisi, fino a corrispondere al 100 % a te.',
  'email.welcome.cta.primary': 'Alla dashboard',
  'email.welcome.signoff.line': 'Domande? Rispondi semplicemente a questa email, la leggo io.',

  // ─── Transactional email — subscription-cancelled ────────────────────────
  'email.subscription-cancelled.subject':
    'Ci dispiace vederti andare, {{first_name}}: cancellazione confermata',
  'email.subscription-cancelled.title': 'Il tuo abbonamento è stato cancellato',
  'email.subscription-cancelled.preheader': 'Abbiamo ricevuto la tua cancellazione.',
  'email.subscription-cancelled.badge': 'Cancellazione confermata',
  'email.subscription-cancelled.hero': 'Ci dispiace vederti andare,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    'Abbiamo ricevuto la tua cancellazione. Il tuo accesso al piano {{plan_name}} resta attivo fino al {{access_until}}.',
  'email.subscription-cancelled.subhead_trial':
    'Abbiamo ricevuto la tua cancellazione. La prova è terminata e non verrà addebitato nulla.',
  'email.subscription-cancelled.note_trial':
    'Se più avanti vuoi continuare, puoi riattivare l’abbonamento nel tuo account.',
  'email.subscription-cancelled.summary.plan_label': 'Piano',
  'email.subscription-cancelled.summary.until_label': 'Accesso fino al',
  'email.subscription-cancelled.note':
    "Fino ad allora mantieni l'accesso completo. Dopo, i tuoi dati saranno eliminati secondo la nostra informativa sulla privacy.",
  'email.subscription-cancelled.signoff.line':
    'Cosa avremmo potuto fare meglio? Rispondi a questa email, la leggo io.',
  'email.subscription-cancelled.cta.primary': 'Torna al prodotto &amp; riattiva',
  'email.subscription-cancelled.cta.note':
    'Atterrerai direttamente nella dashboard dove puoi riattivare il tuo abbonamento.',
  'email.subscription-cancelled.footer.transactional':
    'Ricevi questa email come conferma della tua cancellazione. Questo messaggio transazionale fa parte del rapporto contrattuale e non può essere disiscritto.',

  // ─── Transactional email — payment-failed / dunning (LEA-304, AI-translated from DE master) ─────
  'email.payment-failed.subject': 'Il tuo pagamento non è andato a buon fine: aggiorna i dati',
  'email.payment-failed.title': 'Pagamento non riuscito: aggiorna i dati',
  'email.payment-failed.preheader':
    'Non siamo riusciti ad addebitare {{amount_formatted}} per il tuo piano {{plan_name}}. Aggiorna i tuoi dati di pagamento.',
  'email.payment-failed.badge': 'Pagamento non riuscito',
  'email.payment-failed.hero': 'Il tuo pagamento non è andato a buon fine, {{first_name}}.',
  'email.payment-failed.subhead':
    'Non siamo riusciti ad addebitare <strong style="color:#0B0F19;">{{amount_formatted}}</strong> per il tuo piano {{plan_name}}. Aggiorna i tuoi dati di pagamento per evitare interruzioni ai tuoi lead.',
  'email.payment-failed.summary.plan_label': 'Piano',
  'email.payment-failed.summary.amount_label': 'Importo dovuto',
  'email.payment-failed.summary.attempt_label': 'Tentativo',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}} di 3',
  'email.payment-failed.summary.next_label': 'Prossimo tentativo',
  'email.payment-failed.cta.primary': 'Aggiorna i dati di pagamento ora',
  'email.payment-failed.reassurance':
    'Bastano pochi secondi, poi tutto prosegue come sempre. Domande? Rispondi semplicemente a questa email.',
  'email.payment-failed.footer.transactional':
    'Ricevi questa email perché un pagamento del tuo abbonamento Leadscraper non è andato a buon fine. Questo messaggio transazionale fa parte del rapporto contrattuale e non può essere disiscritto.',

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-winback.subject': 'Se era solo la paura dell’addebito …',
  'email.trial-winback.badge': 'Il tuo account è ancora qui',
  'email.trial-winback.hero': '30 % di sconto<br>se vuoi continuare.',
  'email.trial-winback.preheader': 'Torna — 30% di sconto per 3 mesi, il tuo account è ancora lì.',
  'email.trial-winback.greeting': 'Ciao {{first_name}},',
  'email.trial-winback.intro':
    'ieri hai terminato subito la tua prova — del tutto legittimo, il pulsante serve a questo. Ma se era solo per evitare un addebito indesiderato: il tuo account è ancora lì, con tutto quello che hai configurato.',
  'email.trial-winback.offer':
    'Se vuoi continuare: {{plan_name}} con il 30% di sconto per 3 mesi. Nessun nuovo modulo — la tua carta è già registrata.',
  'email.trial-winback.button': 'Vedi l’offerta e riattiva',
  'email.trial-winback.transparency':
    'Il clic non addebita nulla — prima vedi prezzo e data di addebito, poi confermi tu stesso. Link: {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  'email.trial-ending-soon.cancel_note':
    'Non vuoi continuare? Disdici con un clic, prima del primo addebito: {{cancel_link}}',
  'email.trial-ending-soon.cancel_link_label': 'Disdici la prova',
  'email.trial-ending-soon.subject': 'La tua prova sta per finire',
  'email.trial-ending-soon.preheader':
    'La prova termina il {{trial_ends_at}}: scegli un piano ora.',
  'email.trial-ending-soon.greeting': 'Ciao {{first_name}},',
  'email.trial-ending-soon.intro':
    'la tua prova {{plan_name}} termina il {{trial_ends_at}}. Ti restano {{credits_remaining}} crediti.',
  'email.trial-ending-soon.why':
    'Quando la prova termina, il tuo account diventa di sola lettura: puoi continuare a vedere i lead precedenti, ma le nuove ricerche vengono sospese.',
  'email.trial-ending-soon.cta':
    'Se i risultati ti convincono: scegli un piano ora per continuare senza interruzioni.',
  'email.trial-ending-soon.button': 'Scegli un piano',
  'email.trial-ending-soon.signoff': 'Janik',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'La tua prova è terminata',
  'email.trial-ended.badge': 'Prova terminata',
  'email.trial-ended.hero': 'La tua prova<br>è terminata.',
  'email.trial-ended.preheader': 'La tua prova è terminata: account in sola lettura.',
  'email.trial-ended.greeting': 'Ciao {{first_name}},',
  'email.trial-ended.intro':
    'la tua prova {{plan_name}} è appena terminata. Il tuo account ora è di sola lettura: puoi ancora vedere tutti i lead precedenti, ma le nuove ricerche sono sospese.',
  'email.trial-ended.cta':
    'Scegli un piano per continuare subito. I tuoi dati e la tua memoria di apprendimento restano intatti.',
  'email.trial-ended.button': 'Scegli un piano',
  'email.trial-ended.signoff': 'A presto.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Conferma il tuo indirizzo email',
  'email.verify-email.badge': 'Ci siamo quasi',
  'email.verify-email.hero': 'Conferma il tuo<br>indirizzo e-mail.',
  'email.verify-email.preheader': 'Conferma la tua email per attivare Leadscraper.',
  'email.verify-email.greeting': 'Ciao {{first_name}},',
  'email.verify-email.body':
    'tocca il pulsante qui sotto per confermare la tua email e attivare il tuo account Leadscraper.',
  'email.verify-email.button': 'Conferma email',
  'email.verify-email.fallback_note':
    'Se il pulsante non funziona, incolla questo link nel browser:',
  'email.verify-email.ttl_note': 'Il link scade tra {{verify_expires_in}}.',
  'email.verify-email.ttl_default': '24 ore',
  'email.verify-email.ignore_note': 'Non hai creato un account Leadscraper? Ignora questa email.',

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Rimborso confermato',
  'email.refund-confirmation.preheader': 'Rimborso: {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Ciao {{first_name}},',
  'email.refund-confirmation.intro': 'ti abbiamo rimborsato {{amount_formatted}}.',
  'email.refund-confirmation.refunded_line':
    "Registrato il {{refunded_at}} sul tuo metodo di pagamento originale. A seconda della banca, l'accredito compare in 3-10 giorni lavorativi.",
  'email.refund-confirmation.clawback_yes':
    'Poiché il rimborso annulla i crediti associati, {{credits_clawed_back}} crediti sono stati rimossi dal tuo account.',
  'email.refund-confirmation.clawback_no': 'I tuoi crediti restano intatti.',
  'email.refund-confirmation.reason_line': 'Motivo: {{reason}}.',
  'email.refund-confirmation.outro': 'Domande? Rispondi semplicemente a questa email.',
  'email.refund-confirmation.footer':
    'Ricevi questa email perché è stato emesso un rimborso per il tuo account Leadscraper.',

  // ─── Transactional email — password-reset ────────────────────────────────
  'email.password-reset.subject': 'Reimposta la password: link valido per {{expires_in}}',
  'email.password-reset.title': 'Reimposta la password',
  'email.password-reset.preheader':
    'Reimposta la tua password in modo sicuro. Il link scade tra {{expires_in}}.',
  'email.password-reset.badge': 'Reimposta password',
  'email.password-reset.hero': 'Imposta una nuova<br>password.',
  'email.password-reset.body':
    'Qualcuno ha richiesto di reimpostare la tua password. Se eri tu, clicca semplicemente sul pulsante. Altrimenti, ignora questa email, la tua password resta invariata.',
  'email.password-reset.expires': 'Il link scade tra {{expires_in}}.',
  'email.password-reset.cta.primary': 'Reimposta password',
  'email.password-reset.signoff.line':
    "Domande sulla sicurezza dell'account? Rispondi semplicemente a questa email.",
  'email.password-reset.footer.transactional':
    'Per motivi di sicurezza, questa email contiene informazioni sulla richiesta. Non condividerla con nessuno. Questa notifica di sicurezza fa parte del rapporto contrattuale e non può essere disiscritta.',

  // ─── Transactional email — security-alert ────────────────────────────────
  'email.security-alert.subject': 'Avviso di sicurezza: {{event}}',
  'email.security-alert.title': 'Avviso di sicurezza',
  'email.security-alert.preheader':
    'Avviso di sicurezza: {{event}}. Se non eri tu, reimposta subito la password.',
  'email.security-alert.badge': 'Avviso di sicurezza',
  'email.security-alert.hero': 'Qualcosa è cambiato sul<br>tuo account.',
  'email.security-alert.subhead':
    'Ciao {{first_name}}, abbiamo appena rilevato un\'azione relativa alla sicurezza: <strong style="color:#0B0F19;">{{event}}</strong>. Se eri tu, tutto va bene, puoi ignorare questa email.',
  'email.security-alert.detail.time_label': 'Ora (UTC)',
  'email.security-alert.detail.ip_label': 'Indirizzo IP',
  'email.security-alert.detail.browser_label': 'Browser',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">Non eri tu?</strong> Reimposta subito la password e controlla l\'attività del tuo account.',
  'email.security-alert.cta.primary': 'Reimposta password ora',
  'email.security-alert.signoff.line':
    "Domande sulla sicurezza dell'account? Rispondi semplicemente a questa email, leggo ogni messaggio.",
  'email.security-alert.footer.transactional':
    "Per motivi di sicurezza, questa email contiene informazioni sull'azione. Non condividerle con nessuno. Questa notifica di sicurezza fa parte dei nostri termini di servizio e non può essere disiscritta.",
  // LEA-295 bug-fix: see note in de.ts. Machine-translated, pending native review.
  'email.security-alert.event.password_reset': 'Password reimpostata',
  'email.security-alert.event.account_deletion_requested':
    'Eliminazione account richiesta (periodo di tolleranza di 30 giorni)',
  'email.security-alert.event.password_changed': 'Password modificata',
  'email.security-alert.firstname_fallback': 'lì',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'credito',
  'phase.creditMany': 'crediti',
  'phase.retry': 'Riprova',
  'phase.cancel': 'Annulla',
  'phase.confirm': 'Conferma',
  'phase.running': 'In corso …',
  'phase.btn.running': 'in corso …',
  'phase.unknownError': 'Errore sconosciuto',
  'phase.errorLabel': 'Errore:',
  'phase.gate.loadingConnect': 'Ricerca dei contatti …',
  'phase.gate.loadingPitch': 'Generazione degli insight completi …',
  'phase.gate.loadingHint':
    'Di solito richiede 30-60 secondi. Puoi lasciare la pagina, ti avviseremo quando sarà pronto.',
  'phase.gate.failConnect': 'Ricerca non riuscita',
  'phase.gate.failPitch': 'Generazione degli insight non riuscita',
  'phase.gate.failHint': 'Riprova: nessun credito aggiuntivo verrà addebitato.',
  'phase.connect.title': 'Sblocca contatti e recapiti diretti',
  'phase.connect.desc':
    'Ricerchiamo fino a 3 decisori con email diretta, telefono diretto e URL LinkedIn. Le fonti sono incluse (audit trail GDPR).',
  'phase.connect.cta': 'Trova contatti',
  'phase.connect.runtime': 'Durata: ~30-60 secondi',
  'phase.pitch.title': 'Sblocca insight completi e piano di acquisizione',
  'phase.pitch.desc':
    "Piano di acquisizione personalizzato in 6 sezioni: cosa fa l'azienda, perché proprio questo lead, attualità (trigger event), referenze clienti, agganci per la tua email di vendita.",
  'phase.pitch.cta': 'Genera insight completi',
  'phase.pitch.runtime': 'Durata: ~20-40 secondi',
  'phase.locked.confirmQuestion': 'Conferma: addebitare {credits} per "{action}"?',
  'phase.deepen.title': 'Approfondisci questo lead',
  'phase.deepen.descConnectDone':
    'I contatti sono caricati. Ora carica gli insight completi per il piano di acquisizione + lo stack tecnologico.',
  'phase.deepen.descDefault':
    'Identificato. Carica i contatti o vai direttamente agli insight completi: addebitato per clic.',
  'phase.deepen.pricingError':
    'Impossibile caricare il catalogo prezzi: si usano i prezzi standard.',
  'phase.deepen.directPitch': 'Carica direttamente gli insight completi (senza contatti)',
  'phase.btn.connect': '+ Trova contatti ({credits})',
  'phase.btn.pitch': '+ Insight completi ({credits})',
  'phase.toast.connectLoading': 'I contatti si stanno caricando.',
  'phase.toast.pitchLoading': 'Gli insight completi si stanno caricando.',
  'phase.toast.noCredits': 'Crediti esauriti. Ricarica o aggiorna il tuo piano.',
  'phase.toast.connectSoon': "La ricerca dei contatti arriva presto: sbloccata con l'ondata F2.2.",
  'phase.toast.pitchSoon': "Gli insight completi arrivano presto: sbloccati con l'ondata F2.3.",
  'phase.toast.error': 'Errore: {msg}',
  'phase.toast.unexpected': 'Errore imprevisto. Riprova.',
  'phase.dialog.connectTitle': 'Trovare i contatti?',
  'phase.dialog.pitchTitle': 'Caricare gli insight completi?',
  'phase.dialog.connectDesc':
    'Ricerchiamo i decisori (email, telefono, LinkedIn) per questo lead. Il risultato è di solito disponibile entro 1-2 minuti.',
  'phase.dialog.pitchDesc':
    'Generiamo il piano di acquisizione, lo stack tecnologico, le frasi trigger e i campi Sparkle per questo lead. Il risultato è di solito disponibile entro 1-2 minuti.',
  'phase.dialog.close': 'Chiudi la finestra di dialogo',
  'phase.dialog.costNote':
    'Questa azione costa {credits}. Una volta utilizzato, un credito non viene rimborsato automaticamente.',
  'phase.dialog.confirmDeduct': 'Sì, addebita {credits}',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Note legali',
  'det.src.handelsregister': 'Registro delle imprese',
  'det.src.subPage': 'Pagina del team',
  'det.src.dorkEnrich': 'Ricerca web',
  'det.src.geminiGrounding': 'Ricerca IA',
  'det.confReason.deepResearchConfirmed': 'confermato tramite ricerca',
  'det.confReason.handelsregisterOnly': 'solo registro imprese',
  'det.confReason.nameMatch': 'corrispondenza nome',
  'det.confReason.multiSource': 'fonti multiple',
  'det.confReason.rankFallback': 'Ranking discovery (ricerca approfondita saltata)',
  'det.confReason.rankFallbackLowConf': 'Ranking discovery (ricerca approfondita senza esiti)',
  'det.trust.authoritative': 'Verificato da una fonte ufficiale (note legali/registro imprese)',
  'det.trust.semiAuth': "Dal sito stesso dell'azienda (es. /team)",
  'det.trust.llm': "Estratto dall'IA dal contenuto del sito",
  'det.trust.derived': 'Derivato da altri dati (bassa affidabilità)',
  'det.trust.sourceGeneric': 'Fonte: {source}',
  'det.trust.confidence': 'affidabilità',
  'det.pReject.duplicate': 'Duplicato',
  'det.pReject.duplicateHint':
    'La persona è già nell\'elenco o nome non corrispondente ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Ruolo sbagliato',
  'det.pReject.wrongRoleHint': 'La persona non ha il potere decisionale che cerchiamo',
  'det.pReject.inactive': 'Non più attivo',
  'det.pReject.inactiveHint': 'La persona è cambiata, in pensione, ecc.',
  'det.pReject.wrongData': 'Dati errati',
  'det.pReject.wrongDataHint': 'Email/telefono errati o non raggiungibili',
  'det.pReject.betterContact': "Un'altra persona è migliore",
  'det.pReject.betterContactHint': "C'è un contatto più adatto in questa azienda",
  'det.pReject.private': 'Non contattare',
  'det.pReject.privateHint': 'Non voglio contattare questa persona (nessun apprendimento)',
  'det.toast.personFeedbackRealOnly':
    'Il feedback sulle persone è disponibile solo per i lead reali.',
  'det.toast.removeFailed': 'Impossibile rimuovere: riprova.',
  'det.toast.backendUnavailable': "Backend non disponibile: ricarica l'app.",
  'det.toast.planRegenerating':
    'Il piano di acquisizione viene rigenerato con il briefing attuale …',
  'det.toast.phaseAlreadyRunning': '{phase} è già in corso, un momento.',
  'det.available': 'disponibile',
  'det.unavailable': 'non disponibile',
  'det.primary': 'Principale',
  'det.sourcePrefix': 'Fonte:',
  'det.dataViaWebResearch': 'Dati tramite ricerca web pubblica',
  'det.openLink': 'Apri {label}',
  'det.openLinkedin': 'Apri il profilo LinkedIn di {name}',
  'det.openXing': 'Apri il profilo XING di {name}',
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts': 'Non abbiamo individuato contatti. Nessun credito addebitato.',
  'lt.trigErr.insufficientCredits': 'Crediti insufficienti. Ricarica.',
  'lt.trigErr.phaseRunning': 'Questa fase è già in corso: attendi.',
  'lt.trigErr.phaseCompleted': 'Questa fase è già completata.',
  'lt.trigErr.triggerFailed': 'Attivazione non riuscita: {msg}',
  'lt.cta.findContacts': 'Trova contatti · 1 credito',
  'lt.cta.createPlan': 'Crea piano di acquisizione · 1 credito',
  'lt.cta.openOutreach': 'Apri il messaggio di contatto',
  'lt.verifyStuck': 'La verifica è bloccata: ricarica la pagina e riprova.',
  'lt.verifyFailed': 'Verifica dei contatti non riuscita.',
  'lt.planFailed': 'Impossibile creare il piano di acquisizione.',
  'lt.softKeepAria': 'Possibile: clicca per i dettagli',
  'lt.manual.toast.backendUnavailable': 'Backend non disponibile: riprova più tardi.',
  'lt.manual.toast.added': '{name} aggiunto',
  'lt.manual.toast.alreadyExists': '{name} esiste già: la apro per te.',
  'lt.manual.toast.switchProfile':
    'Potresti dover cambiare target: il lead potrebbe essere altrove.',
  'lt.manual.toast.addFailed': 'Aggiunta non riuscita.',
  'lt.manual.companyFallback': 'Azienda',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested': 'Annullamento richiesto: avrà effetto al prossimo checkpoint.',
  'dash.cancel.failed': 'Annullamento non riuscito',
  'dash.cancel.titleNoRun': 'ID esecuzione non ancora disponibile',
  'dash.cancel.titleCancel': 'Annulla la ricerca',
  'dash.cancel.inFlight': 'Annullamento …',
  'dash.cancel.confirm': 'Annullare davvero?',
  'dash.refreshing': 'Aggiornamento …',
  'dash.run.noCredits': 'Nessun credito: sottoscrivi un abbonamento.',
  'dash.run.startSub': 'Avvia abbonamento',
  'dash.sugg.region': 'Regione:',
  'dash.sugg.contact': 'Contatto:',
  'dash.sugg.extra': 'Extra:',
  'dash.sugg.why': 'Perché:',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Escludi clienti esistenti',
  'acct.exclude.desc':
    "Aggiungi i domini che conosci già (es. l'export del tuo CRM). Vengono esclusi dai risultati di TUTTE le ricerche: un dominio per riga.",
  'acct.exclude.placeholder': 'azienda.it\nesempio-srl.it\ncliente.com',
  'acct.exclude.count': '{n} domini esclusi da tutte le ricerche',
  'acct.exclude.save': 'Salva elenco',
  'acct.exclude.saved': 'Elenco di esclusione salvato ({n} domini)',
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Assistente',
  'agent.tab.chat': 'Chat',
  'agent.tab.workspace': 'Area di lavoro',
  'agent.boot': 'Un attimo — il tuo assistente si sta avviando …',
  'agent.thinking': 'Sto pensando …',
  'agent.turnError': 'Qualcosa non ha funzionato — riprova tra un attimo.',
  'agent.budgetExhausted':
    'Il credito chat del tuo account è esaurito per oggi. Domani riparte automaticamente: i tuoi crediti e lead non sono interessati.',
  'agent.artifact.eyebrow': 'Gruppo target',
  'agent.artifact.draftBadge': 'Bozza',
  'agent.artifact.createdBadge': 'Appena creato',
  'agent.artifact.industry': 'Settore',
  'agent.artifact.region': 'Regione',
  'agent.artifact.size': 'Dimensione',
  'agent.artifact.exclusions': 'Esclusioni',
  'agent.artifact.any': 'qualsiasi',
  'agent.bootError': 'L’assistente non è al momento disponibile. Ricarica la pagina.',
  'agent.empty.title': '{greeting}, come posso aiutarti?',
  'agent.greet.morning': 'Buongiorno',
  'agent.greet.day': 'Ciao',
  'agent.greet.evening': 'Buonasera',
  'agent.empty.sub':
    'Descrivi che clienti cerchi — costruisco la ricerca, chiedo la tua approvazione e rivediamo insieme i risultati.',
  'agent.starter.find': 'Cerco nuovi clienti — aiutami a definire il mio target',
  'agent.starter.describe': 'Analizza il mio sito e proponi target adatti',
  'agent.starter.review': 'Mostrami gli ultimi lead e rivediamoli insieme',
  'agent.composer.placeholder': 'Messaggio al tuo assistente …',
  'agent.composer.send': 'Invia',
  'agent.composer.stop': 'Stop',
  'agent.composer.hint': 'Invio per inviare · Shift+Invio per andare a capo',
  'agent.scroll.end': 'Vai alla fine',
  'agent.confirm.title': 'Approvazione: {action}',
  'agent.confirm.approve': 'Approva',
  'agent.confirm.deny': 'Rifiuta',
  'agent.tool.analyze': 'Analizza sito',
  'agent.tool.analyzeReference': 'Vedi sito di riferimento',
  'agent.tool.draft': 'Bozza di target',
  'agent.tool.createProfile': 'Crea profilo',
  'agent.tool.startRun': 'Avvia ricerca',
  'agent.tool.runStatus': 'Stato ricerca',
  'agent.tool.listLeads': 'Carica lead',
  'agent.tool.getLead': 'Dettagli lead',
  'agent.tool.connect': 'Trova referenti',
  'agent.tool.pitch': 'Crea piano di contatto',
  'agent.tool.feedback': 'Registra feedback',
  'agent.tool.credits': 'Saldo crediti',
  'agent.tool.exclude': 'Escludi aziende',
  'agent.tool.cancelApproval': 'Ritira l’approvazione',
  'agent.tool.cancelPlan': 'Ferma il piano di ricerca',
  'agent.support.open': 'Assistenza',
  'agent.support.title': 'Apri la chat di assistenza — risponde una persona',
  'agent.ws.title': 'I tuoi target',
  'agent.ws.new': 'Nuovo',
  'agent.ws.empty': 'Qui appariranno i profili target creati insieme nella chat.',
  'agent.ws.openLeads': 'Vedi lead',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Copia',
  'agent.msg.copied': 'Copiato',
  'agent.sessions.rename': 'Doppio clic per rinominare',
  'agent.composer.attach': 'Allega elenco clienti (CSV/XLSX)',
  'agent.attach.none': 'Nessun dominio aziendale rilevato nel file.',
  'agent.attach.xlsxFailed': 'Impossibile leggere il file Excel. Prova con un file CSV.',
  'agent.attach.saved':
    'Ho caricato il mio elenco clienti: {n} domini aziendali sono ora esclusi da tutte le ricerche future (ad es. {examples}).',
  'agent.attach.saveFailed':
    'Ho caricato il mio elenco clienti ({n} domini aziendali), ma il salvataggio come lista di esclusione non è riuscito.',
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'Nuova chat',
  'agent.sessions.empty': 'Nessuna conversazione.',
  'agent.sessions.untitled': 'Nuova conversazione',
  'agent.sessions.delete': 'Elimina',
  // LEA-448
  'agent.sessions.deleteConfirm': 'Eliminare questa conversazione? Non è reversibile.',
  'agent.artifact.radius': 'raggio di {n} km',
  'agent.leads.companyContactHint':
    'Contatto aziendale dall’imprint — non una persona di riferimento.',
  'agent.run.stalled': 'Sta impiegando più del solito…',
  'agent.run.interrupted': '{n} aziende consegnate — ricerca terminata in anticipo',
  'agent.run.qualifierDown':
    'La nostra fase di qualificazione era momentaneamente non disponibile — colpa nostra, non dei tuoi criteri. Vale la pena riprovare.',
  'agent.run.recheck': 'Controlla di nuovo',
  // LEA-448 round-4
  'agent.cost.startRun':
    'fino a {n} crediti — contano solo le aziende effettivamente consegnate; quelle scartate non vengono mai addebitate',
  'agent.cost.startRunRescue':
    'secondo tentativo dopo un risultato scarso: non conta come ulteriore ricerca; come sempre vengono addebitate solo le aziende consegnate (fino a {n} crediti)',
  'agent.cost.connect':
    '{n} credito — referenti (nome, ruolo, e-mail, telefono) di questa azienda da fonti pubbliche',
  'agent.cost.pitch':
    '{n} credito — piano di acquisizione (ricerca + primo messaggio pronto all’invio) per questa azienda',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    'gratis — la ricerca non costa nulla, paghi solo quando sblocchi un referente',
  'agent.cost.scheduleReveal':
    'gratis — ogni ricerca · {cadence} · si mette in pausa da sola dopo {k} ricerche di fila senza nuove aziende o quando il saldo è vuoto · puoi fermarla in qualsiasi momento',
  'agent.cost.connectReveal':
    'gratis — i referenti vengono cercati e sono visibili dopo lo sblocco',
  'agent.cost.pitchReveal': 'gratis — il piano di acquisizione è incluso nello sblocco',
  'agent.cost.startRunPlan':
    '{runs} ricerche una dopo l’altra, fino a {per} crediti ciascuna — fino a {n} crediti in totale per fino a {leads} aziende; contano solo le aziende effettivamente consegnate e il piano si ferma dopo un risultato scarso',
  'agent.cost.connectBatch':
    'fino a {n} crediti — referenti (nome, ruolo, e-mail, telefono) di {count} aziende da fonti pubbliche; un’azienda senza un contatto raggiungibile non viene addebitata',
  'agent.cost.pitchBatch':
    'fino a {n} crediti — piani di acquisizione (ricerca + primo messaggio pronto all’invio) per {count} aziende',
  'agent.sessions.history': 'Cronologia',
  'agent.sessions.close': 'Chiudi',
  'agent.time.now': 'proprio ora',
  'agent.time.min': '{n} min fa',
  'agent.time.hour': '{n} h fa',
  'agent.time.day': '{n} g fa',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Ricerca in corso',
  'agent.run.finalizing': 'Ultimazione — quasi pronto …',
  'agent.run.preparing': 'Preparazione della ricerca …',
  'agent.run.done': 'Ricerca completata',
  'agent.run.failed': 'Ricerca non riuscita',
  'agent.run.cancelled': 'Ricerca annullata',
  'agent.run.delivered': '{n} / {total} aziende consegnate',
  'agent.run.reviewCta': 'Rivedi i lead',
  'agent.run.dismiss': 'Nascondi',
  'agent.run.step.planning': 'Pianificazione',
  'agent.run.step.discovery': 'Scoperta',
  'agent.run.step.hydration': 'Arricchimento',
  'agent.run.step.reasoning': 'Valutazione',
  'agent.run.step.delivery': 'Consegna',
  'agent.run.won': '{n} lead freschi per te!',
  'agent.run.empty': 'Nessuna azienda adatta trovata',
  'agent.rescue.head.zero': 'Questa ricerca non ha trovato aziende adatte.',
  'agent.rescue.head.lowOne':
    "Questa ricerca ha trovato solo 1 azienda adatta: puoi già dare un'occhiata.",
  'agent.rescue.head.low':
    "Questa ricerca ha trovato solo {n} aziende adatte: puoi già dare un'occhiata.",
  'agent.rescue.cause.ours':
    'È stata colpa nostra, non del tuo target: la ricerca non è andata a buon fine per un problema tecnico.',
  'agent.rescue.cause.oursQualifier':
    'È stata colpa nostra, non del tuo target: la nostra fase di verifica non era disponibile durante la ricerca, quindi le aziende trovate non sono state valutate.',
  'agent.rescue.cause.fewFound':
    "Nell'area di ricerca ({area}) abbiamo trovato solo poche aziende che corrispondono alla tua descrizione. Questo dice di più sulla nostra copertura lì che sul tuo mercato.",
  'agent.rescue.cause.harvested':
    'Le aziende che abbiamo trovato le conosci già: ti sono state consegnate in ricerche precedenti o sono nella tua lista di aziende note.',
  'agent.rescue.cause.harvestedLow':
    'Le altre aziende che abbiamo trovato le conosci già: ti sono state consegnate in ricerche precedenti o sono nella tua lista di aziende note.',
  'agent.rescue.cause.tooBroad':
    'Il tuo target non indica un settore preciso. Senza settore, la ricerca non sa quali aziende controllare.',
  'agent.rescue.cause.filtered':
    'Abbiamo trovato delle aziende, ma nessuna soddisfaceva i tuoi criteri (settore, dimensione o regione).',
  'agent.rescue.cause.filteredLow':
    'Le altre aziende che abbiamo trovato non soddisfacevano i tuoi criteri (settore, dimensione o regione).',
  'agent.rescue.cause.unknown': 'Non siamo riusciti a stabilire con certezza il motivo.',
  'agent.rescue.freeRule':
    'Le ricerche fallite non costano mai nulla: senza aziende consegnate non viene addebitato nulla. E il nuovo tentativo non conta come ulteriore ricerca.',
  'agent.rescue.pick': 'La mia proposta: con un clic parte la nuova ricerca:',
  'agent.rescue.noOption.tooBroad':
    'Dimmi un settore o un mestiere preciso e perfezioniamo insieme il target.',
  'agent.rescue.noOption.wide':
    "L'area di ricerca è già ampia quanto ha senso: un altro tentativo con gli stessi criteri molto probabilmente non porterebbe nulla di nuovo.",
  'agent.rescue.thin.zero':
    'Anche il secondo tentativo non ha trovato aziende adatte. Questo indica che per questa combinazione esistono pochissime aziende reperibili pubblicamente: un altro tentativo con gli stessi criteri non cambierebbe nulla.',
  'agent.rescue.thin.low':
    'Anche il secondo tentativo non ha trovato quasi nessuna azienda adatta ({n} consegnate). Questo indica che per questa combinazione esistono poche aziende reperibili pubblicamente: un altro tentativo con gli stessi criteri non cambierebbe nulla.',
  'agent.rescue.thin.next':
    "Ha più senso un altro approccio: per esempio un settore affine o un'altra regione.",
  'agent.rescue.opt.same': 'Riavvia la stessa ricerca',
  'agent.rescue.opt.widen': "Allarga l'area: {area} (invece che solo {from})",
  'agent.rescue.opt.dach': "Allarga l'area: Germania, Austria e Svizzera",
  'agent.rescue.opt.dachFrom':
    "Allarga l'area: Germania, Austria e Svizzera (invece che solo {from})",
  'agent.rescue.opt.industry': 'Cerca di nuovo con il settore «{industry}»',
  'agent.rescue.chip.market': 'Proviamo «{market}» come target',
  'agent.rescue.chip.rethink': 'Aiutami a ripensare il target',
  'agent.rescue.unavailable': 'Questo secondo tentativo non è più disponibile',
  'agent.rescue.card.note':
    'Non conta come ulteriore ricerca: come sempre vengono addebitate solo le aziende consegnate',
  'agent.rescue.card.noteFree': 'Secondo tentativo gratuito: non conta come ulteriore ricerca',
  'agent.rescue.oursRetryLater':
    'Riprova tra qualche minuto: le aziende non consegnate non vengono mai addebitate.',
  'agent.rescue.card.used': 'Avviata',
  'agent.rescue.card.aria': 'Proposte per un secondo tentativo',
  'agent.rescue.preparing': 'Sto guardando cosa non ha funzionato …',
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Il tuo slancio',
  'agent.momentum.audiences': 'Target',
  'agent.momentum.searches': 'Ricerche',
  'agent.momentum.leads': 'Lead',
  'agent.momentum.contacts': 'Contatti',
  'agent.momentum.pitches': 'Outreach',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'I tuoi lead — quali sono adatti?',
  'agent.leads.rated': '{done}/{total} valutati',
  'agent.leads.accept': 'Adatto',
  'agent.leads.reject': 'Non adatto',
  'agent.leads.accepted': 'Adatto',
  'agent.leads.rejected': 'Non adatto',
  'agent.leads.contacts': '{n} contatti',
  'agent.leads.openAll': 'Vedi tutti nel dettaglio',
  'agent.leads.done': 'Ottimo — tutti valutati! Questo affina la tua prossima ricerca.',
  'agent.leads.chainConnect': '→ Trova i decisori per i tuoi risultati ({n})',
  'agent.leads.chainMsg': 'Trova i contatti per: {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Tasso di successo {pct}%',
  'agent.pulse.rising': 'sale',
  'agent.pulse.detail': '{accepted} su {rated} lead corrispondono · {profiles} target',
  'agent.pulse.nudge':
    'Valuta i tuoi lead con 👍/👎 — così imparo il tuo tasso di successo e miglioro a ogni ricerca.',
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Sì, crealo così',
  'agent.chip.adjustDraft': 'Affina il target',
  'agent.chip.startRun': 'Avvia ricerca',
  'agent.chip.reviewLeads': 'Rivedi i lead',
  'agent.chip.msg.confirmDraft': 'Sì, crea il profilo esattamente così.',
  'agent.chip.msg.adjustDraft': 'Vorrei ancora modificare il target.',
  'agent.chip.msg.startRun': 'Avvia ora la ricerca per questo profilo.',
  'agent.chip.msg.startRunNamed': 'Avvia ora la ricerca per il target «{name}».',
  'agent.chip.msg.reviewLeads': 'Rivediamo i lead consegnati.',
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Rimuovi',
  'dash.cortex.editHint':
    'Rimuovi i chip con × o aggiungine altri, così Leadscraper coglie la tua offerta con più precisione (max 8 per colonna).',
  'dash.cortex.descLabel': 'Descrizione',
  'dash.cortex.changeUrl': 'Analizza un altro sito',
  'dash.cortex.editSaved': 'Profilo aziendale aggiornato',
  'dash.cortex.addPlaceholder': 'aggiungi…',
  'dash.cortex.capReached': 'Max 8 raggiunti',
  'pd.target.edit': 'Ridescrivi',
  'pd.target.editHint':
    'Descrivi i tuoi clienti ideali in 1–2 frasi. Leadscraper ne rideduce settore, regione e referente.',
  'pd.target.editPlaceholder':
    'es. produttori di imballaggi, a livello nazionale, 50–250 dipendenti, direzione',
  'pd.target.reparsing': 'Leadscraper sta pensando …',
  'pd.target.saved': 'Target aggiornato',
  'pd.target.saveError': 'Aggiornamento non riuscito: riprova.',

  // W21/W22 Dossier — audience page as a self-writing dossier
  // (Claude-Design-Handover 03.07.2026). Area 1: dossier card.
  'dos.eyebrow': 'Il tuo target · scritto da te e da Leadscraper',
  'dos.maturity.coldStart': 'Ti sta conoscendo',
  'dos.maturity.early': 'Primo quadro',
  'dos.maturity.calibrated': 'Calibrato',
  'dos.maturity.mature': 'Maturo',
  'dos.ratings': '{n} valutazioni',
  'dos.matchRate': '{pct}% tasso di corrispondenza',
  'dos.weak': 'debole',
  'dos.edit.cta': 'Modifica target',
  'dos.weave.youSearch': 'Stai cercando',
  'dos.weave.vorgabeLabel': 'La tua indicazione · dal tuo briefing',
  'dos.weave.withSize': 'con {size} dipendenti',
  'dos.weave.sizeValue': '{range} dipendenti',
  'dos.weave.inRegion': 'in {region}',
  'dos.weave.contact': 'referente',
  'dos.weave.prefers': 'con preferenza per',
  'dos.weave.and': 'e',
  'dos.weave.weakHint': 'primo indizio:',
  'dos.legend.you': 'la tua indicazione',
  'dos.legend.learned': 'appreso: numero = prove, cliccabile',
  'dos.legend.weak': 'debole (1–2 prove)',
  'dos.emptyLearned':
    'Ancora nulla di appreso: valuta qui sotto i tuoi primi lead, poi questo dossier continua a scriversi da solo.',
  'dos.heartbeat.active': 'Sta imparando attivamente',
  'dos.heartbeat.waiting': 'In attesa delle tue prime valutazioni',
  'dos.heartbeat.since': 'da {date}',
  'dos.heartbeat.next': 'prossima analisi a {n} valutazioni',
  'dos.proof.title': 'Le tue {n} aziende accettate',
  'dos.proof.openAll': 'Vedi tutti nella board',
  'dos.error.learn': 'I dati di apprendimento non sono al momento raggiungibili.',
  'dos.error.retry': 'Riprova',
  'dos.details.show': 'Tutti i {n} pattern nel dettaglio ↓',
  'dos.details.hide': 'Nascondi dettagli',
  'dos.aside.patterns': 'Pattern nel dettaglio',
  'dos.kpi.title': 'Il tuo pubblico in numeri',
  'dos.kpi.match': 'Successo',
  'dos.kpi.reachable': 'Raggiungibili',
  'dos.kpi.reachableSub': '{n} di {m} richieste',
  'dos.kpi.reachableTeaser': 'Dopo la prima richiesta di contatto',
  'dos.kpi.yield': 'Per ricerca',
  'dos.kpi.yieldSub': '{n} ricerche',
  'dos.kpi.matchTeaser': 'da {p} valutazioni',
  'dos.journey.eyebrow': 'Così nasce il tuo dossier',
  'dos.journey.s1': 'Pubblico descritto',
  'dos.journey.s1Sub': 'Registrato con precisione: Leadscraper sa cosa cercare.',
  'dos.journey.s2': 'Ricevi i primi lead',
  'dos.journey.s2Sub': 'Avvia la prima ricerca: le prime aziende arrivano in pochi minuti.',
  'dos.journey.s2Done': '{n} lead pronti.',
  'dos.journey.s2Running': 'La tua ricerca è in corso: le prime aziende arriveranno a breve.',
  'dos.journey.s2RunningBadge': 'Ricerca in corso · di solito 5–12 min',
  'dos.journey.s3': 'Valuta i primi {p} lead',
  'dos.journey.s3Progress': '{n} su {p} lead valutati',
  'dos.journey.s3Sub':
    'Con {p} valutazioni Leadscraper scrive qui la sua prima analisi; da {a} il tuo feedback guida ogni ricerca.',
  'dos.voice.preview':
    'Dopo le prime {p} valutazioni, Leadscraper scriverà qui la sua valutazione del tuo pubblico.',
  'dos.voice.more': 'Continua a leggere',
  'dos.voice.less': 'Mostra meno',
  'dos.analysis.pending':
    'Leadscraper sta analizzando le tue {n} valutazioni: la prima valutazione apparirà qui a breve.',
  'dos.heartbeat.analysing': 'Analisi delle tue valutazioni …',
  // Dossier — popover delle prove
  'dos.popover.close': 'Chiudi',
  'dos.popover.evidence': '{n} prove',
  'dos.popover.weakChip': 'debole · {n} prove',
  'dos.popover.view': 'vedi ↗',
  'dos.popover.noExamples':
    'Per questo pattern non sono salvati lead di prova singoli: il numero conta le tue valutazioni.',
  'dos.popover.weakNote': 'Solo {n} prove: entra ancora con cautela nella ricerca.',
  // Dossier — Area 2: valuta ora
  'dos.rate.eyebrow': 'Valuta ora',
  'dos.rate.waiting': '{n} lead aspettano il tuo giudizio',
  'dos.rate.waitingOne': '1 lead aspetta il tuo giudizio',
  'dos.rate.openBoard': 'Apri tutti nella board →',
  'dos.rate.sub': 'Ogni valutazione affina il dossier, direttamente qui, senza lasciare la pagina.',
  'dos.rate.fits': 'Si adatta al mio target',
  'dos.rate.fitsNot': 'Non si adatta',
  'dos.rate.view': 'vedi',
  'dos.rate.acceptedCheck': '✓ Accettato',
  'dos.rate.learned': ', il dossier ha imparato:',
  'dos.rate.flowsIn': ', confluisce nella prossima analisi.',
  'dos.rate.undo': 'Annulla',
  'dos.rate.whyQuestion': 'Cosa non andava? Basta un tocco: Leadscraper impara da questo.',
  'dos.rate.noReason': 'Continua senza motivo',
  'dos.rate.allDone': 'Tutto valutato: nuovi lead appariranno qui appena una ricerca ne trova.',
  'dos.rate.rejectedCheck': '✗ Scartato',
  'dos.rate.avoidedLearned': ', il dossier ora evita:',
  'dos.reason.industry': 'Settore sbagliato',
  'dos.reason.tooBig': 'Troppo grande',
  'dos.reason.tooSmall': 'Troppo piccola',
  'dos.reason.region': 'Regione sbagliata',
  'dos.reason.role': 'Ruolo sbagliato',
  'dos.reason.other': 'Altro',
  // Dossier — Area 3: prossime ricerche
  'dos.sug.eyebrow': 'Derivato dai tuoi pattern',
  'dos.sug.title': 'Le tue prossime ricerche',
  'dos.sug.basis.expansion': 'Espansione',
  'dos.sug.basis.crossSell': 'Cross-sell',
  'dos.sug.basis.zoomOut': 'Zoom-out',
  'dos.sug.basis.patternHint': 'Indizio di pattern',
  'dos.sug.basis.salesFit': 'Sales-fit',
  'dos.sug.tier.veryStrong': 'molto forte',
  'dos.sug.tier.strong': 'forte',
  'dos.sug.tier.solid': 'solida',
  'dos.sug.tier.hypothesis': 'debole',
  'dos.sug.fitLabel': 'corrispondenza attesa',
  'dos.sug.start': 'Avvia ricerca',
  'dos.sug.history': '{n} ricerche precedenti',
  'dos.sug.historyOne': '1 ricerca precedente',
  'dos.sug.showHistory': 'Vedi cronologia →',

  'common.close': 'Chiudi',
  'common.selected': 'Selezionato',
  'credit.balanceTitle': 'Il tuo saldo crediti',
  'credit.available': 'disponibili',
  'det.trigger.cat.serviceRadius': 'Area di servizio',
  'det.trigger.cat.specialization': 'Specializzazione',
  'det.trigger.cat.capacity': 'Capacità',
  'det.trigger.cat.history': 'Storico',
  'det.trigger.cat.partnership': 'Partnership',
  'det.trigger.cat.certification': 'Certificazione',
  'det.trigger.cat.other': 'Altro',
  'lead.removeContactTitle': 'Perché rimuovere?',
  'lead.actionNeedPlan': 'Genera prima un piano di acquisizione',
  'lead.actionNoEmail': 'Nessun indirizzo email per il contatto prioritario',
  // scraper run experience + API errors (LEA-302) — see de.ts for context
  'scraper.act.loadProfile': 'Carico il tuo profilo + valutazioni precedenti…',
  'scraper.act.firstFeedbacks':
    'Raccolta prime valutazioni: da 10 in poi Cortex apprende i tuoi pattern di accettazione/rifiuto.',
  'scraper.act.feedbacksCollected':
    '{seen} valutazioni raccolte: personalizzazione attiva da {activeAt} valutazioni per profilo. Questa ricerca procede ancora senza pattern override.',
  'scraper.act.patternsActive':
    '{seen} valutazioni · {accepted} pattern accettazione · {rejected} pattern rifiuto attivi nel reasoning',
  'scraper.act.planning':
    'Pianificazione strategia di ricerca: quali fonti + query coprono al meglio la tua richiesta?',
  'scraper.act.aiSearchTempError':
    'Ricerca AI ha avuto un problema temporaneo (rete/timeout). Riprova.',
  'scraper.act.aiSearchUnavailable':
    'Ricerca AI attualmente non disponibile (problema configurazione). Contatta il supporto.',
  'scraper.act.aiSearchBadFormat': 'Ricerca AI ha restituito un formato non valido. Riprova.',
  'scraper.act.aiSearchFailed': 'Ricerca AI fallita ({reason}). Riprova.',
  'scraper.act.reasonUnknown': 'sconosciuto',
  'scraper.act.researcherAnalyzing': "L'IA Researcher sta analizzando la tua ricerca…",
  'scraper.act.researcherFound': 'IA Researcher: {n} aziende verificate identificate',
  'scraper.act.goal': 'Obiettivo: {goal}',
  'scraper.act.strategy': 'Strategia: {strategy}',
  'scraper.act.reasoning': 'Ragionamento: {reasoning}',
  'scraper.act.srcCurated': '⭐ Fonte curata',
  'scraper.act.srcOwn': '💡 Suggerimento proprio',
  'scraper.act.srcKindRegister': 'Registro',
  'scraper.act.srcKindDirectory': 'Directory',
  'scraper.act.srcKindPortal': 'Portal',
  'scraper.act.source': '{tag}: {label} [{kind}]',
  'scraper.act.googleSearch': 'Google-Suche: „{q}"',
  'scraper.act.googleMaps': 'Google Maps: „{q}"{location}',
  'scraper.act.googleNews': 'Google News: „{q}"',
  'scraper.act.researcherEnough':
    "L'AI-Researcher è sufficiente ({n} aziende): salto le ricerche Google aggiuntive",
  'scraper.act.researcherIdentified':
    "L'AI-Researcher ha identificato {n} aziende: salto le ricerche Google",
  'scraper.act.researcherNone':
    "L'AI-Researcher non ha trovato aziende corrispondenti: la query di ricerca è molto di nicchia. Prova con un profilo più ampio o una regione meno specifica.",
  'scraper.act.companyIdentified': 'Azienda identificata: {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Arricchisco {n} aziende con dati di base (indirizzo, dimensioni, tech stack)...',
  'scraper.act.enrichCompany': 'Reichere Firma {idx}/{total} an: {domain}',
  'scraper.act.phase1Light':
    'Phase-1-Light: {n} Firmen identifiziert in {secs}s. Adresse/Größe/Details werden bei Bedarf nachgescraped.',
  'scraper.act.serperExhausted':
    '⚠ Serper-Credits aufgebraucht: Discovery limited. Auf serper.dev/dashboard nachladen.',
  'scraper.act.mapsHits': '{n} Maps-Treffer für „{query}"',
  'scraper.act.searchHitsCollected': '{n} Treffer aus Google-Suche eingesammelt',
  'scraper.act.directoriesFound':
    '{n} directory settoriali trovate: estrazione delle aziende elencate…',
  'scraper.act.searchingPortal': 'Ricerca su {host} per aziende elencate…',
  'scraper.act.minedCompanies': '{n} aziende estratte da {portal}',
  'scraper.act.onlyPortals':
    'Nessuna azienda operativa identificata: tutti i risultati erano portali',
  'scraper.act.queryInfeasible': 'Cortex considera la query non fattibile: {reason}',
  'scraper.act.rethinking': 'Cortex ci ripensa (Ciclo {round}): {reason}',
  'scraper.act.searchingPortalNew': 'Ricerca in {host} (nuovo step del piano) …',
  'scraper.act.minedPortalRound': '{n} aziende da {host} (Ciclo Reflector {round})',
  'scraper.act.backlogResumed': '{n} candidati dal backlog di precedenti run ripresi',
  'scraper.act.companiesIdentifiedAgg':
    '{n} aziende identificate: {rescued}/{attempted} recuperate da portali aggregatori, avvio analisi approfondita',
  'scraper.act.companiesIdentified': '{n} aziende identificate: avvio analisi approfondita',
  'scraper.act.handelsregisterChecked': 'Estratto registro imprese verificato: {hrb}',
  'scraper.act.scanningWebsite': 'Analisi del sito web: {domain}',
  'scraper.act.relatedPages': '{n} pagine aggiuntive analizzate: {domain}',
  'scraper.act.deepAnalysis': 'Analisi aziendale approfondita: {name}',
  'scraper.act.pipelineStarted':
    'Pipeline avviata: {n} candidati passano in parallelo attraverso idratazione + valutazione',
  'scraper.act.allDroppedPrefilter':
    "Tutte le {n} aziende trovate sono state scartate come non adatte (settore/regione). Affina il tuo target o prova un'altra regione.",
  'scraper.act.noCompaniesFound':
    'La discovery non ha trovato aziende per questa ricerca. Affina il tuo target.',
  'scraper.act.phase1OnlyRun': 'Run solo fase 1: {n} leads identificati. Fase 2 + 3 saltate.',
  'scraper.act.leadsDeliveredEnriching':
    '{n} leads consegnati: Cortex sta ancora arricchendo (piano acquisizione, punteggi, ricerca approfondita)',
  'scraper.act.deeperResearch': 'Ricerca approfondita: {name} · {findings} da {sources} fonti',
  'scraper.act.coldStart': 'Cold-Start (nessun run precedente)',
  'scraper.act.runHistory':
    '{runs} run precedenti · {delivered} già consegnati · {dropped} già scartati',
  'scraper.act.buyerProfile': 'Profilo acquirente: {narrative} (Confidenza: {confidence})',
  'scraper.act.confHigh': 'alta',
  'scraper.act.confMid': 'media',
  'scraper.act.confLow': 'bassa',
  'scraper.act.subsidiary':
    'Filiale DACH rilevata: {domain} ({src}), sarà utilizzata per la ricerca contatti.',
  'scraper.act.subsidiarySrcDirect': 'verificata direttamente',
  'scraper.act.subsidiarySrcGoogle': 'via ricerca Google',
  'scraper.rq.harvestedMsg':
    'Target temporaneamente esaurito: run precedenti hanno già fornito {prior} aziende adatte.',
  'scraper.rq.harvestedRec':
    'Cortex ha già trovato le aziende conosciute. Nuovi risultati arriveranno quando nuove aziende del tuo target diventano visibili online, lo schedule le raccoglierà automaticamente.',
  'scraper.rq.noMarketMsg':
    "Solo {n} aziende trovate nell'intero web per la ricerca. Questo target non sembra essere pubblicamente identificabile: forse troppo specifico o dati aziendali interni.",
  'scraper.rq.noMarketRec':
    'Prova a formulare più ampiamente o combina con settori look-alike. Lo schedule non vale la pena per questa query.',
  'scraper.rq.tooNicheMsg':
    'Solo {n} aziende potenziali nel mercato: il tuo target è molto di nicchia.',
  'scraper.rq.tooNicheRec':
    'Lo schedule vale la pena solo per target con 50+ aziende. Considera regioni più ampie o più varianti settoriali.',
  'scraper.rq.qualifierDownMsg':
    'La valutazione tramite IA non era raggiungibile durante questa ricerca, quindi le {n} aziende trovate non hanno potuto essere valutate: è un problema tecnico dalla nostra parte, non un giudizio sul tuo mercato.',
  'scraper.rq.qualifierDownRec':
    'Riavvia la ricerca tra qualche minuto. Non serve modificare i criteri: questa volta nessuna azienda è stata effettivamente valutata.',
  'scraper.rq.unmatchedMsg':
    '{n} aziende analizzate: nessuna corrispondeva ai tuoi criteri (settore, dimensione, regione).',
  'scraper.rq.unmatchedRec':
    "Controlla descrizione: criteri troppo rigidi? L'accettazione look-alike non aiuta perché nessun look-alike era plausibile.",
  'scraper.sum.delivered':
    '{n} leads consegnati ({hard} sicuri{softFrag}) da {total} aziende analizzate.',
  'scraper.sum.softFragment': ', {soft} possibilmente rilevanti',
  'scraper.sum.deliveredNiche':
    '{n}/10 leads consegnati: il target è di nicchia (solo {total} aziende identificate nel mercato).',
  'scraper.sum.nicheRec':
    'Normale per schedule ricorrenti, nuovi risultati emergono nel tempo. Se hai bisogno di più volume: considera regioni più ampie o settori correlati.',
  'scraper.sum.deliveredDropped':
    '{n}/10 leads consegnati: Cortex ha scartato {dropped} altri candidati come non adatti.',
  'scraper.sum.droppedRec':
    'Se vuoi più volume: formula descrizione più flessibile o accetta look-alikes/soft-keeps.',
  'scraper.sum.deliveredMixed': '{n}/10 leads consegnati: rendimento misto da {total} aziende.',
  'scraper.sum.mixedRec':
    'Normale per schedule ricorrenti: Cortex raccoglie altri risultati nel tempo.',
  'scraper.sum.noneMatched': '{total} aziende analizzate: nessuna corrispondeva ai tuoi criteri.',
  'scraper.sum.noneMatchedRec':
    'Controlla descrizione: criteri troppo rigidi o prova altra regione.',
  'scraper.mem.active': 'Attivamente personalizzato · {n} valutazioni',
  'scraper.mem.analyzing': 'In fase di rianalisi · {n} valutazioni',
  'scraper.mem.firstImpression': 'Prima impressione · {n}/{active} per essere attivo',
  'scraper.mem.learning': 'Impara con te · {n}/{preview} per anteprima',
  'scraper.reflector.fallback':
    'Reflector non disponibile: query segnalata come non fattibile per evitare attese infinite.',
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    'Leadscraper trova aziende e i decisori al loro interno — non forniamo privati.',
  'apierr.b2cPivot': "Un'alternativa possibile: {pivot}",
  'apierr.junkQuery':
    'Per favore descrivi concretamente CHI stai cercando: es. "Panetterie a Milano" o "Commercialisti Lombardia 5-50 dipendenti". Termini generici come "B2B", "Test", "Profilo" o testi con errori di battitura non sono accettati.',
  'apierr.invalidWebsite': 'Per favore inserisci un sito web valido (es. mia-azienda.it)',
  'apierr.noUserCompanyStep1': 'Prima analizza il sito web (Passaggio 1).',
  'apierr.noUserCompany': 'Prima analizza il sito web.',
  'apierr.insufficientPhase': 'Ti servono {cost} Credits per questa fase. Attuali: {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    'Sblocca prima i contatti di questa azienda — il piano di acquisizione è incluso.',
  'apierr.planGenFailed': 'Impossibile generare il piano di acquisizione. Nessun Credit consumato.',
  'apierr.urlParse': "Impossibile elaborare l'URL.",
  'apierr.urlIncomplete': 'Inserisci un URL completo.',
  'apierr.dupCompany': 'Hai già creato questa azienda{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable':
    'Il sito web non era raggiungibile durante la creazione: impossibile recuperare i dati.',
  'apierr.manualPhase1Failed':
    'Fase 1 fallita (sito web non raggiungibile). Riprova tramite "Aggiorna dati".',
  'apierr.cancelRequested': 'Annullamento richiesto. Sarà effettivo al prossimo checkpoint.',
  'apierr.noCredits': 'Nessun Credit disponibile. Sottoscrivi un abbonamento o acquista Credits.',
  'apierr.rescueNotAvailable':
    'Il secondo tentativo gratuito per questa ricerca non è (più) disponibile.',
  'apierr.intentParse':
    'Non è possibile estrarre un settore specifico dalla tua descrizione "{desc}". Sii più preciso: ad esempio invece di "Milano" → "Panetterie a Milano" o "Commercialisti a Milano".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': 'Piano di acquisizione',
  'det.creatingPlan': 'Cortex sta creando il tuo piano di acquisizione…',
  'det.planLoadTime':
    'Di solito 30-60 secondi: nessun ricaricamento necessario, appare automaticamente',
  'det.planUncertaintyWarning': 'Nota: il testo del piano contiene incertezze',
  'det.companyClassification': "Classificazione dell'azienda",
  'det.opportunities': 'Opportunità',
  'det.risksAndDealbreakers': 'Rischi / fattori critici',
  'det.channelMix': 'Mix di canali · sequenza di 7 giorni',
  'ld.sparkle.sampleMessageLabel': 'Messaggio di esempio per il primo contatto',
  'ld.sparkle.sampleMessageCopied': 'Messaggio di esempio copiato.',
  'common.copy': 'copia',
  'ld.sparkle.messageSubject': 'Oggetto: ',
  'ld.lean.urteil': 'Perché questo lead',
  'ld.lean.winkel': 'Il tuo angolo',
  'ld.lean.kontakte': 'Chi per primo',
  'ld.lean.nachricht': 'Primo contatto · pronto da inviare',
  'ld.lean.nachrichtShort': 'Bozza di primo contatto',
  'ld.lean.telefon': 'Apertura telefonica',
  'ld.lean.check': 'Prima di inviare',
  'ld.lean.copyAI': 'Copia per l’IA',
  'ld.lean.copyAITitle':
    'Copia il piano, i dati pubblici di azienda e contatti e il tuo profilo d’offerta come handover per ChatGPT, Claude & co.',
  'ld.lean.copiedAI': 'Handover copiato: incollalo nel tuo strumento IA',
  'ld.lean.varMain': 'Consigliata',
  'ld.lean.sendMail': 'Invia come e-mail',
  'ld.lean.sendMailTitle':
    'Apre il tuo programma di posta con {addr}, oggetto e testo precompilati',
  'ld.lean.zentrale': 'Centralino',
  'ld.lean.nameNotPublic': 'nome non pubblico',
  'ld.lean.verifiziert': 'verificato',
  'ld.lean.chEmail': 'E-mail',
  'ld.lean.chTelefon': 'Telefono',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'Sei il mio copilota commerciale per questo specifico lead. Qui sotto trovi tutti i dati che il mio strumento (Leadscraper) ha ricercato da fonti pubbliche e preparato come piano di acquisizione: usali direttamente, non chiederli prima.\n\nMarcatori: ✓ = verificato pubblicamente (sito, note legali, LinkedIn, registro), ~ = ipotesi senza fonte solida. Mantieni questa distinzione e non inventare nulla su azienda o contatto.\n\nPuoi aiutarmi a rifinire il messaggio di primo contatto, creare uno script di chiamata, provare le obiezioni o preparare il follow-up.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Dati disponibili',
  'ld.ai.secContacts': 'Contatti',
  'ld.ai.secCompany': 'La mia azienda',
  'ld.ai.secPlan': 'Piano di acquisizione',
  'ld.ai.secUncertain': 'Incertezze e da verificare',
  'ld.ai.secTask': 'Cosa mi serve da te',
  'ld.ai.taskBody':
    'Parti subito: rifinisci il messaggio di primo contatto qui sopra con il mio tono e proponi UN miglioramento concreto che aumenti il mio tasso di risposta.',
  'ld.ai.company': 'Azienda',
  'ld.ai.industry': 'Settore',
  'ld.ai.size': 'Dimensione',
  'ld.ai.region': 'Regione',
  'ld.ai.dataAsOf': 'Dati aggiornati al: ricercato il {date}',
  'det.recommendedNextStep': 'Prossimo passo consigliato',
  'det.botProtectionWarning':
    'Questo sito web aveva la protezione anti-bot attiva: non siamo riusciti a estrarre direttamente la pagina di note legali/contatti. I dati mostrati qui sono stati raccolti da fonti pubbliche (Google, directory di settore) e potrebbero essere meno precisi dei dati diretti delle note legali.',
  'det.possibleNotVerified': 'Possibile: non verificabile al 100%',
  'det.noJustificationYet':
    'Ancora nessuna motivazione: per questo lead non è stato possibile eseguire il buyer matching (profilo utente incompleto o sito web non raggiungibile). Avviare le fasi 2/3 recupererà più dati.',
  'det.offering': 'Offerta',
  'det.nicheSignals': 'Segnali di nicchia',
  'det.niche.signalsOne': '1 segnale',
  'det.niche.signalsMany': '{n} segnali',
  'det.vatId': 'P. IVA: ',
  'det.revenue': 'Fatturato ',
  'det.agency': 'Agenzia',
  'det.distributor': 'Distributore',
  'det.stack': 'Stack:',
  'det.webDesign': 'Web design:',
  'det.masteryBusiness': 'Impresa con qualifica di maestro artigiano',
  'det.guild': 'Corporazione: ',
  'det.imprintVerified': '✓ Note legali verificate',
  'det.sealsOfQuality': 'Marchi di qualità:',
  'det.social': 'Social:',
  'det.verifyingContacts': 'Verifica dei contatti…',
  'det.inferringPattern': 'Inferenza del pattern…',
  'det.emailPatternPlaceholder': '{nome}.{cognome}@azienda.de',
  'det.sales': 'Vendite',
  'det.marketing': 'Marketing',
  'det.engineering': 'Tecnico',
  'det.finance': 'Finanza',
  'det.management': 'Direzione',
  'det.procurist': 'Procuratore',
  'det.contactRemoved': 'rimosso: non verrà più consegnato.',
  'det.percentSure': '% di certezza',
  'det.foundIn': 'trovato in:',
  'det.recommendedChannel': 'Canale consigliato',
  'det.tier1': 'Livello 1 · raggiungibile direttamente',
  'det.tier2': 'Livello 2 · canale di profilo',
  'det.tier3': 'Livello 3 · tramite sede centrale',
  'det.tier4': 'Livello 4 · contatto di riserva',
  'det.tier5': 'Livello 5 · solo instradamento aziendale',
  'det.inferred': '⚠ presunto',
  'det.companyCentral': '(Sede centrale)',
  'det.quality.title': 'Qualità del lead',
  'det.quality.company': 'Azienda',
  'det.quality.contact': 'Contatto',
  'det.quality.noContacts':
    'Nessun decisore verificabile pubblicamente per questa azienda: Leadscraper non inventa contatti.',
  'det.quality.companyFitPlain': 'Settore, regione e dimensione corrispondono alla tua ricerca.',
  'det.quality.companyFitSoft':
    'Settore e regione coincidono, non ancora del tutto chiaro su ogni criterio.',
  'det.quality.noContactsCentral': 'Resta raggiungibile tramite il centralino (vedi contatto).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': 'Verifica prima il contatto',
  'det.quality.lockedPlanCreate': 'Crea prima il piano di acquisizione',
  'ld.sparkle.conversationOpener': 'Apertura della conversazione',
  'ld.sparkle.openerCopied': 'Apertura copiata.',
  'lt.next.contactVerificationStarted': 'Verifica del contatto avviata …',
  'lt.next.contactVerificationLabel': 'Verifica del contatto',
  'lt.next.planGenerationStarted': 'Generazione del piano di acquisizione avviata …',
  'lt.next.planGenerationLabel': 'Generazione del piano di acquisizione',
  'lt.next.verifiedNoContacts': 'Verificato: nessun contatto trovato',
  // LEA-379 i18n#5 (Om QA): lead-card loading status — these keys existed only in
  // de/en, so IT fell back to German. Copy is tweakable — flag Janik if off.
  'lt.loading.connecting': 'Ricerca dei contatti …',
  'lt.loading.planning': 'Generazione del piano di acquisizione …',
  'lt.loading.adding': 'Aggiunta …',
  'lt.loading.verifying': 'Verifica …',
  'lt.loading.connectingLive': 'Verifica dei contatti …',
  'lt.loading.planningLive': 'Creazione del piano di acquisizione …',
  'det.size.employees': 'dipendenti',
  'det.since': 'dal ',

  // ── Prism-Funnel (Stage C i18n-Extraktion, /dev/prism-demo) ──────────────
  // Allgemein / Kicker
  'prism.kicker.account': 'Account creato',
  'prism.kicker.waiting': 'I tuoi primi clienti ti aspettano',
  'prism.audienceFallback': 'il tuo target',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang.
  'billing.tripwire.lineItem.name': 'Leadscraper · Pacchetto iniziale 50 lead',
  'billing.tripwire.lineItem.desc': '50 lead verificati, pronti da contattare.',
  'prism.a11y.close': 'Chiudi',
  // Schritt 1 — Zielgruppe
  'prism.target.eyebrow': 'Passo 1 di 3 · Target',
  'prism.target.title': 'Chi vuoi raggiungere?',
  'prism.target.titleGrad': 'Li troviamo subito.',
  'prism.target.sub':
    'Descrivi in una frase chi vuoi raggiungere: la tua ricerca live si calibra esattamente sul tuo target.',
  'prism.target.label': 'Il tuo target',
  'prism.target.placeholder': 'es. titolari di studi di commercialisti in Baviera',
  'prism.target.chip.steuer': 'Studi di commercialisti in Baviera',
  'prism.target.chip.agentur': 'Agenzie di marketing in NRW',
  'prism.target.chip.handwerk': 'Imprese artigiane ad Amburgo',
  'prism.target.chipQuery.steuer': 'Titolari di studi di commercialisti in Baviera',
  'prism.target.chipQuery.agentur': 'Titolari di agenzie di marketing in NRW',
  'prism.target.chipQuery.handwerk': 'Imprese artigiane ad Amburgo',
  'prism.target.tip':
    '💡 La formula più efficace: settore + regione, es. «dentisti a Colonia». Capiamo anche ruoli come «amministratori di PMI».',
  'prism.target.suggestion': 'Intendi ad es. «{suggestion}»?',
  'prism.target.validating': 'Stiamo verificando il tuo target …',
  'prism.target.cta': 'Trova il mio target',
  'prism.target.foot': 'Gratis · nessun dato di pagamento richiesto',
  'prism.target.errFallback': 'Questo non sembra ancora un target chiaro.',
  // Schritt 2 — Website
  'prism.website.eyebrow': 'Passo 2 di 3 · Sito web',
  'prism.website.title': 'Il tuo sito web ·',
  'prism.website.titleGrad': "così l'AI ti capisce",
  'prism.website.sub':
    'Il sito della tua azienda, così capiamo cosa vendi e quali clienti fanno per te.',
  'prism.website.label': 'URL del sito',
  'prism.website.placeholder': 'https://tua-azienda.it',
  'prism.website.hint':
    'Non hai ancora un sito? Salta questo passaggio: la ricerca parte solo dal tuo target.',
  'prism.website.errInvalid': 'Questo non sembra ancora un indirizzo web: es. «tua-azienda.it».',
  'prism.website.cta': 'Analizza il sito',
  'prism.website.foot': 'Solo analisi · non pubblichiamo nulla',
  // Analyse-Phase
  'prism.analyzing.reading': "L'AI sta leggendo il tuo sito …",
  'prism.analyzing.wait': 'Stiamo affinando il tuo target …',
  'prism.analyze.step1': 'Sito caricato e letto live',
  'prism.analyze.step2': 'Modello di business riconosciuto',
  'prism.analyze.step3': 'Offerta e proposta di valore analizzate',
  'prism.analyze.step4': 'Target ideale definito',
  // Schritt 3 — Fragen
  'prism.questions.eyebrow': 'Ultimo passo · Rifinitura',
  'prism.questions.back': '← Indietro',
  'prism.questions.title': 'Una rapida conferma ·',
  'prism.questions.titleGrad': 'domanda {num} di {total}',
  'prism.questions.q1': 'Quanto grandi devono essere le aziende?',
  'prism.questions.q1o1': 'Fino a 50 dipendenti',
  'prism.questions.q1o2': 'Più di 50',
  'prism.questions.q1o3': 'Indifferente',
  'prism.questions.q2': 'Le aziende devono essere specializzate?',
  'prism.questions.q2o1': 'Sì, in un segmento',
  'prism.questions.q2o2': 'Generaliste',
  'prism.questions.q2o3': 'Indifferente',
  'prism.questions.q3': 'Dove devono trovarsi le aziende?',
  'prism.questions.q3o1': 'Solo nella mia regione',
  'prism.questions.q3o2': 'In tutta Italia',
  'prism.questions.q3o3': 'Indifferente',
  'prism.questions.yes': 'Sì, esatto',
  'prism.questions.no': 'Non proprio',
  'prism.questions.foot': 'Più la tua risposta è precisa, più i tuoi primi lead saranno mirati.',
  // Such-Phase
  'prism.searching.label': 'aziende trovate nel tuo target …',
  // Wave 2: concrete/procedural so the endless rotation doesn't feel "stuck" —
  // 6 true process steps instead of 4.
  'prism.searching.wait1': 'Verifica della pertinenza dei risultati …',
  'prism.searching.wait2': 'I risultati deboli vengono scartati …',
  'prism.searching.wait3': 'Verifica dei duplicati in corso …',
  'prism.searching.wait4': 'Verifica dell’accessibilità dei siti …',
  'prism.searching.wait5': 'Confronto delle sedi …',
  'prism.searching.wait6': 'Unione dei profili aziendali …',
  'prism.search.step1': 'Ricerche pianificate per il tuo target',
  'prism.search.step2': 'Aziende raccolte tramite ricerca web e mappe',
  'prism.search.step3': 'Portali, elenchi e duplicati esclusi',
  'prism.search.step4': 'Coerenza dei risultati migliori con il tuo target valutata',
  'prism.search.step5': 'Siti web dei risultati migliori verificati live',
  'prism.search.step6': 'Regione e tipo di azienda dei risultati migliori ricontrollati',
  'prism.search.step7': 'Risultati deboli scartati',
  'prism.search.step8': 'Plausibilità del risultato verificata',
  'prism.search.step9': 'Selezionati i risultati più forti',
  'prism.search.n.companies': '{count} aziende',
  'prism.search.n.ap': '{count} referenti',
  'prism.search.n.valid': '{count} validi',
  'prism.search.n.revenue': '~{count} mln €',
  'prism.search.n.top': 'Top 50',
  // Fit-Score-Labels
  'prism.score.perfect': 'Fit perfetto',
  'prism.score.outstanding': 'Fit eccezionale',
  'prism.score.veryStrong': 'Fit molto forte',
  'prism.score.good': 'Buon fit',
  'prism.score.titleAttr': 'Fit score {score}/100',
  // Refine-Screen (Engine schwach)
  'prism.refine.title': 'Non ancora abbastanza risultati: perfezioniamo insieme.',
  'prism.refine.body': 'Per {audience} non abbiamo ancora trovato abbastanza aziende convincenti.',
  'prism.refine.hint1': "Rendi più preciso il tuo target: l'ideale è",
  'prism.refine.hintStrong': 'settore + regione',
  'prism.refine.hint2':
    '(es. «studi di commercialisti in Baviera», «studi dentistici ad Amburgo», «imprese edili in Sassonia»). Più sei preciso, più aziende reali troviamo per te.',
  'prism.refine.try': 'Questi funzionano già bene, basta un clic:',
  // F9: schermata 429 — limite giornaliero, detto onestamente (non è un refine di qualità).
  'prism.rateLimit.title': 'Hai raggiunto il limite giornaliero di ricerche live.',
  'prism.rateLimit.body':
    'Questo non ha nulla a che fare con il tuo target: limitiamo le ricerche live gratuite al giorno. Il tuo target e il tuo sito restano salvati.',
  'prism.rateLimit.reset': 'Il tuo limite si azzera alle {time}.',
  'prism.rateLimit.cta': 'Torna all’inizio',
  // D2 (LEA-430): ripresa «bentornato» + alternativa onesta al timer.
  'prism.resume.title': 'Bentornato!',
  'prism.resume.body': 'La tua ricerca per {audience} è pronta — il tuo risultato è salvato.',
  'prism.resume.cta': 'Vedi il risultato',
  'prism.resume.dismiss': 'Avvia una nuova ricerca',
  'prism.resume.saved': 'La tua selezione è salvata — senza fretta.',
  'prism.understood.title': 'La tua azienda, capita',
  'prism.understood.opps': 'Opportunità',
  // Wave 2: label above the highlighted "why now" line.
  'prism.understood.momentumLabel': 'Perché ora:',
  // DEPRECATED (Wave 2): "Da tenere d'occhio" is no longer rendered (legacy bundles).
  'prism.understood.risks': 'Da tenere d’occhio',
  'prism.understood.demoModel': 'Servizio B2B che aiuta le PMI a trovare nuovi clienti.',
  'prism.understood.demoOpp1': 'Nicchia ben definita con alto valore per cliente',
  'prism.understood.demoOpp2': 'Poca concorrenza specializzata nella regione',
  'prism.understood.demoOpp3': 'Decisori raggiungibili direttamente (team piccoli)',
  'prism.understood.demoRisk1': 'Cicli decisionali lunghi nelle PMI',
  'prism.understood.demoRisk2': 'Il primo contatto richiede un aggancio concreto',
  'prism.seed.badge': 'Pacchetto iniziale',
  'prism.seed.working': '{delivered}/{total} lead consegnati',
  'prism.seed.workingSub':
    'Ci vogliono da 10 a 30 minuti. I nuovi lead compaiono automaticamente. Meglio esportare quando ci sono tutti.',
  'prism.seed.creditsNote':
    'I tuoi {total} crediti iniziali vengono usati man mano: 1 credito per lead completato.',
  'prism.seed.done': 'Tutti i {delivered} lead sono nel tuo account.',
  'prism.seed.donePartial':
    '{delivered} lead consegnati: i crediti rimanenti restano sul tuo saldo.',
  'prism.refine.cta': 'Perfeziona il mio target ora',
  // Ergebnis (Aha)
  // Wave 2: the real kept-count now carries the headline.
  'prism.results.foundSuffix': 'aziende trovate nel tuo target',
  // #4 (Quickwins): variante personalizzata — {audience} arriva come »citazione«
  // pronta dal client (mai flessa, il gate vive lato client).
  'prism.results.foundSuffixAud': 'aziende trovate per {audience}',
  // DEPRECATED (#13): "only X match" undersells the engine and contradicts
  // the 50-unlock — replaced by topLine (abundance + curation).
  'prism.results.matched': '{count} corrispondono al tuo target',
  // #13: story = we show the strongest matches, the market has more of them.
  'prism.results.topLine': 'Qui sotto: i tuoi risultati più forti per coerenza.',
  // Wave 2: crossfade label target for the number morph (reserved; the
  // "verificate live" framing currently carries foundSuffix).
  'prism.results.checkedLabel': 'di cui verificate live, le tue più forti',
  // DEPRECATED (Wave 2): replaced by prism.results.matched.
  'prism.results.checked': '{count} di queste già verificate live',
  'prism.results.unlockHint': 'Sblocca ora le tue prime',
  'prism.results.unlockOffer': '{n} aziende adatte a 49 €',
  'prism.results.disclaimer':
    'Stima del potenziale di mercato basata sulla tua analisi live: sono esattamente le aziende che troveremo per te.',
  'prism.results.stat.checked': 'aziende trovate',
  // Wave 2: new real stat labels.
  'prism.results.stat.onTarget': 'corrispondono al tuo target',
  // #13: market-abundance tile instead of "X match" — real engine estimate
  // (market.projected_range_dach); tile is omitted when no estimate exists.
  'prism.results.stat.market': 'aziende nel tuo mercato (stima)',
  'prism.results.stat.avgFit': 'Fit score medio dei tuoi risultati più forti',
  // DEPRECATED (Wave 2): synthetic tiles — no longer rendered.
  'prism.results.stat.contacts': 'referenti individuabili',
  'prism.results.stat.revenue': 'potenziale di fatturato del target',
  'prism.results.chart.sizeTitle': 'Aziende per dimensione',
  'prism.results.chart.sizeMuted': 'nel tuo target',
  'prism.results.chart.emp1': '1–9 dip.',
  'prism.results.chart.emp2': '10–49 dip.',
  'prism.results.chart.emp3': '50–199 dip.',
  'prism.results.chart.emp4': '200+ dip.',
  'prism.results.chart.qualityTitle': 'Qualità dei dati dei tuoi lead',
  'prism.results.chart.qualityMuted': 'verificati oggi',
  'prism.results.chart.mail': 'E-mail verif.',
  'prism.results.chart.dial': 'Linea diretta',
  'prism.results.chart.decider': 'Decisori',
  'prism.results.insights.title': 'Potenziale e timing del tuo target',
  'prism.results.insights.openRate': 'Tasso medio di apertura delle e-mail B2B verificate',
  'prism.results.insights.bestTimeValue': 'mar–gio · ore 9–11',
  'prism.results.insights.bestTime': 'Fascia migliore per il primo contatto in questo settore',
  'prism.results.insights.dealValue': 'Valore medio di un contratto per cliente acquisito',
  'prism.results.insights.competitionValue': 'bassa',
  'prism.results.insights.competition': 'Concorrenza nel contatto a freddo nella tua zona',
  'prism.results.why.title': 'Il momento è buono:',
  'prism.results.why.p1': 'Nel tuo target di recente si sono attivati',
  'prism.results.why.strong': 'il 18 % in più di nuovi decisori',
  'prism.results.why.p2':
    ': la fase ideale per farti avanti per primo, prima che la concorrenza si muova.',
  'prism.results.timing.title': 'Perché proprio adesso è il momento giusto',
  'prism.results.timing.legend': 'La fase migliore per contattare il tuo target · adesso',
  'prism.timing.text':
    'A {month} la reperibilità di {who} è in genere al massimo: si stanno pianificando i budget del prossimo trimestre e i decisori rispondono al telefono. Chi si fa avanti adesso arriva prima che la concorrenza si svegli a {next}.',
  // Monate (Saisonalitäts-Chart + Timing-Text)
  'prism.month.now': 'Ora',
  'prism.month.short.1': 'Gen',
  'prism.month.short.2': 'Feb',
  'prism.month.short.3': 'Mar',
  'prism.month.short.4': 'Apr',
  'prism.month.short.5': 'Mag',
  'prism.month.short.6': 'Giu',
  'prism.month.short.7': 'Lug',
  'prism.month.short.8': 'Ago',
  'prism.month.short.9': 'Set',
  'prism.month.short.10': 'Ott',
  'prism.month.short.11': 'Nov',
  'prism.month.short.12': 'Dic',
  'prism.month.long.1': 'gennaio',
  'prism.month.long.2': 'febbraio',
  'prism.month.long.3': 'marzo',
  'prism.month.long.4': 'aprile',
  'prism.month.long.5': 'maggio',
  'prism.month.long.6': 'giugno',
  'prism.month.long.7': 'luglio',
  'prism.month.long.8': 'agosto',
  'prism.month.long.9': 'settembre',
  'prism.month.long.10': 'ottobre',
  'prism.month.long.11': 'novembre',
  'prism.month.long.12': 'dicembre',
  // Frei-Lead
  'prism.freelead.tag': 'Il tuo primo lead: lo offriamo noi',
  'prism.freelead.verified': 'verificato',
  'prism.freelead.lockedChip': '🔒 Referente e contatti dopo lo sblocco',
  'prism.freelead.note1': 'Così apparirà',
  'prism.freelead.noteStrong': 'ognuna',
  'prism.freelead.note2':
    'delle tue {n} aziende adatte: un referente reale con e-mail o telefono. Le altre {rest} le sblocchi al prossimo passo.',
  'prism.freelead.alt1': 'Questa azienda rientra nel tuo target. Allo sblocco aggiungiamo',
  'prism.freelead.altStrong': 'referenti reali con e-mail o telefono',
  'prism.freelead.alt2': ', per tutte le {n}.',
  // Lead-Zeilen
  'prism.lead.ap': 'Referenti',
  'prism.lead.inclDeciders': 'dopo lo sblocco',
  'prism.results.moreStrong': '≈{count} altre',
  'prism.results.moreRest': 'trovate. Ricerchiamo i contatti dopo lo sblocco.',
  'prism.results.planTitle': 'Il tuo piano di acquisizione iniziale:',
  'prism.results.planBody':
    'prima le {n} aziende più forti: referenti con e-mail o telefono, esportabili in CSV o Excel.',
  'prism.results.cta': 'Sblocca le mie {n} aziende adatte',
  'prism.results.detailsLink': 'Che cosa è incluso esattamente?',
  'prism.results.foot': '49 € oggi · {n} aziende adatte · dal 4° giorno: 290 €/mese, disdici quando vuoi',
  // Paywall
  'prism.paywall.step2': 'Sblocca',
  'prism.paywall.step3': 'Parti',
  'prism.paywall.resPrefix': 'I tuoi',
  'prism.paywall.resStrong': '50 lead',
  'prism.paywall.resSuffix': 'sono riservati per te',
  'prism.paywall.resExpired':
    "Prenotazione scaduta, ma teniamo da parte la tua ricerca ancora per un po'.",
  'prism.paywall.eyebrow': '{count} aziende trovate · pronte da sbloccare',
  'prism.paywall.title1': 'Le tue prime',
  'prism.paywall.titleGrad': '{n} aziende adatte',
  'prism.paywall.title2': 'sono pronte. Sbloccale.',
  // #4 (Quickwins): variante H1 personalizzata ({audience} = »citazione« pronta).
  'prism.paywall.title2Aud': 'per {audience} sono pronte. Sbloccale.',
  'prism.paywall.sub1': 'Abbiamo trovato',
  'prism.paywall.subStrong1': '{count} aziende',
  'prism.paywall.sub2': 'per {audience}. Le',
  'prism.paywall.subStrong2': '{n} più forti',
  'prism.paywall.sub3': 'ti aspettano. Ricerchiamo referenti e contatti dopo lo sblocco.',
  // Lead-Tresor
  'prism.vault.title': 'Le tue {n} aziende più forti sono pronte',
  // Wave 2: 3-stage story from real numbers — {count}=discovery.kept
  // (verificate live), {audience}=typed target audience.
  // #13: no more "exactly X match" (contradicted "50 strongest" and shrank
  // the market) — {onTarget} stays as an unused-but-compatible placeholder.
  'prism.vault.sub':
    'Su {count} aziende trovate per {audience}: ecco le tue {n} più forti. Ricerchiamo referenti e contatti dopo lo sblocco.',
  'prism.vault.locked': 'bloccato',
  'prism.vault.blurEmail': 'contatto@azienda.it',
  // Wave 2: real remaining count from the scored pool instead of a static "+45".
  'prism.vault.more': '+ altre {count} aziende trovate · bloccate',
  'prism.vault.cta': 'Sblocca tutte le {n} · 49 €',
  'prism.vault.reassure': '49 € oggi · dal 4° giorno: 290 €/mese · disdici quando vuoi',
  // Gründer-Karte + Video
  'prism.founder.head': 'Un messaggio personale dal fondatore',
  'prism.founder.quote':
    "«Ciao, sono Janik. Per tutta la fase di prova ti seguo personalmente, e l'ingresso è volutamente a un prezzo basso, così puoi provare Leadscraper con calma. Dacci una possibilità: sono sicuro che siamo quello che fa per te.»",
  'prism.founder.role': 'Fondatore · Leadscraper',
  'prism.video.playAria': 'Riproduci il video demo',
  'prism.video.chip': 'Demo live · 10:04',
  'prism.video.title': 'Guarda come Janik trova i tuoi primi lead',
  'prism.video.cta': 'Guarda la demo: ricerca reale, dashboard reale',
  'prism.video.iframeTitle': 'Demo live · Leadscraper',
  // Timeline (So läuft dein Test)
  'prism.timeline.title': 'Come funziona la tua prova di 3 giorni',
  'prism.timeline.today': 'Oggi',
  'prism.timeline.todayStrong': '49 € oggi',
  'prism.timeline.todayRest': ', {n} aziende adatte sbloccate, nel tuo account tra 10 e 30 minuti.',
  'prism.timeline.days13': 'Giorni 1–3',
  'prism.timeline.testP1': 'Provi con lead reali.',
  'prism.timeline.testStrong': '3 giorni di tempo',
  'prism.timeline.testP2': ', se non fa per te, disdici con 1 clic, non un centesimo in più.',
  'prism.timeline.day4': 'Dal 4° giorno',
  'prism.timeline.aboP1': 'Poi il tuo piano continua con',
  'prism.timeline.aboStrong': '250 crediti a 290 €/mese',
  'prism.timeline.aboP2': ' — disdici quando vuoi.',
  // Versus-Block
  'prism.versus.title': 'Perché Leadscraper, e non il solito metodo',
  'prism.versus.oldTitle': 'Il solito metodo',
  'prism.versus.old1': 'Ore su Google o liste comprate e già vecchie',
  'prism.versus.old2': 'Bounce rate alto, zona grigia GDPR',
  'prism.versus.old3': 'Referenti da cercare a mano, uno per uno',
  'prism.versus.old4': '1.000–1.500 €/mese + contratto annuale (Cognism, Dealfront)',
  'prism.versus.old5': 'Settimane prima della prima risposta',
  'prism.versus.newTitle': 'Con Leadscraper',
  'prism.versus.new1': '{n} aziende adatte tra 10 e 30 minuti · su misura per il tuo target',
  'prism.versus.new2': 'E-mail controllate tecnicamente, telefono se disponibile',
  'prism.versus.new3': 'Referenti inclusi nel pacchetto',
  'prism.versus.new4': 'Provi a 49 € · disdetta mensile · nessun contratto annuale',
  'prism.versus.new5': 'Esporti oggi, contatti domani',
  'prism.versus.foot1': 'Lo stesso lavoro per cui altri spendono',
  'prism.versus.footStrong1': 'settimane',
  'prism.versus.foot2': 'e',
  'prism.versus.footStrong2': 'oltre 1.000 €/mese',
  'prism.versus.foot3': ', per te oggi, in prova, a',
  'prism.versus.footStrong3': '49 €',
  // ROI-Panel
  'prism.roi.title': 'Cosa ti portano le tue {n} aziende adatte',
  'prism.roi.row1': 'Lead con referenti, pronti tra 10 e 30 minuti',
  'prism.roi.row2': 'La tua spesa di oggi',
  'prism.roi.row3': 'Basta 1 cliente acquisito per rientrare',
  'prism.roi.row3v': 'molte volte la spesa',
  'prism.roi.hl1': 'Un',
  'prism.roi.hlStrong': 'solo',
  'prism.roi.hl2':
    'cliente dalle tue prime {n} aziende adatte ripaga i 49 € molte volte: tutto il resto è vantaggio.',
  'prism.roi.perLead': 'per lead pronto',
  'prism.roi.stat2v': '10–30 min',
  'prism.roi.stat2': 'invece di settimane di ricerca',
  'prism.roi.stat3v': '3 giorni',
  'prism.roi.stat3': 'di prova prima che parta l’abbonamento',
  // Plan-Karte
  'prism.plan.badge': 'Offerta di ingresso · 3 giorni di prova',
  'prism.plan.leadsUnit': 'aziende adatte · referenti tra 10 e 30 minuti',
  'prism.plan.anchor': 'Fai da te: ~10 ore di ricerca manuale',
  'prism.plan.priceSuffix': 'oggi',
  'prism.price.netVat': 'IVA escl.',
  'prism.plan.perLeadStrong': 'meno di 1 €',
  'prism.plan.f1': 'E-mail controllate tecnicamente, telefono se disponibile',
  'prism.plan.f2': 'Referenti per ogni azienda, se reperibili pubblicamente',
  'prism.plan.f3': 'Esportazione in CSV o Excel, collegamento al CRM possibile',
  'prism.plan.cta': 'Sblocca ora · 49 €',
  'prism.plan.secure': 'Pagamento sicuro con Stripe · crittografia SSL',
  'prism.plan.subnote': 'Disdetta in ogni momento con 1 clic dal tuo account.',
  'prism.plan.gbCondition': 'Condizioni della garanzia: vedi § 7 dei',
  'prism.guarantee.title': 'Garanzia soddisfatti o rimborsati',
  'prism.guarantee.sub':
    'Entro i 3 giorni di prova ti rimborsiamo i 49 €: scrivi a support@leadscraper.eu, compila il nostro breve modulo di feedback e con il rimborso chiudiamo anche il tuo abbonamento. Solo per questa offerta di ingresso.',
  'prism.legal.agb': 'Termini e condizioni',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/it/termini-e-condizioni',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/it/informativa-sulla-privacy',
  'prism.legal.privacy': 'Informativa privacy',
  // Reviews-Band (Überschriften — Kunden-Zitate/Namen bleiben bewusst unübersetzt)
  'prism.reviews.title': 'Team commerciali che hanno già fatto il passaggio',
  // Trust-Bar
  'prism.trust.payStrong': '49 € oggi',
  'prism.trust.payRest': '· carta, PayPal, Apple e Google Pay · sicuro via Stripe',
  'prism.trust.cancelStrong': 'Disdici quando vuoi',
  'prism.trust.cancelRest': '· con 1 clic dal tuo account, nessun preavviso, nessuna domanda',
  'prism.trust.dataStrong': 'Solo dati pubblici',
  'prism.trust.dataRest': '· GDPR by design · server in UE',
  // FAQ
  'prism.faq.title': 'Domande frequenti',
  'prism.faq.q1': 'Cosa succede dopo i 3 giorni?',
  'prism.faq.a1':
    'Dal 4° giorno il tuo piano continua con 250 crediti a 290 €/mese, disdicibile in ogni momento con un clic. Hai quindi 3 giorni per decidere con calma.',
  'prism.faq.q2': 'Posso disdire quando voglio?',
  'prism.faq.a2':
    'Sì, ogni mese: basta un clic nel tuo account, senza preavviso e senza domande. Se disdici nei 3 giorni di prova paghi solo i 49 €. Più avanti, l’accesso resta attivo fino alla fine del mese pagato.',
  'prism.faq.q3': 'Da dove arrivano i lead? È tutto conforme al GDPR?',
  'prism.faq.a3':
    'Esclusivamente da dati aziendali pubblicamente disponibili. GDPR by design: elaborazione e server esclusivamente in UE.',
  'prism.faq.q4': 'E se i lead non fanno al caso mio?',
  'prism.faq.a4':
    'Entro i 3 giorni di prova ti rimborsiamo i 49 € se compili il nostro breve modulo di feedback (Termini § 7). Scrivi a support@leadscraper.eu; con il rimborso chiudiamo il tuo abbonamento. Dopo non è più possibile alcun rimborso, ma puoi disdire l’abbonamento in ogni momento.',
  'prism.faq.q5': 'Ricevo referenti reali?',
  'prism.faq.a5':
    'Sì: per ogni azienda, referenti ricercati con indirizzo e-mail o numero di telefono. Gli indirizzi e-mail sono controllati tecnicamente; non possiamo garantire che ogni casella esista. Se per un’azienda non si trova alcun contatto raggiungibile, per essa non viene addebitato nulla.',
  // Gründer-Zeile
  'prism.founderline.strong': 'Guidata dal fondatore, da Amburgo',
  'prism.founderline.rest': '· Janik Deimann, fondatore',
  'prism.founderline.sub':
    'Deimann Com GmbH · Da noi parli con persone, non con una coda di ticket.',
  'prism.founderline.ask':
    'Hai ancora dubbi? Scrivici: support@leadscraper.eu, ti risponde una persona vera.',
  // Fixe Kauf-Leiste
  'prism.sticky.leads': '{n} aziende adatte ·',
  'prism.sticky.today': 'oggi · dal 4° giorno: 290 €/mese',
  'prism.sticky.cta': 'Sblocca ora',
  // Inline-Checkout
  'prism.checkout.eyebrow': 'Offerta di ingresso · 49 € oggi',
  'prism.checkout.title': '{n} aziende adatte · sblocca ora',
  'prism.checkout.sumPrice': '49 € oggi',
  'prism.checkout.sumDesc': '{n} aziende adatte sbloccate, 3 giorni di prova',
  'prism.checkout.after': 'dal 4° giorno',
  'prism.checkout.monthly': '290 € / mese',
  'prism.checkout.reassure3d':
    'Se disdici entro i 3 giorni, paghi solo i 49 €. I tuoi lead restano tuoi: puoi vederli ed esportarli anche dopo.',
  'prism.checkout.deliverNote':
    'In questa ricerca ci sono {count} aziende adatte pronte. Un credito conta solo se troviamo un referente; il resto dei tuoi 50 crediti lo usi per altre ricerche.',
  'prism.checkout.cancelNote': 'Disdici l’abbonamento quando vuoi: un clic.',
  'prism.checkout.invite':
    'Ti invitiamo noi: 50 lead una tantum a prezzo di costo, solo per iniziare, così provi Leadscraper senza rischi.',
  'prism.checkout.or': 'oppure con carta',
  'prism.checkout.tabCard': 'Carta',
  'prism.checkout.tabSepa': 'Addebito SEPA',
  'prism.checkout.cardholder': 'Titolare della carta',
  'prism.checkout.cardholderPh': 'Mario Rossi',
  'prism.checkout.cardNumber': 'Numero della carta',
  'prism.checkout.expiry': 'Scadenza',
  'prism.checkout.expiryPh': 'MM / AA',
  'prism.checkout.country': 'Paese',
  'prism.checkout.countryDe': 'Germania',
  'prism.checkout.countryAt': 'Austria',
  'prism.checkout.countryCh': 'Svizzera',
  'prism.checkout.paying': 'Attivazione in corso …',
  'prism.checkout.embedLoading': 'Caricamento del pagamento sicuro …',
  'prism.checkout.payCta': 'Sblocca {n} aziende adatte · 49 €',
  'prism.checkout.securePrefix': 'Pagamento sicuro con',
  'prism.checkout.secureSuffix': '· crittografia SSL',
  // Wave 2: generic button reference — the live CTA of the PaymentElement
  // (locked zone) reads "Continua al pagamento", not "Sblocca 50 lead".
  'prism.checkout.fine1': 'Cliccando sul pulsante qui sopra accetti i',
  'prism.checkout.fine2':
    "e il rinnovo automatico come abbonamento Starter (250 crediti / 290 € al mese) dal 4° giorno, disdicibile in ogni momento con un clic. Questa offerta si rivolge esclusivamente a imprenditori e attività commerciali (B2B, § 14 BGB). Tutti i prezzi sono al netto dell'IVA di legge. Garanzia soddisfatti o rimborsati: solo per questa offerta di ingresso, solo entro i 3 giorni di prova e con il modulo di feedback compilato (Termini § 7).",
  // Success-Screen
  'prism.success.title': '{n} aziende adatte sbloccate',
  'prism.success.body':
    'Le tue {n} aziende adatte sono sbloccate. I referenti arrivano tra 10 e 30 minuti, esportabili in CSV/CRM. Dal 4° giorno parte il tuo abbonamento Starter (250 crediti/mese), disdicibile ogni mese.',
  'prism.success.cta': 'Si parte!',

  // --- LEA-379 i18n backfill (2026-07-06): keys that previously fell back to
  //     German (packages/i18n index.ts fallback). Machine-translated from EN/DE,
  //     billing/cancel copy pending Janik wording review. ---
  'acct.plan.downgradeScheduled': 'Cambio di piano programmato',
  'acct.plan.downgradeScheduledDetail':
    'Passerai a {plan} il {date}. Fino ad allora mantieni il tuo piano attuale e i tuoi Credits restano.',
  'acct.plan.downgradeCancel': 'Annulla cambio di piano',
  'acct.plan.downgradeCanceling': 'Annullamento …',
  // LEA-555 — trial intercept.
  // LEA-557 — retention discount (30% x 3 Monate).
  // LEA-558 — VIP-Einrichtung (990-€-Vergleichswert nur in der Copy).
  // LEA-560 — Win-back-Banner.
  'acct.winback.title': 'La tua offerta di bentornato',
  'acct.winback.body':
    '{plan} con il 30% di sconto per 3 mesi. Il checkout mostra prezzo e data di addebito prima che accada qualcosa.',
  'acct.winback.cta': 'Vai al checkout',
  'acct.winback.starting': 'Apertura …',

  // LEA-524 — Pausendauer + Wiederaufnahme-Datum.
  'acct.cancel.save.offerTitle': 'Prima di disdire — forse una di queste opzioni ti va meglio',
  'acct.cancel.save.offerSub': 'Nessuna pressione. Disdire resta a un clic.',
  'acct.cancel.pauseMonthsLabel': 'Metti in pausa per',
  'acct.cancel.pauseMonths1': '1 mese',
  'acct.cancel.pauseMonths': '{n} mesi',
  'acct.cancel.pauseResumeHint':
    "Il tuo abbonamento riprende automaticamente il {date} — da quel momento l'addebito riparte.",
  'acct.cancel.pausedDetailUntil':
    "Non viene addebitato alcun importo. Mantieni l'accesso e i crediti rimanenti. Il tuo abbonamento riprende automaticamente il {date}; puoi riprenderlo prima in qualsiasi momento.",
  'acct.cancel.pausedNoteUntil':
    'In pausa fino al {date}, nessun addebito. I tuoi crediti restano utilizzabili.',

  'acct.cancel.trial.vipTitle': 'Janik configura il tuo account personalmente',
  'acct.cancel.trial.vipBody':
    'Gruppi target, profili di ricerca, prime ricerche — il fondatore configura il tuo account insieme a te. Un servizio del valore di 990 € — gratis per te se continui la prova.',
  'acct.cancel.trial.vipCta': 'Richiedi la configurazione personale',
  'acct.cancel.trial.vipRequesting': 'Invio richiesta …',
  'acct.cancel.trial.vipDoneTitle': 'Richiesta inviata',
  'acct.cancel.trial.vipDoneBody':
    'Janik ti contatterà personalmente entro 24 ore. La tua prova continua normalmente — non è stato disdetto né addebitato nulla.',

  'acct.cancel.save.discountTitle': '30% di sconto per i prossimi 3 mesi',
  'acct.cancel.save.discountBody':
    'Resta e paga il 30% in meno per tre mesi — lo sconto è applicato direttamente al tuo abbonamento, la tua carta resta invariata, nessun nuovo checkout.',
  'acct.cancel.save.discountCta': 'Attiva lo sconto del 30%',
  'acct.cancel.save.discounting': 'Attivazione …',
  'acct.cancel.save.discountDoneTitle': 'Sconto attivo',
  'acct.cancel.save.discountDoneBody':
    'Le tue prossime tre fatture mensili sono ridotte del 30%. Dopo, il piano continua al prezzo normale — puoi sempre disdire in qualsiasi momento con un clic.',

  'acct.cancel.trial.interceptTitle': 'Aspetta — la tua prova è attiva fino al {date}.',
  'acct.cancel.trial.interceptTitleNoDate': 'Aspetta — la tua prova è ancora attiva.',
  'acct.cancel.trial.interceptSub': 'Fino ad allora non ti verrà addebitato nulla.',
  'acct.cancel.trial.reminderTitle': 'Ti avvisiamo per tempo',
  'acct.cancel.trial.reminderBody':
    'Non devi annotare né ricordare nulla. Ti scriveremo 24 ore prima della scadenza — e se non vorrai continuare, potrai disdire direttamente da quella e-mail.',
  'acct.cancel.trial.reminderPointMail': "Il link per disdire è direttamente nell'e-mail.",
  'acct.cancel.trial.reminderPointNoCharge': 'Prima di allora non ti verrà addebitato nulla.',
  'acct.cancel.trial.reminderCta': 'Continua e ricordamelo',
  'acct.cancel.trial.keepTestingCta': 'Continua la prova',
  'acct.cancel.trial.reminderSaving': 'Attivazione …',
  'acct.cancel.trial.reminderDoneTitle': 'Promemoria attivo',
  'acct.cancel.trial.reminderDoneBody':
    "Ti scriveremo il {date} — 24 ore prima della fine della prova, con il link per disdire direttamente nell'e-mail.",
  'acct.cancel.trial.reminderDoneBodyNoDate':
    "Ti scriveremo 24 ore prima della fine della prova, con il link per disdire direttamente nell'e-mail.",
  'acct.cancel.trial.cancelNowLink': 'Disdici definitivamente',
  'acct.cancel.trial.confirm.endsNow':
    "L'accesso di prova termina subito, non alla data di scadenza.",
  'acct.cancel.trial.confirm.forfeits':
    'I tuoi profili di ricerca e i crediti residui vanno persi.',
  'acct.cancel.trial.confirm.noCharge': 'Non ti verrà addebitato nulla.',
  'acct.cancel.trial.done.title': 'Prova terminata',
  'acct.cancel.trial.done.body':
    'La tua prova è terminata e non ti è stato addebitato nulla. Se cambi idea, puoi attivare un abbonamento quando vuoi.',

  'acct.cancel.trigger': 'Disdici abbonamento',
  'acct.cancel.manageHint': 'Gestisci abbonamento',
  'acct.cancel.scheduledTitle': 'Disdetta programmata',
  'acct.cancel.scheduledDetail':
    "Il tuo abbonamento termina il {date}. Fino ad allora mantieni l'accesso completo.",
  'acct.cancel.reactivate': 'Annulla disdetta',
  'acct.cancel.reactivating': 'Annullamento …',
  'acct.cancel.restored': 'Abbonamento ripristinato: il tuo piano continua.',
  'acct.cancel.title': 'Disdici abbonamento',
  'acct.cancel.stepOf': 'Passo {n} di {total}',
  'acct.cancel.reasonTitle': 'Perché vuoi disdire?',
  'acct.cancel.reasonSub': 'Opzionale: la tua risposta ci aiuta a migliorare Leadscraper.',
  'acct.cancel.reason.too_expensive': 'Troppo caro',
  'acct.cancel.reason.too_few_leads': 'Troppo pochi lead (buoni)',
  'acct.cancel.reason.wrong_contacts': 'Referenti sbagliati',
  'acct.cancel.reason.unreliable_data': 'Email/dati di contatto inaffidabili',
  'acct.cancel.reason.too_complicated': 'Troppo complicato',
  'acct.cancel.reason.missing_feature': 'Manca una funzionalità',
  'acct.cancel.reason.temporary_only': 'Mi serviva solo temporaneamente',
  'acct.cancel.reason.switched_tool': 'Passo a un altro tool',
  'acct.cancel.reason.other': 'Altro',
  'acct.cancel.freeTextPlaceholder': 'Raccontaci di più (opzionale) …',
  'acct.cancel.save.downgradeTitle': 'Forse un piano più piccolo fa al caso tuo?',
  'acct.cancel.save.downgradeBody':
    'Invece di disdire, puoi passare a un piano più economico: mantieni i tuoi Credits e paghi meno dal prossimo ciclo.',
  'acct.cancel.save.downgradeCta': 'Vedi piani più economici',
  'acct.cancel.save.downgradeOffer':
    'Passa a {plan} · €{price}/mese · {leads} lead/mese. Mantieni i tuoi Credits e paghi meno dal prossimo ciclo.',
  'acct.cancel.save.downgradeCtaPlan': 'Passa a {plan}',
  'acct.cancel.save.downgrading': 'Cambio in corso …',
  'acct.cancel.save.seeAllPlans': 'Vedi tutti i piani',
  'acct.cancel.save.helpTitle': 'Sistemiamo le cose',
  'acct.cancel.save.helpBody':
    'Stiamo migliorando attivamente molte di queste cose. Scrivici cosa mancava: spesso possiamo rimettere a punto la tua ricerca in fretta.',
  'acct.cancel.confirm.accessUntil': "Mantieni l'accesso completo fino al {date}.",
  'acct.cancel.confirm.noCharge': 'Dopo di allora non ti verrà più addebitato nulla.',
  'acct.cancel.confirm.reactivate':
    'Puoi annullare la disdetta in qualsiasi momento prima di allora.',
  'acct.cancel.audit.title': "Un'ultima cosa (opzionale)",
  'acct.cancel.audit.sub': 'Cosa ha funzionato e cosa no? Va dritto nei nostri miglioramenti.',
  'acct.cancel.audit.rightCompanies': 'Le aziende giuste?',
  'acct.cancel.audit.rightContacts': 'I referenti giusti?',
  'acct.cancel.audit.contactDataUsable': 'Email/telefono/LinkedIn utilizzabili?',
  'acct.cancel.audit.enoughLeads': 'Abbastanza lead?',
  'acct.cancel.audit.helpedWin': 'Ti ha aiutato a conquistare clienti?',
  'acct.cancel.audit.good': 'Bene',
  'acct.cancel.audit.bad': 'Scarso',
  'acct.cancel.lead.title': 'Quale lead ti ha deluso? (opzionale)',
  'acct.cancel.lead.sub': 'Se un lead specifico non andava, indicarcelo è ciò che ci aiuta di più.',
  'acct.cancel.lead.pick': 'Scegli un lead',
  'acct.cancel.lead.loading': 'Caricamento …',
  'acct.cancel.lead.none': 'Nessun lead consegnato trovato.',
  'acct.cancel.cf.title': 'Aiutaci a fare meglio (opzionale)',
  'acct.cancel.cf.gapPlaceholder': 'Cosa ti serviva che non siamo riusciti a offrirti?',
  'acct.cancel.cf.toolPlaceholder': 'Passi a un altro tool? Quale?',
  'acct.cancel.cf.betterPlaceholder': 'Cosa fa di meglio?',
  'acct.cancel.justCancel': 'Disdici ora',
  'acct.cancel.keep': 'Mantieni',
  'acct.cancel.next': 'Continua',
  'acct.cancel.back': 'Indietro',
  'acct.cancel.stillCancel': 'Disdici comunque',
  'acct.cancel.confirmBtn': 'Conferma disdetta',
  'acct.cancel.confirming': 'Disdetta in corso …',
  'acct.cancel.done.title': 'Disdetta confermata',
  'acct.cancel.done.body':
    "Il tuo abbonamento termina il {date}. Fino ad allora mantieni l'accesso completo, e puoi annullare la disdetta in qualsiasi momento prima di allora.",
  'acct.cancel.done.close': 'Chiudi',
  'acct.cancel.save.pauseTitle': 'Metti in pausa invece di disdire?',
  'acct.cancel.save.pauseBody':
    'Congela il tuo abbonamento invece di disdirlo: nessun addebito, i tuoi Credits e dati restano, e puoi riprendere in qualsiasi momento con un clic.',
  'acct.cancel.save.pauseCta': "Metti in pausa l'abbonamento",
  'acct.cancel.save.pausing': 'Pausa in corso …',
  'acct.cancel.pauseTrigger': 'Metti in pausa',
  'acct.cancel.pausing': 'Pausa in corso …',
  'acct.cancel.pausedBadge': 'In pausa',
  'acct.cancel.pausedNote':
    'Abbonamento in pausa: nessun addebito. I tuoi Credits restano utilizzabili.',
  'acct.cancel.pausedTitle': 'Abbonamento in pausa',
  'acct.cancel.pausedDetail':
    "Non ti viene addebitato nulla. Mantieni l'accesso e i tuoi Credits residui. Riprendi in qualsiasi momento.",
  'acct.cancel.resume': 'Riprendi abbonamento',
  'acct.cancel.resuming': 'Ripresa in corso …',
  'billing.errorRetry': 'Riprova',
  'billing.transientError': 'Temporaneamente non disponibile. Riprova tra un momento.',
  'billing.downgradeScheduled':
    'Cambio di piano programmato: passerai a {plan} il {date}. I tuoi Credits restano.',
  'billing.downgradeAlready': 'Un cambio a {plan} è già programmato per il {date}.',
  'dash.run.suggHeading': 'Ricerche di esempio per la tua attività',
  'dash.run.intent.broad': 'Classico',
  'dash.run.intent.growth': 'Segnale di crescita',
  'dash.run.intent.tool': 'Segnale tool',
  'dash.run.intent.default': 'Suggerimento',
  'dash.run.costPreview': 'fino a {n} Credits',
  'det.sourcesPending':
    'Le prove delle fonti per questo lead sono ancora in fase di raccolta: appariranno qui una volta verificate.',
  'ld.contact.emailCopied': 'Indirizzo email copiato.',
  'ld.contact.phoneCopied': 'Numero di telefono copiato.',
  'ld.contact.copy': 'Copia',
  'ld.contact.copied': 'Copiato.',
  'ld.contact.tagCentral': 'Centralino',
  'ld.contact.tagUnconfirmed': 'non confermato',
  'ld.contact.tagPattern': 'Pattern',
  'ld.contact.centralTooltip': 'Linea diretta non pubblica: chiama e chiedi di {name}.',
  'ld.contact.centralTooltipNoName': 'Linea diretta non pubblica: raggiungi il centralino.',
  'ld.contact.verifiedSmtp': 'Casella email confermata (SMTP).',
  'ld.contact.unverifiedHint': 'Ripresa da una fonte pubblica: non ancora verificata via SMTP.',
  'ld.contact.patternTooltip':
    'Indirizzo probabile basato sul pattern email aziendale: non confermato.',
  'ld.contact.derivePattern': "Ricava l'email dal pattern aziendale",
  'ld.contact.bestRoute': 'Percorso migliore:',
  'ld.contact.route.central': 'Chiama tramite il centralino',
  'ld.contact.route.centralEmail': 'Scrivi al centralino',
  'ld.contact.route.linkedin': 'Messaggio LinkedIn',
  'ld.contact.route.xing': 'Messaggio Xing',
  'ld.contact.route.phone': 'Chiama (linea diretta)',
  'ld.contact.route.email': 'Email',
  'ld.contact.route.pattern': 'Email tramite pattern aziendale',
  'ld.contact.provMailbox': 'Casella confermata',
  'ld.contact.provImpressum': "Citato nell'Impressum",
  'ld.contact.provFound': 'Trovato in fonti pubbliche',
  'ld.contact.provVia': 'confermato tramite',
  'ld.contact.confHigh': 'Alta',
  'ld.contact.confMid': 'Media',
  'ld.contact.confLow': 'Bassa',
  'ld.contact.photoVia': 'Foto: {src} ↗',
  'ld.contact.roleProof': 'Ruolo confermato pubblicamente ↗',
  'ld.section.roleFallback':
    'Il ruolo richiesto ({roles}) non è confermato pubblicamente: mostriamo i referenti più adatti tra quelli disponibili.',
  'ld.section.noDirect':
    'Qui i contatti diretti non sono pubblici: raggiungibili tramite il centralino.',
  'lt.expH.legalForm': 'Forma giuridica',
  'lt.expH.street': 'Via',
  'lt.expH.zip': 'CAP',
  'lt.expH.website': 'Sito web',
  'lt.expH.vatId': 'Partita IVA',
  'lt.expH.hr': 'Registro commerciale',
  'lt.expH.founded': 'Fondata',
  'lt.expH.size': 'Dipendenti',
  'lt.expH.revenue': 'Fascia di fatturato',
  'lt.expH.description': 'Descrizione',
  'lt.expH.techStack': 'Tech stack',
  'lt.expH.triggers': 'Segnali/Trigger',
  'lt.expH.scoreCompany': 'Punteggio di affinità aziendale',
  'lt.expH.scoreData': 'Qualità dei dati',
  'lt.expH.seniority': 'Seniority',
  'lt.expH.department': 'Reparto',
  'lt.expH.phone': 'Telefono',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Qualifica',
  'lt.expH.confidence': 'Confidenza',
  'lt.expH.channel': 'Canale consigliato',
  'lt.filter.all': 'Tutti',
  'lt.filter.torate': 'Da valutare',
  'lt.filter.identified': 'Azienda aggiunta',
  'lt.filter.connected': 'Con contatti',
  'lt.filter.planned': 'Piano pronto',
  'lt.filter.archived': 'Archiviati',
  'lt.view.list': 'Elenco',
  'lt.view.listSubheader': 'Tabella · tutte le colonne visibili',
  'lt.funnel.subheader': 'Funnel · lead raggruppati per fase',
  'lt.funnel.addCompany': 'Aggiungi azienda',
  'lt.funnel.add': 'Aggiungi',
  'lt.funnel.addTooltip': 'Aggiungi azienda tramite URL · 1 Credit',
  'lt.funnel.pullAllContacts': 'Estrai tutti i contatti',
  'lt.funnel.empty': 'Ancora nessun lead in questa fase',
  'lt.funnel.dropHint': 'Trascina qui per avviare la fase',
  'lt.col.planned': 'Piano di acquisizione pronto',
  'lt.card.new': 'Nuovo',
  'lt.card.viewPlan': 'Vedi piano',
  'lt.card.findContacts': 'Trova referenti',
  'lt.card.createPlan': 'Crea piano di acquisizione',
  'lt.card.contactsCount': '{n} referenti',
  'lt.card.fitTooltip':
    'Affinità {score}%: quanto bene questa azienda corrisponde al tuo mercato di riferimento',
  'lt.card.noContacts': 'Ancora nessun referente',
  'lt.card.noJustification':
    'Ancora nessuna motivazione Cortex: il lead verrà arricchito alla prossima esecuzione.',
  'lt.card.rejectTitle': 'Segna come non in target',
  'lt.card.rejectAria': 'Segna {company} come non in target',
  'lt.card.openWebsite': 'Apri {website}',
  'lt.manual.verifyingDesc': 'Verifica del sito web, estrazione dei dati di base …',
  'lt.manual.addedDesc':
    'Aggiunta tramite URL: settore, indirizzo e dati di contatto vengono completati durante la verifica.',
  'lt.phaseChip.identified': 'Aggiunta',
  'lt.phaseChip.connected': 'Contatti',
  'lt.phaseChip.planned': 'Piano pronto',
  'nav.matchRateMin': 'Il tasso di corrispondenza viene mostrato a partire da 5 valutazioni',
  'notif.review.bodyAll': '{n} lead non valutati in {m} mercati di riferimento.',
  'price.ctaDowngradeScheduled': 'Cambio già programmato',
  'run.startFailed': 'Impossibile avviare la ricerca. Riprova.',
  'email.subscription-paused.subject': 'Il tuo abbonamento è in pausa',
  'email.subscription-paused.badge': 'Abbonamento in pausa',
  'email.subscription-paused.hero': 'Il tuo abbonamento<br>è in pausa.',
  'email.subscription-paused.detail.plan_label': 'Piano',
  'email.subscription-paused.detail.until_label': 'In pausa fino al',
  'email.subscription-paused.preheader': 'Nessun addebito fino al {{pause_ends_at}}.',
  'email.subscription-paused.greeting': 'Ciao {{first_name}},',
  'email.subscription-paused.intro':
    'il tuo abbonamento {{plan_name}} è ora in pausa. Non ti verrà addebitato nulla fino al {{pause_ends_at}}.',
  'email.subscription-paused.access':
    "Mantieni l'accesso completo e i tuoi Credits residui: semplicemente non riceverai nuovi Credits mensili.",
  'email.subscription-paused.resume_note':
    'Il {{pause_ends_at}} il tuo abbonamento riprende automaticamente. Puoi riprenderlo o disdirlo in qualsiasi momento prima di allora.',
  'email.subscription-paused.button': 'Gestisci abbonamento',
  'email.subscription-paused.signoff': 'A presto, il team Leadscraper',
  'email.subscription-pause-ending.subject': 'Il tuo abbonamento riprende a breve',
  'email.subscription-pause-ending.preheader': 'La tua pausa termina il {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Ciao {{first_name}},',
  'email.subscription-pause-ending.intro':
    'un breve promemoria: la tua pausa termina il {{resumes_at}}. Il tuo abbonamento {{plan_name}} riprenderà poi automaticamente.',
  'email.subscription-pause-ending.charge_note':
    'Da quel momento la fatturazione riparte normalmente. Se preferisci non riprendere, puoi disdire prima di tale data.',
  'email.subscription-pause-ending.button': 'Gestisci abbonamento',
  'email.subscription-pause-ending.signoff': 'Il team Leadscraper',
  'scraper.sum.recallUnverified':
    '{n}/10 lead consegnati: il ricercatore AI è stato sufficiente, quindi la ricerca web ampia è stata saltata. Il mercato potrebbe essere molto più grande delle {total} aziende trovate finora.',
  'scraper.sum.recallUnverifiedRec':
    'Questo non è un mercato ristretto: è una ricerca saltata. Stiamo ampliando la discovery per misurare la reale dimensione del mercato.',
  'scraper.sum.supplyExhausted':
    '{n}/10 lead consegnati: altri {dropped} risultati corrispondenti li avevi già ricevuti in ricerche precedenti e sono stati filtrati come duplicati. Il mercato non è ristretto; hai semplicemente già ricevuto la maggior parte delle aziende che al momento riusciamo a trovare.',
  'scraper.sum.supplyExhaustedRec':
    'Normale per le ricerche ricorrenti, col tempo compaiono nuove aziende. Per più volume fresco: scegli una regione più ampia o settori affini.',
  'det.emailPatternExampleTag': 'Esempio',
  'det.emailPatternLockedHint': 'Determinato per questa azienda quando verifichi i referenti.',
  'det.email.verified': 'verificata',
  'det.email.unverified': 'non verificata',
  'det.linkedinProfile': 'Profilo LinkedIn',
  'det.xingProfile': 'Profilo Xing',
  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.act.title': 'Ultime attività',
  'autopilot.appr.action': 'Approva',
  'autopilot.appr.givenShort': 'Approvato',
  'autopilot.appr.opsShort': 'Approvato da noi',
  'autopilot.appr.opsFeedback':
    'L’abbiamo verificato e approvato, non devi fare nulla. Se ti va bene, puoi confermarlo qui. Eventuali modifiche scrivile direttamente al tuo referente.',
  'autopilot.appr.opsNoAction':
    'L’abbiamo verificato e approvato, non devi fare nulla. Eventuali modifiche scrivile direttamente al tuo referente.',
  'autopilot.appr.opsChanged':
    'I contenuti sono cambiati dal tuo riscontro del {date}. Abbiamo verificato e approvato la versione attuale.',
  'autopilot.appr.opsConfirm': 'Per me va bene',
  'autopilot.appr.opsConfirmAsk': 'Salvare il tuo riscontro?',
  'autopilot.appr.opsDone': 'Grazie, il tuo riscontro è stato salvato.',
  'autopilot.appr.opsAllDone': 'Tutto approvato. Se noti qualcosa, faccelo sapere.',
  'autopilot.appr.launchHintOps':
    'Approviamo l’avvio non appena target, messaggi e gestione delle risposte sono verificati.',
  'autopilot.camp.readonlyOps': 'Vuoi modificare qualcosa? Dillo al tuo referente e lo sistemiamo.',
  'autopilot.appr.pvShow': 'Vedi',
  'autopilot.appr.pvHide': 'Comprimi',
  'autopilot.appr.pvShowFirst': 'Prima controlla cosa approvi',
  'autopilot.appr.pvHeading': 'Ecco cosa approvi',
  'autopilot.appr.pvSampleTitle': 'Estratto delle aziende target',
  'autopilot.appr.pvSampleFoot':
    'Un campione del tuo pubblico — la lista completa la vedi durante l’operatività.',
  'autopilot.appr.pvEmpty': 'Stiamo preparando il contenuto per te.',
  'autopilot.appr.pvFirms': '{n} aziende',
  'autopilot.appr.pvPace': '{n}/giorno',
  'autopilot.appr.pvStart': 'Subito',
  'autopilot.appr.pvWait': '+{d} giorni',
  'autopilot.appr.pvSubject': 'Oggetto:',
  'autopilot.appr.pvAb': 'Variante A/B:',
  'autopilot.appr.pvLaunchReady':
    'Tutti i contenuti sono approvati — all’avvio parte la prima email.',
  'autopilot.appr.pvLaunchWait': 'L’avvio si sblocca quando ci sono le tre approvazioni sopra.',
  'autopilot.appr.allDone':
    'Tutto approvato — avviamo la tua campagna e ti avviseremo non appena sarà attiva.',
  'autopilot.appr.confirmAsk': 'Approvare in modo vincolante?',
  'autopilot.appr.copy': 'Testi & sequenza',
  'autopilot.appr.copyHint': 'Le tue email, già pronte — vedi esempi reali, non modelli generici.',
  'autopilot.appr.done': 'Approvazione registrata — con timestamp e checksum.',
  'autopilot.appr.error': 'Approvazione non riuscita — riprova.',
  'autopilot.appr.given': 'Approvato il {date}',
  'autopilot.appr.hash': 'Checksum',
  'autopilot.appr.icp': 'Target & segmento',
  'autopilot.appr.icpHint': 'Chi contatta il tuo motore — settori, regioni, decisori.',
  'autopilot.appr.intro':
    'Tu approvi, noi eseguiamo. Ogni approvazione viene documentata — mantieni il controllo su target, contenuti e avvio.',
  'autopilot.appr.launch': 'Avvio campagna',
  'autopilot.appr.launchHint':
    "La tua approvazione finale — solo dopo la prima email lascerà l'azienda.",
  'autopilot.appr.locked': 'Si sblocca non appena arrivano le altre approvazioni',
  'autopilot.appr.logIntro':
    'Ogni approvazione viene registrata con data e ora; il contenuto approvato viene bloccato e ancorato tramite checksum.',
  'autopilot.appr.logTitle': 'Registro delle approvazioni',
  'autopilot.appr.pending': 'In attesa di te',
  'autopilot.appr.preparingShort': 'In preparazione',
  'autopilot.appr.preparing':
    'Stiamo preparando il contenuto — ti avviseremo appena potrai approvarlo.',
  'autopilot.appr.playbook': 'Playbook di risposta',
  'autopilot.appr.playbookHint':
    'Come rispondiamo alle domande per tuo conto, prima di effettuare il passaggio.',
  'autopilot.appr.soon': 'Contenuto in preparazione per te',
  'autopilot.appr.title': 'Le tue approvazioni',
  'autopilot.camp.approvedAt': 'Approvata da te il {date}',
  'autopilot.camp.approvedShort': 'Approvata — avvio in arrivo',
  'autopilot.camp.audience': 'Target',
  'autopilot.camp.audienceN': '{n} aziende nel segmento',
  'autopilot.camp.awaitApproval': 'In attesa della tua approvazione al lancio',
  'autopilot.camp.back': 'Tutte le campagne',
  'autopilot.camp.chip.paused': 'In pausa',
  'autopilot.camp.chip.running': 'In corso',
  'autopilot.camp.chip.scheduled': 'Programmata',
  'autopilot.camp.hideMail': 'Comprimi',
  'autopilot.camp.nextSend': 'Prossimo invio {when}',
  'autopilot.camp.open': 'Visualizza',
  'autopilot.camp.pace': 'fino a {n} email/giorno tramite le tue caselle di posta',
  'autopilot.camp.progress': '{done} di {total} aziende contattate',
  'autopilot.camp.queue': '{n} aziende verificate in riserva',
  'autopilot.camp.readonly':
    'Vuoi modificare qualcosa? Contatta il tuo referente — ogni modifica va live solo dopo la tua approvazione.',
  'autopilot.camp.runningSince': 'in corso dal {date}',
  'autopilot.camp.sReplies': '{n} risposte',
  'autopilot.camp.sSent': '{n} inviate',
  'autopilot.camp.sectionRunning': 'In corso',
  'autopilot.camp.sending': 'Invio',
  'autopilot.camp.sequence': 'La sequenza',
  'autopilot.camp.sequenceHint':
    "Ogni email è un unicum — le {{variabili}} vengono compilate dall'engine individualmente per ogni azienda.",
  'autopilot.camp.showMail': 'Visualizza email',
  'autopilot.camp.startsAt': 'Inizia {when}',
  'autopilot.camp.stepStart': 'Inizio della sequenza',
  'autopilot.camp.stepWait': '+{n} giorni dopo',
  'autopilot.camp.subject': 'Oggetto',
  'autopilot.contact.hint':
    "Linea diretta, niente sistema di ticket. L'arresto d'emergenza si trova sotto Approvazioni.",
  'autopilot.contact.title': 'Il tuo referente',
  'autopilot.contact.write': 'Scrivi un messaggio',
  'autopilot.end.testing': 'In test ora: {label}',
  'autopilot.exp.empty':
    'Non appena il tuo Engine avvia delle ipotesi di test, qui vedrai cosa viene testato — e perché.',
  'autopilot.exp.since': 'dal {date}',
  'autopilot.exp.title': 'Esperimenti',
  'autopilot.foot.details': 'Dettagli in Tecnica',
  'autopilot.foot.quota': 'Contingente {used}/{target}',
  'autopilot.health.amber': 'Sotto osservazione',
  'autopilot.health.blacklistOk': 'Blacklist pulite',
  'autopilot.health.bounce': 'Tasso di bounce {n}%',
  'autopilot.health.green': 'Tutti i sistemi ok',
  'autopilot.health.red': 'Ce ne stiamo occupando',
  'autopilot.health.suppressed': '{n} disiscrizioni rispettate, bloccate su tutte le campagne',
  'autopilot.health.title': 'Stato del sistema',
  'autopilot.hist.campaigns': 'Completate',
  'autopilot.hist.completed': 'completata',
  'autopilot.hist.emptyHint':
    'Non appena la tua prima campagna sarà in corso, qui si raccoglieranno i bilanci delle campagne e i risultati dei test completati.',
  'autopilot.hist.emptyTitle': 'Nessuno storico ancora',
  'autopilot.hist.intro':
    'Cosa è in corso, cosa è stato completato — e cosa ha imparato nel frattempo la tua engine. Consulta e approfondisci; il controllo avviene tramite le tue approvazioni.',
  'autopilot.hist.ongoing': 'in corso',
  'autopilot.hist.running': 'in corso',
  'autopilot.hist.steps': '{n} fasi della sequenza',
  'autopilot.hist.tests': 'Test completati',
  'autopilot.hist.tie': 'Pareggio',
  'autopilot.hist.title': 'Campagne',
  'autopilot.hist.vs': 'contro',
  'autopilot.ho.none': "Nessun passaggio in sospeso — l'Engine sta lavorando.",
  'autopilot.ho.title': 'Passaggi caldi',
  'autopilot.infra.dns': 'Autenticazione e-mail configurata (SPF · DKIM · DMARC)',
  'autopilot.infra.domain': 'Dominio di invio registrato — a tuo nome',
  'autopilot.infra.mailboxes': 'Caselle di posta configurate',
  'autopilot.infra.title': 'La tua infrastruttura',
  'autopilot.infra.verify': "Dominio verificato e abilitato all'invio",
  'autopilot.infra.yourTask': 'Il tuo compito',
  'autopilot.setup.title': 'La tua engine prende forma',
  'autopilot.setup.intro':
    'Cosa stiamo costruendo per te in questo momento — ogni passo documentato.',
  'autopilot.setup.ev.domain_registered':
    'Dominio di invio {domain} registrato — intestato alla tua azienda, il titolare sei tu.',
  'autopilot.setup.ev.dns_shield':
    'Rete di sicurezza DNS per {domain} attiva: autenticazione del mittente (SPF · DKIM · DMARC) e protezione anti-spoofing.',
  'autopilot.setup.ev.redirect_live':
    '{domain} porta ora i visitatori direttamente su {target} — piena trasparenza per ogni destinatario.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} caselle configurate su {domain}, protette e cifrate.',
  'autopilot.setup.ev.warmup_started':
    'Rete di riscaldamento avviata: {n} caselle costruiscono reputazione di consegna giorno dopo giorno.',
  'autopilot.setup.ev.warmup_progress':
    'Riscaldamento: giorno {day} di {total} — {rate} % di consegna in posta in arrivo.',
  'autopilot.setup.ev.blacklist_clean':
    'Controllo reputazione: {n} blacklist verificate — tutto pulito.',
  'autopilot.kpi.contacted': 'Contattati',
  'autopilot.kpi.delivered': 'Consegnati',
  'autopilot.kpi.handovers': 'Passaggi',
  'autopilot.kpi.lockedHint': 'I numeri appariranno non appena la tua campagna sarà attiva.',
  'autopilot.kpi.modulePrice': 'Modulo: {price}/mese',
  'autopilot.kpi.replies': 'Risposte',
  'autopilot.kpi.won': 'Vinti',
  'autopilot.kpi.wonValueLabel': 'Valore ordini vinti',
  'autopilot.mb.empty': 'Le tue caselle email sono in fase di configurazione.',
  'autopilot.mb.hint':
    'Il warmup è sempre attivo — anche in fase live, un livello minimo costante mantiene alta la deliverability.',
  'autopilot.mb.perDay': '{n} email/giorno',
  'autopilot.mb.score': 'Deliverability',
  'autopilot.mb.st.connecting': 'connessione in corso',
  'autopilot.mb.st.ready': 'pronto',
  'autopilot.mb.st.sending': 'attivo · Warmup di mantenimento',
  'autopilot.mb.st.warmup': 'Warmup · Giorno {d}/{total}',
  'autopilot.mb.title': 'Caselle email & Warmup',
  'autopilot.mb.count': '{active} di {total} attivi',
  'autopilot.mb.scoreLabel': 'Punteggio di recapito',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.mode.lockedHint': 'Autopilot è un modulo aggiuntivo – scopri di più',
  'autopilot.mode.search': 'Standard',
  'autopilot.nav.history': 'Campagne',
  'autopilot.nav.overview': 'Dashboard',
  'autopilot.nav.replies': 'Kanban',
  'autopilot.nav.tech': 'Tecnica',
  'autopilot.notActive.hint': 'Se desideri utilizzare Autopilot, contattaci.',
  'autopilot.notActive.title': 'Autopilot non è attivo per questo account',
  'autopilot.ov.activeTitle': 'Il tuo motore è al lavoro',
  'autopilot.ov.awaitCta': 'Vai alle approvazioni',
  'autopilot.ov.awaitHint': "Mancano solo le tue approvazioni — dopo avvieremo l'invio.",
  'autopilot.ov.awaitTitle': 'Il tuo motore è pronto',
  'autopilot.ov.endedTitle': 'Autopilot terminato',
  'autopilot.ov.engineTitle': 'La tua Engine',
  'autopilot.ov.offerHint':
    'Non appena il contratto sarà firmato, inizieremo a configurare il tuo motore.',
  'autopilot.ov.offerTitle': 'Il tuo Autopilot è in preparazione',
  'autopilot.ov.pausedHint': 'Non viene inviato nulla. Contatta il tuo referente per riprendere.',
  'autopilot.ov.pausedTitle': 'Invio in pausa',
  'autopilot.ov.setupHint':
    'Dominio, autenticazione e caselle di posta sono in fase di configurazione — pensiamo a tutto noi. Non devi fare nulla; ti contattiamo appena le tue prime approvazioni sono pronte.',
  'autopilot.ov.setupTitle': 'Stiamo costruendo il tuo motore',
  'autopilot.ov.warmupDay': 'Warmup · Giorno {d} di {total}',
  'autopilot.ov.warmupHint':
    'Le tue caselle di posta vengono riscaldate con cura affinché le tue email arrivino nella posta in arrivo — non nello spam. Nel frattempo puoi occuparti delle tue approvazioni.',
  'autopilot.ov.warmupTitle': 'Warmup in corso',
  'autopilot.pause.hintContact':
    'Il tuo referente ferma l’invio per te: scrivigli e ha effetto subito.',
  'autopilot.pause.action': "Metti in pausa l'invio",
  'autopilot.pause.hint':
    "Interrompe l'invio immediatamente e completamente. Il tuo referente ti contatterà personalmente in seguito.",
  'autopilot.pause.title': "Stop d'emergenza",
  'autopilot.pause.confirm': 'Fermare davvero?',
  'autopilot.pause.done': 'Invio in pausa — il tuo referente ti contatterà personalmente.',
  'autopilot.pause.error': 'La pausa non è riuscita — contatta direttamente il tuo referente.',
  'autopilot.pause.pausedHint':
    "L'invio è in pausa. Il tuo referente ti contatterà personalmente prima di riprendere.",
  'autopilot.pulse.checked': "{n} verificati dall'IA",
  'autopilot.pulse.next': 'Prossimo invio {when}',
  'autopilot.pulse.queue': '{n} in coda',
  'autopilot.pulse.quiet':
    "Ancora nessun invio — l'engine è in fase di avvio. Non appena parte, qui vedrai il polso giornaliero.",
  'autopilot.pulse.researched': '{n} analizzati',
  'autopilot.pulse.sent': '{n} inviati oggi',
  'autopilot.pulse.title': "L'Engine in questo momento",
  'autopilot.quota.progress': '{used} di ~{target} aziende',
  'autopilot.quota.title': 'Quota di questo mese',
  'autopilot.rc.interested': 'Interesse',
  'autopilot.rc.later': 'Più avanti',
  'autopilot.rc.noNeed': 'Nessuna necessità',
  'autopilot.rc.ooo': 'Assenza',
  'autopilot.rc.unsub': 'Disiscrizione',
  'autopilot.rcls.title': 'Risposte per categoria',
  'autopilot.rep.actionFailed': 'Azione non riuscita — riprova.',
  'autopilot.rep.call': 'Chiama ora',
  'autopilot.rep.contacted': 'Segna come gestito',
  'autopilot.rep.contactedDone': 'Gestito il {date}',
  'autopilot.rep.contactedSet': 'Segnato come gestito — grazie, ci è di grande aiuto.',
  'autopilot.rep.contactedShort': 'Gestito',
  'autopilot.rep.dealPlaceholder': "Valore dell'ordine",
  'autopilot.rep.emptyHint':
    'Non appena la tua campagna sarà attiva, qui appariranno le risposte delle aziende contattate — con lo storico completo e la nostra valutazione.',
  'autopilot.rep.emptyTitle': 'Ancora nessuna risposta',
  'autopilot.rep.intro':
    'Ogni risposta arriva qui — classificata e con lo storico completo. Noi chiariamo, tu telefoni.',
  'autopilot.rep.lostPlaceholder': 'Motivo (opzionale)',
  'autopilot.rep.noFit': 'Non un fit',
  'autopilot.rep.noFitSet': 'Contrassegnato come "non un fit" — la tua Engine impara da questo.',
  'autopilot.rep.saveClose': 'Salva',
  'autopilot.rep.title': 'Risposte',
  'autopilot.rep.viewThread': 'Vedi conversazione ({n})',
  'autopilot.rep.threadEmpty': 'Nessuno storico per questa conversazione.',
  'autopilot.rep.threadSent': 'Inviato · {step}',
  'autopilot.rep.threadSentPlain': 'Inviato da te',
  'autopilot.rep.threadFoot': 'Inviato a tuo nome. Le modifiche passano dal tuo referente.',
  'autopilot.rep.cls.interested': 'Interesse',
  'autopilot.rep.cls.later': 'Più tardi',
  'autopilot.rep.cls.noNeed': 'Nessun bisogno',
  'autopilot.rep.cls.referral': 'Altro referente',
  'autopilot.rep.cls.question': 'Domanda',
  'autopilot.rep.cls.outOfOffice': 'Assenza',
  'autopilot.rep.cls.unsubscribed': 'Disiscrizione',
  'autopilot.rep.wonNoValue': 'Vinto',
  'autopilot.rep.wonSet':
    "Vinto — ottimo lavoro! Il valore dell'ordine confluisce nel tuo bilancio.",
  'autopilot.report.first':
    'Il tuo prossimo report arriva il {date} — inviati, consegnati, risposte, passaggi. Senza abbellimenti.',
  'autopilot.report.title': 'Report mensile',
  'autopilot.res.angles': 'Approcci',
  'autopilot.res.anglesHint': 'Con quale spunto avviamo la conversazione.',
  'autopilot.res.emptyHint':
    'Non appena la tua campagna sarà attiva e arriveranno le prime risposte, qui vedrai cosa funziona e cosa no.',
  'autopilot.res.emptyTitle': 'Ancora nessuna risonanza',
  'autopilot.res.footnote':
    'Le percentuali sono disponibili solo a partire da 30 aziende contattate — sotto questa soglia una percentuale sarebbe casuale.',
  'autopilot.res.intro':
    'Da dove arrivano le risposte — e a cosa nessuno reagisce. Il tuo Engine misura ogni contatto e ne trae le conseguenze.',
  'autopilot.res.learnedTitle': 'Cosa ne fa il tuo Engine',
  'autopilot.res.segments': 'Segmenti',
  'autopilot.res.segmentsHint': 'Quali settori e ruoli rispondono.',
  'autopilot.res.subjects': 'Oggetti email',
  'autopilot.res.subjectsHint': 'Cosa viene aperto e a cosa si risponde.',
  'autopilot.res.thin': 'dati insufficienti',
  'autopilot.res.title': 'Cosa funziona',
  'autopilot.spark.empty': "Appare non appena inizia l'invio.",
  'autopilot.spark.title': 'Attività di invio (4 settimane)',
  'autopilot.stage.clarify': 'In chiarimento',
  'autopilot.stage.handover': 'Trasferito',
  'autopilot.stage.lost': 'Perso',
  'autopilot.stage.new': 'Nuovo',
  'autopilot.stage.won': 'Vinto',
  'autopilot.status.active': 'Attivo',
  'autopilot.status.awaiting': 'In attesa di approvazione',
  'autopilot.status.contract': 'Contratto firmato',
  'autopilot.status.ended': 'Terminato',
  'autopilot.status.offer': 'In preparazione',
  'autopilot.status.paused': 'In pausa',
  'autopilot.status.setup': 'Configurazione',
  'autopilot.status.warmup': 'Warmup',
  'autopilot.step.approvals': 'Approvazioni',
  'autopilot.step.live': 'Live',
  'autopilot.step.setup': 'Configurazione',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.talk.all': 'Vedi tutte',
  'autopilot.talk.empty':
    "Non appena la tua campagna è live, qui vedrai con chi sta parlando l'engine.",
  'autopilot.talk.emptyLive':
    "Nessuna conversazione aperta al momento — alla prossima risposta l'azienda apparirà qui.",
  'autopilot.talk.title': 'In conversazione ora',
  'autopilot.tasks.approvals': '{n} approvazioni in attesa',
  'autopilot.tasks.call1': 'Un passaggio caldo è in attesa della tua chiamata',
  'autopilot.tasks.calls': '{n} passaggi caldi in attesa della tua chiamata',
  'autopilot.tasks.none': "Nulla da fare — l'Engine sta lavorando per te.",
  'autopilot.tasks.title': 'I tuoi compiti',
  'autopilot.tech.allGreen': 'Tutto operativo',
  'autopilot.tech.auto': 'In esecuzione automatica',
  'autopilot.tech.autoHint':
    'Queste attività di manutenzione vengono eseguite in background — senza che tu debba muovere un dito.',
  'autopilot.tech.blacklists': 'Monitoraggio blacklist',
  'autopilot.tech.clean': 'pulita',
  'autopilot.tech.dmarcReports': 'Report aggregati DMARC attivi',
  'autopilot.tech.domains': 'Domini di invio',
  'autopilot.tech.integrations': 'Sistemi collegati',
  'autopilot.tech.intro':
    "La tua intera infrastruttura di invio a colpo d'occhio — domini, autenticazione DNS, caselle postali, monitoraggio. Configuriamo tutto e lo manteniamo attivo; non devi occupartene tu.",
  'autopilot.tech.mailboxes': 'Caselle postali & autenticazione',
  'autopilot.tech.nis2': 'Dominio confermato',
  'autopilot.tech.owner': 'Proprietario: tu',
  'autopilot.tech.pending':
    'La tua infrastruttura è in fase di configurazione — presto qui apparirà la tua sala di controllo completa.',
  'autopilot.tech.pipeline': 'La pipeline AI',
  'autopilot.tech.pipelineHint':
    "Ogni singola email passa attraverso questi controlli indipendenti prima di essere pronta per l'invio.",
  'autopilot.tech.placement': 'Ultimo test di posizionamento: {n}% posta in arrivo',
  'autopilot.tech.registrar': 'Registrar: {name}',
  'autopilot.tech.rep': 'Reputazione {n}',
  'autopilot.tech.replyLogic': 'Intelligenza delle risposte',
  'autopilot.tech.reputation': 'Reputazione & monitoraggio consegna',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.title': 'Tecnica e recapitabilità',
  'autopilot.tech.warmup': 'Warmup',
  'autopilot.warm.traffic.weekendShort': 'WE',
  'autopilot.warm.traffic.pauseShort': 'Pausa',
  'autopilot.warm.traffic.weekend':
    'Fine settimana: la rete di riscaldamento riduce l’attività come previsto',
  'autopilot.warm.traffic.pause': 'Giorno di riposo nella rete di riscaldamento',
  'autopilot.ov.hero.warmOffen':
    'Le tue caselle sono ancora in riscaldamento (giorno {d} di {total}). Approva ora e partiremo appena saranno pronte.',
  'autopilot.ov.hero.warmFrei':
    'Tutto approvato. Le tue caselle sono ancora in riscaldamento (giorno {d} di {total}), poi partirà la prima email.',
  'autopilot.ov.hero.fertigOffen':
    'Le tue caselle hanno completato il riscaldamento. Mancano solo le tue approvazioni per partire.',
  'autopilot.ov.hero.fertigFrei':
    'Riscaldamento completato e tutto approvato. Stiamo preparando il primo invio.',
  'autopilot.ov.hero.startNachFreigabe': 'appena avrai approvato',
  'autopilot.ov.hero.startInVorbereitung': 'in preparazione',
  'autopilot.mb.st.fertig': 'Riscaldamento completato',
  'autopilot.appr.zf.lead':
    'Contatteremo tutte le aziende che non escludi. La spunta è facoltativa e ci aiuta a capire quali aziende preferisci.',
  'autopilot.appr.zf.f.alle': 'Tutte {n}',
  'autopilot.appr.zf.f.dabei': 'Incluse {n}',
  'autopilot.appr.zf.f.raus': 'Escluse {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'Senza contatto {n}',
  'autopilot.camp.offenN': '{n} approvazioni in sospeso: {liste}',
  'autopilot.camp.offen1': 'Un’approvazione in sospeso: {liste}',
  'autopilot.appr.zf.neuTitle': 'Nuova dalla tua ultima visita',
  'autopilot.appr.zf.g.bekanntHinweis':
    '«La conosciamo già» rimuove l’azienda dai tuoi suggerimenti in modo permanente, anche nelle campagne future.',
  'autopilot.camp.offenDanach': ', poi {label}',
  'autopilot.ov.ring.bereit': 'pronte',
  'autopilot.ov.hero.bereitOffen':
    'Pronto al lancio: tutte le {n} caselle hanno almeno {s} di deliverability. Mancano solo le tue approvazioni.',
  'autopilot.ov.hero.bereitFrei':
    'Pronto e approvato. Tutte le {n} caselle hanno almeno {s} di deliverability; prepariamo il primo invio.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} caselle su {n} sono pronte (deliverability da {s}). Approva ora e partiamo appena lo sono tutte.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} caselle su {n} sono pronte (deliverability da {s}). Partiamo appena lo sono tutte.',
  'autopilot.ov.hero.scoreRegel': 'Deliverability per casella · pronta da {s}',
  'autopilot.mb.st.bereit': 'Pronta al lancio',
  'autopilot.mb.st.bereitTeil': '{bereit} su {n} pronte',
  'autopilot.mb.st.mbBereit': 'pronta · giorno {d}/{total}',
  'autopilot.warm.regel':
    'Una casella è pronta da un punteggio di deliverability di {s}. I {total} giorni sono un riferimento, non la condizione.',
  'autopilot.camp.vs.post': '{n} per posta',
  'autopilot.camp.vs.geprueft': '{n} confermati',
  'autopilot.camp.vs.ungeprueft': '{n} non confermati',
  'autopilot.camp.vs.zust.ok': 'Indirizzo confermato',
  'autopilot.camp.vs.zust.ungeprueft': 'Indirizzo non confermato',
  'autopilot.camp.vs.erkl.geprueft':
    'Verifichiamo ogni indirizzo prima dell’invio. Confermato significa che il server lo ha accettato. Non confermato indica spesso un catch-all, dove il server risponde allo stesso modo per ogni indirizzo.',
  'autopilot.camp.vs.absender': 'Mittente',
  'autopilot.camp.vs.takt': 'Ritmo',
  'autopilot.camp.vs.taktWert': '{n} email al giorno',
  'autopilot.camp.vs.naechster': 'prossimo invio {when}',
  'autopilot.camp.vs.keinAbsender':
    'A questa campagna non è ancora stata assegnata una casella mittente. La configureremo prima dell’avvio.',
  'autopilot.camp.vs.hint':
    'Così parte l’e-mail. Sottolineato in verde: inserito dalla nostra ricerca. Tratteggiato: compilato per persona all’invio.',
  'autopilot.camp.vs.wartetTitel':
    'Aziende senza indirizzo e-mail trovato. Si aggiungono automaticamente appena viene individuato un contatto con indirizzo.',
  'autopilot.camp.vs.empfaenger': 'Destinatari',
  'autopilot.camp.vs.vorschauFuer': 'Anteprima per',
  'autopilot.camp.vs.an': 'A',
  'autopilot.camp.vs.platzhalter': 'compilato per persona all’invio',
  'autopilot.erkl.aria': 'Come viene calcolato?',
  'autopilot.erkl.quelle': 'Fonte: {q}',
  'autopilot.warm.traffic.title': 'Traffico di riscaldamento delle tue caselle',
  'autopilot.warm.traffic.hint':
    'Email di riscaldamento in uscita e registrate nella posta in arrivo di tutte le tue caselle.',
  'autopilot.mb.place.hint':
    'E-mail di riscaldamento in posta in arrivo e spam su tutte le tue caselle.',
  'autopilot.ov.zu.sub': 'su {n} email di riscaldamento negli ultimi 7 giorni',
  'autopilot.warm.scoreChart.title': 'Punteggio di recapito per casella',
  'autopilot.warm.scoreChart.hint':
    'La fascia copre tutte le caselle, la linea segue la più bassa. Pronto da {s}.',
  'autopilot.warm.scoreChart.perBox': 'per casella',
  'autopilot.warm.scoreChart.perDomain': 'per dominio',
  'autopilot.warm.scoreChart.schwelle': 'pronta da {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Ogni punto è una variazione del punteggio salvata, con il valore attuale a destra.',
  'autopilot.warm.scoreChart.messpunkt': 'Punto {n}',
  'autopilot.warm.chart.gesendet': 'Inviate',
  'autopilot.warm.scoreChart.titleDomain': 'Punteggio di recapito per dominio',
  'autopilot.warm.scoreChart.hintDomain':
    'La fascia copre i tuoi domini, la linea segue il più basso. Una casella è pronta da {s}.',
  'autopilot.warm.erkl.traffic':
    'Qui vedi le email di riscaldamento della rete lemwarm. I numeri includono il traffico in entrata dalla rete e non mostrano gli invii delle campagne.',
  'autopilot.warm.erkl.placement':
    'I valori mostrano dove arrivano le tue email di riscaldamento, comprese quelle in entrata dalla rete. Il tasso di posta in arrivo si calcola dividendo le email in posta in arrivo per la somma di quelle in posta in arrivo e in spam.',
  'autopilot.warm.erkl.tage':
    'I giorni sono un riferimento per il riscaldamento; il requisito è un punteggio di recapito di almeno {s} per casella.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'Questo è traffico della rete di riscaldamento, non ancora email delle campagne.',
  'autopilot.warm.placement.vorwoche':
    'Tasso di posta in arrivo degli ultimi 7 giorni registrati rispetto ai 7 giorni precedenti.',
  'autopilot.camp.vs.absenderKonto':
    'Queste caselle appartengono al tuo account. Quale di esse invia questa campagna lo definiamo prima dell’avvio.',
  'autopilot.camp.vs.quellePruefung': 'verifica e-mail',
  'autopilot.appr.zf.unvollstaendig':
    'Mostriamo le aziende più recenti fino al limite di visualizzazione. Quelle più vecchie non compaiono qui.',
  'autopilot.appr.zf.ladeFehler':
    'Non è stato possibile caricare una parte delle tue aziende. Ricarica la pagina e riproviamo.',
  'autopilot.warm.scoreChart.schwelleKurz': 'pronto',
  'autopilot.warm.scoreChart.alle': 'Tutte',
  'autopilot.warm.scoreChart.hintEines': 'Andamento di {adresse}. Pronto da {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    "La tua carta verrà salvata per futuri riacquisti con un clic. Viene addebitata solo quando confermi espressamente un riacquisto all'importo mostrato — nessun abbonamento, nessuna ricarica automatica. Puoi rimuovere la carta in qualsiasi momento nel portale clienti.",
  'refill.title': 'Acquista altri contatti',
  'refill.subtitle': 'Con la tua carta salvata — senza ripassare dal checkout.',
  'refill.choose': 'Scegli un pacchetto',
  'refill.pack': '{n} contatti',
  'refill.net': '{amount} IVA esclusa',
  'refill.total': 'Totale',
  'refill.inclTax': 'incl. {tax} di IVA',
  'refill.reverseCharge':
    "Senza IVA — inversione contabile, l'imposta è a carico del destinatario.",
  'refill.cardLabel': 'Pagato con {brand} •••• {last4}',
  'refill.cta': 'Paga {amount} ora',
  'refill.quoting': "Calcolo dell'importo …",
  'refill.paying': 'Pagamento in corso …',
  'refill.terms': 'Pagamento unico, nessun abbonamento. I tuoi contatti non scadono.',
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Acquista contatti',
  'packs.first.subtitle': 'Scegli un pacchetto, poi usalo per sbloccare i contatti.',
  'packs.first.balance': 'Contatti disponibili: {n}',
  'packs.first.popular': 'Popolare',
  'packs.first.cta': 'Continua al pagamento',
  'packs.first.redirecting': 'Reindirizzamento a Stripe…',
  'packs.first.checkoutNote':
    "Paghi in modo sicuro con Stripe nel passaggio successivo, dove vedi l'importo finale IVA inclusa.",
  'packs.first.error': 'Non è stato possibile avviare il pagamento. Riprova.',
  'packs.first.loadError': 'Non è stato possibile caricare i pacchetti in questo momento.',
  'packs.first.retry': 'Riprova',
  'refill.success': '{n} contatti accreditati. Nuovo saldo: {balance}.',
  'refill.again': 'Acquista un altro pacchetto',
  'refill.amountChanged': "L'importo è cambiato. Conferma il nuovo importo, per favore.",
  'refill.inProgress': 'Un riacquisto è già in corso. Un momento …',
  'refill.processing': 'Il pagamento è ancora in elaborazione. Ricontrolliamo tra un momento.',
  'refill.failedDeclined': 'La tua banca ha rifiutato il pagamento. Non è stato addebitato nulla.',
  'refill.failedAuth':
    'La conferma con la tua banca non è stata completata. Non è stato addebitato nulla.',
  'refill.failed': 'Il pagamento non è andato a buon fine. Non è stato addebitato nulla.',
  'refill.error': 'Non ha funzionato. Riprova tra un momento.',
  'refill.checking': 'Stiamo verificando lo stato del tuo pagamento …',
  'refill.unknown':
    'Non siamo ancora riusciti a confermare il pagamento. Controlla il tuo saldo prima di acquistare di nuovo.',
  'refill.retryQuote': "Ricarica l'importo",
  'refill.checkStatus': 'Verifica il pagamento',

  'auth.register.errPwPolicy':
    'La password è troppo debole. Usa almeno 8 caratteri con maiuscole, minuscole, un numero e un carattere speciale.',
  'auth.err.emailTaken': 'Questo indirizzo e-mail è già registrato. Accedi.',
  'auth.err.rateLimited':
    'Troppi tentativi da questa connessione. Riprova entro {minutes} minuti al massimo.',
  'auth.err.rateLimitedLater': 'Troppi tentativi da questa connessione. Riprova più tardi.',
  'auth.err.network': 'Impossibile raggiungere il server. Controlla la tua connessione a internet.',
  'auth.err.busy': 'Il server è molto carico in questo momento. Riprova tra un attimo.',
  'auth.err.signupFailed': 'Registrazione non riuscita. Riprova tra un attimo.',
  'auth.err.invalidInput': 'Controlla i dati inseriti.',
  'auth.err.turnstileFailed':
    'La verifica anti-bot non è riuscita o è scaduta. Ricarica la pagina e riprova.',
  'auth.err.turnstileBlocked':
    'Non è stato possibile eseguire il controllo di sicurezza. Un blocco di annunci o tracker potrebbe impedirlo: consenti challenges.cloudflare.com per questa pagina o prova un altro browser.',
  'auth.err.popupBlocked':
    'La finestra di accesso è stata bloccata. Consenti i pop-up per questo sito e riprova.',
  'auth.err.popupClosed':
    'La finestra di accesso è stata chiusa prima del completamento dell’autenticazione.',
  'auth.err.otherProvider': 'Esiste già un account con questa e-mail. Accedi con {provider}.',
  'auth.err.otherMethod':
    'Esiste già un account con questa e-mail. Accedi con il metodo usato per la registrazione (Google, Microsoft o e-mail e password).',
  'auth.err.providerPassword': 'e-mail e password',
  'auth.err.firstName': 'Inserisci il tuo nome.',
  'auth.err.lastName': 'Inserisci il tuo cognome.',
  'auth.err.pwLong': 'La password è troppo lunga.',
  'auth.err.oauthFailed': 'Accesso con il provider di identità non riuscito. Riprova.',
  'auth.err.noEmailFromProvider':
    'Non abbiamo ricevuto un indirizzo e-mail dal tuo provider. Prova un altro metodo di accesso.',
  'auth.err.ssoUnavailable':
    'L’accesso con Google o Microsoft non è al momento disponibile. Usa e-mail e password.',
  'auth.err.accountGone': 'Questo account è stato eliminato o disattivato.',
  'auth.err.sessionFailed': 'Impossibile creare la sessione. Riprova.',
  'auth.register.next.prism':
    'Passo successivo: descrivi il tuo target e vedi aziende reali. Paghi solo quando sblocchi i lead.',
  'auth.register.next.noCard':
    'Dopo la registrazione puoi iniziare subito. Nessun dato di pagamento richiesto.',
  'auth.register.next.trial':
    'Passo successivo: scegli un piano e provalo per 3 giorni. Serve una carta, 0 € oggi; poi il piano prosegue se non disdici prima della fine della prova.',
  'auth.register.next.plan':
    'Passo successivo: scegli un piano. Il pagamento con carta è dovuto subito.',
  'auth.register.busyHint': 'Stiamo creando il tuo account. Ci vogliono alcuni secondi.',
  'auth.login.legalSso':
    'Sei nuovo? Accedendo con Google o Microsoft viene creato automaticamente un account e accetti i nostri {terms}. Trovi le informazioni sui tuoi dati nella nostra {privacy}.',
  'auth.r19.form.pw.title': 'Requisiti della password',
  'auth.r19.form.pw.len': 'Almeno 8 caratteri',
  'auth.r19.form.pw.case': 'Maiuscole e minuscole',
  'auth.r19.form.pw.digit': 'Un numero',
  'auth.r19.form.pw.special': 'Un carattere speciale',
  'auth.r19.form.pw.met': 'soddisfatto',
  'auth.r19.form.pw.open': 'da soddisfare',
  'auth.r19.chat.greeting':
    'Scrivi qui la tua domanda. Se aggiungi il tuo indirizzo e-mail, potremo risponderti anche più tardi.',
  'auth.r19.chat.failed': 'Non riusciamo ad aprire la chat in questo momento. Scrivici invece a',

  'prism.abandon.fit': 'Le aziende non corrispondono',
  'prism.abandon.fitQ': 'Quali aziende ti aspettavi?',
  'prism.abandon.freeText': 'O diccelo in una frase…',
  'prism.abandon.later': 'Guarderò più tardi',
  'prism.abandon.price': 'Il prezzo',
  'prism.abandon.q': 'Domanda veloce: cosa ti frena?',
  'prism.abandon.send': 'Invia',
  'prism.abandon.skip': 'Salta',
  'prism.abandon.thanks': 'Grazie, ci aiuta davvero.',
  'prism.checkout.autoNote':
    'Passa automaticamente all’abbonamento Starter (250 crediti/mese) se non disdici entro i 3 giorni di prova.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '49 € oggi · dal giorno 4: 290 €/mese · disdetta mensile con un clic',
  'prism.abo.afterDelivery':
    'Ogni settimana ~{n} nuove aziende. Per ognuna cerchiamo il decisore, e paghi solo se lo troviamo.',
  'prism.abo.afterCredits':
    'Poi, ogni mese {credits} crediti per nuove aziende e nuovi contatti.',
  'prism.teaser.tag':
    'Referente gratis in anteprima',
  'prism.teaser.running':
    'Stiamo cercando il referente di {company} …',
  'prism.teaser.foundShort':
    'Referente trovato: {name}',
  'prism.teaser.noneShort':
    'Nessun referente con prova',
  'prism.teaser.failedShort':
    'Ricerca non possibile al momento',
  'prism.teaser.open':
    'Vedi',
  'prism.teaser.close':
    'Chiudi',
  'prism.teaser.role':
    'Ruolo',
  'prism.teaser.source':
    'Prova',
  'prism.teaser.email':
    'E-mail',
  'prism.teaser.src.impressum':
    'Note legali di {domain}',
  'prism.teaser.src.handelsregister':
    'Registro delle imprese',
  'prism.teaser.src.website':
    'Sito di {domain}',
  'prism.teaser.mail.verified':
    'verificata con il server di posta',
  'prism.teaser.mail.probable':
    'molto probabilmente valida',
  'prism.teaser.mail.found':
    'così come appare sul loro sito',
  'prism.teaser.mail.none':
    'nessuna e-mail personale trovata',
  'prism.teaser.foundNote':
    'Così ricerchiamo ognuna delle tue {n} aziende. L’e-mail completa la vedi dopo lo sblocco, il telefono dove disponibile.',
  'prism.teaser.noneBody':
    'Per {company} non abbiamo trovato nessun referente con prova (note legali, registro delle imprese o sito aziendale). Piuttosto che inventare, preferiamo non mostrarti nulla.',
  'prism.teaser.noneNote':
    'Dopo lo sblocco, un credito conta solo se troviamo un contatto.',
  'prism.teaser.failedBody':
    'La ricerca non è riuscita in questo momento. Dopo lo sblocco parte per tutte le {n} aziende.',
  'prism.teaser.cta':
    'Sblocca tutte le {n}',
  'prism.cardHint.body':
    'Il referente di {company} lo ricerchiamo dopo lo sblocco: nome e ruolo, più e-mail o telefono se pubblici.',
  'prism.cardHint.example':
    'Un esempio lo vedi sopra, da {top}.',
  'prism.cardHint.cta':
    'Sblocca',
  'prism.website.skip':
    'Continua senza sito',
  'prism.website.issue.own_product':
    'Questo è il nostro sito, non il tuo. Inserisci il sito della tua azienda, così capiamo cosa vendi.',
  'prism.website.issue.ai_chat':
    'È un link a una chat IA. Ci serve il sito della tua azienda, ad es. «tua-azienda.it».',
  'prism.website.issue.social':
    'Un profilo social ci dice troppo poco della tua offerta. Hai un sito tuo? Altrimenti salta pure questo passaggio.',
  'prism.website.issue.redirect':
    'È un link breve o di reindirizzamento. Inserisci direttamente l’indirizzo del tuo sito, ad es. «tua-azienda.it».',
  'prism.notice.title':
    'Una nota sui dati',
  'prism.notice.local_b2c':
    'I piccoli negozi per privati (ad es. parrucchieri o snack bar) online indicano spesso solo telefono e titolare. Lì troviamo e-mail verificate dei referenti più di rado che nelle aziende che vendono ad altre aziende.',
  'prism.notice.outside_dach':
    'I nostri dati sono più completi in Germania, Austria e Svizzera. Altrove mancano spesso note legali e registro delle imprese, quindi troviamo meno referenti.',
  'prism.notice.continue':
    'Puoi comunque avviare la ricerca.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'I tuoi {n} lead gratuiti, subito utilizzabili',
  'prism.free.tagRunning':
    'Stiamo cercando i tuoi {n} lead gratuiti',
  'prism.free.tagOne':
    'Il tuo lead gratuito, subito utilizzabile',
  'prism.free.tagNone':
    'Lead gratuiti: questa volta nessuno con prova',
  'prism.free.tagSlow':
    'I tuoi lead gratuiti richiedono un po’ più di tempo',
  'prism.free.slowBody':
    'La ricerca richiede più tempo del solito. Ti mostreremo qui i tuoi lead gratuiti appena sono pronti, anche se torni più tardi.',
  'prism.free.running':
    'Stiamo cercando i referenti delle tue aziende migliori … ({found} di {n})',
  'prism.free.noneBody':
    'Per le tue aziende migliori non abbiamo trovato nessun referente con prova ed e-mail (note legali, registro delle imprese o sito aziendale). Piuttosto che inventare, preferiamo non mostrarti nulla. Dopo lo sblocco, un credito conta solo se troviamo un contatto.',
  'prism.free.fewer':
    'Abbiamo potuto provarne {found} su {n}. Per le altre aziende in cima mancava una prova, lì non mostriamo nulla.',
  'prism.free.yours':
    'Copiali o esportali, sono tuoi.',
  'prism.free.export':
    'Esporta in CSV',
  'prism.free.copy':
    'Copia',
  'prism.free.copied':
    'Copiato',
  'prism.free.cta':
    'Sblocca tutte le {n}',
  'prism.free.usedNote':
    'I lead gratuiti valgono una volta per account e azienda. Questo referente lo vedi qui in anteprima.',
  'prism.free.csv.company':
    'Azienda',
  'prism.free.csv.domain':
    'Dominio',
  'prism.free.csv.name':
    'Nome',
  'prism.free.csv.role':
    'Ruolo',
  'prism.free.csv.email':
    'E-mail',
  'prism.free.csv.phone':
    'Telefono',
  'prism.free.csv.source':
    'Prova',
  'prism.pattern.first':
    'nome',
  'prism.pattern.last':
    'cognome',
  'prism.pattern.f':
    'n',
  'prism.hint.freeAbove':
    'Sbloccato gratis, vedi sopra',
  'prism.hint.dmsOne':
    '1 referente: {roles}',
  'prism.hint.dmsMany':
    '{count} referenti: {roles}',
  'prism.hint.dmsNoRole':
    '{count} referenti provati',
  'prism.hint.pattern':
    'Formato e-mail riconosciuto:',
  'prism.hint.src.impressum':
    'Note legali',
  'prism.hint.src.handelsregister':
    'Registro delle imprese',
  'prism.hint.src.website':
    'Sito web',
  'prism.hint.unlock':
    'Sblocca',
  'prism.hint.unlockSub':
    'referente',
  'prism.freelead.tagTop': 'La tua azienda migliore',
  'prism.rail.label': 'Avanzamento',
  'prism.rail.audience': 'Target',
  'prism.rail.website': 'Sito web',
  'prism.rail.refine': 'Rifinitura',
  'prism.rail.result': 'Risultato',
  'prism.rail.done': 'completato',
  'prism.steps.earlier': '{n} passaggi precedenti completati',
  'prism.lead.evidenceTag': 'Sul loro sito:',
  'prism.plan.termsStrong': 'Dal 4° giorno: 290 €/mese.',
  'prism.plan.termsBody':
    'Dopo i 3 giorni di prova il tuo accesso passa automaticamente all’abbonamento Starter (250 crediti/mese). Se disdici prima dal tuo account, paghi solo i 49 €.',
  'prism.rateLimited.body':
    'Hai esaurito le ricerche di oggi. Si riparte domani — i tuoi dati restano salvati.',
  'prism.rateLimited.title': 'Limite giornaliero raggiunto',
  'prism.results.queriesLabel': 'Come abbiamo cercato:',
  'prism.results.queriesMore': '+{count} altre',
  'prism.score.possible': 'Fit possibile',
  'prism.target.errEmpty': 'Prima dicci chi vuoi raggiungere — ad es. “dentisti a Milano”.',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Contatti trovati, ancora bloccati',
  'ld.reveal.hint':
    'Vedrai nome, e-mail e telefono dopo lo sblocco. Uno sblocco apre tutti i contatti di questa azienda.',
  'ld.reveal.cta': 'Sblocca i contatti',
  'ld.reveal.confirm':
    'Questo usa 1 credito. Poi vedrai i contatti di questa azienda per intero, e il piano di acquisizione non costa nulla in più.',
  'ld.reveal.confirmCta': 'Sblocca per 1 credito',
  'ld.reveal.busy': 'Sblocco in corso…',
  'ld.reveal.done': 'Contatti sbloccati, 1 credito usato.',
  'ld.reveal.already': 'Già sbloccato, non è stato addebitato nulla di nuovo.',
  'ld.reveal.notEligible':
    "Nessuna persona di contatto raggiungibile: non c'è nulla da sbloccare e non viene addebitato nulla.",
  'ld.reveal.verificationPending':
    'I contatti sono ancora in verifica. Riprova tra un minuto; non è stato addebitato nulla.',
  'ld.reveal.researchRunning':
    'La ricerca dei contatti è ancora in corso. Potrai sbloccare appena sarà finita.',
  'ld.reveal.failed': 'Lo sblocco non è riuscito. Riprova; non paghi mai due volte.',
  'ld.reveal.noCredits': 'Ti serve 1 credito per sbloccare.',
  'ld.reveal.buyContacts': 'Il tuo saldo è vuoto – qui puoi acquistare altri contatti',
  'ld.reveal.planLocked': 'Prima sblocca i contatti',
  'ld.reveal.planNoContact':
    'Nessuna persona di contatto raggiungibile, quindi nessun piano di acquisizione',
  'ld.contact.lockedEmailPhone': 'E-mail e telefono dopo lo sblocco',
  'ld.contact.lockedEmail': 'E-mail dopo lo sblocco',
  'ld.contact.lockedPhone': 'Telefono dopo lo sblocco',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Consegna settimanale',
  'delivery.card.badgeNew': 'Nuovo',
  'delivery.card.forAudience': 'per {name}',
  'delivery.card.amount': 'Ogni settimana ~{n} nuove aziende. Per ognuna cerchiamo il decisore, e paghi solo se lo troviamo.',
  'delivery.card.credits': 'Fino a {credits} crediti per consegna: 1 per azienda, 1 per decisore trovato',
  'delivery.card.switchLabel': 'Attiva o disattiva la consegna settimanale',
  'delivery.card.on': 'Attiva',
  'delivery.card.off': 'Disattivata',
  'delivery.card.offHint': 'Attivala e la prima consegna parte subito.',
  'delivery.card.next.label': 'Prossima consegna',
  'delivery.card.next.afterRating': 'appena hai valutato quella attuale, al più tardi il {date}',
  'delivery.card.next.soon': 'parte a breve',
  'delivery.card.running': 'Consegna {no} in corso: {delivered} di {target} aziende',
  'delivery.card.runningConnect': 'Consegna {no}: {delivered} aziende arrivate, ora cerchiamo i decisori',
  'delivery.card.lowCredits': 'Hai {credits} crediti, una consegna completa ne richiede {need}.',
  'delivery.card.topUp': 'Ricarica crediti',
  'delivery.card.loadFailed': 'Impossibile caricare la consegna.',
  'delivery.pause.out_of_credits.title': 'In pausa: crediti esauriti',
  'delivery.pause.out_of_credits.body': 'Con nuovi crediti la consegna riparte da sola.',
  'delivery.pause.niche_exhausted.title': 'In pausa: il tuo target è esaurito',
  'delivery.pause.niche_exhausted.body': 'Qui non troviamo più aziende nuove. Allargalo con un clic:',
  'delivery.pause.subscription_ended.title': 'In pausa: il tuo abbonamento è terminato',
  'delivery.pause.subscription_ended.body': 'Con un piano attivo la consegna continua.',
  'delivery.pause.subscription_ended.cta': 'Scegli un piano',
  'delivery.pause.subscription_paused.title': 'In pausa: il tuo abbonamento è sospeso',
  'delivery.pause.subscription_paused.body': 'Appena il tuo abbonamento riparte, la consegna continua.',
  'delivery.pause.payment_issue.title': 'In pausa: pagamento in sospeso',
  'delivery.pause.payment_issue.body': 'Aggiorna il metodo di pagamento e la consegna continua.',
  'delivery.pause.payment_issue.cta': 'Aggiorna pagamento',
  'delivery.pause.other.title': 'In pausa',
  'delivery.pause.other.body': 'Scrivici un breve messaggio e controlliamo.',
  'delivery.expand.hint': 'Questo cambia il tuo target, anche per le ricerche manuali.',
  'delivery.pause.profile_missing.title': 'In pausa: questo target non esiste più',
  'delivery.pause.profile_missing.body': 'Crea un nuovo target e attiva lì la consegna.',
  'delivery.pause.profile_missing.cta': 'Crea target',
  'delivery.pause.not_self_service.title': 'In pausa: il tuo account è seguito dal nostro team',
  'delivery.pause.not_self_service.body': 'Ricevi le tue aziende tramite Autopilot.',
  'delivery.pause.account_closed.title': 'In pausa: cancellazione richiesta',
  'delivery.pause.account_closed.body': 'Non consegniamo a un account in fase di cancellazione.',
  'delivery.pause.unsupported_model.title': 'In pausa: non inclusa nel tuo piano',
  'delivery.pause.unsupported_model.body': 'La consegna fa parte di Basic, Starter e Growth.',
  'delivery.short.title': 'Ultima consegna: {delivered} di {target} aziende',
  'delivery.short.body': 'Il tuo target al momento non offre di più. Allargalo con un clic:',
  'delivery.expand.loading': 'Verifica dei suggerimenti …',
  'delivery.expand.none': 'Descrivi il tuo target in modo più ampio per continuare.',
  'delivery.expand.edit': 'Modifica target',
  'delivery.expand.applied': 'Target ampliato. La prossima consegna parte a breve.',
  'delivery.expand.opt.area': 'Allarga a tutto il territorio di {area} invece di {from} e avvia la consegna',
  'delivery.expand.opt.dach': 'Allarga a Germania, Austria e Svizzera e avvia la consegna',
  'delivery.expand.opt.industry': 'Aggiungi {industry} al tuo target e avvia la consegna',
  'delivery.expand.opt.size': 'Ammetti aziende di ogni dimensione invece di {from} dipendenti e avvia la consegna',
  'delivery.toast.on': 'La consegna è attiva. La prima parte a breve.',
  'delivery.toast.off': 'La consegna è disattivata.',
  'delivery.toast.failed': 'Non ha funzionato. Riprova.',
  'delivery.toast.planRequired': 'Per la consegna ti serve un piano attivo.',
  'delivery.history.title': 'Consegne precedenti',
  'delivery.history.cycle': 'Consegna {no}',
  'delivery.history.companies': '{n} aziende',
  'delivery.history.withContact': '{n} con decisore',
  'delivery.history.acceptRate': '{pct} % in target',
  'delivery.history.noRating': 'non ancora valutata',
  'delivery.history.review': 'Valuta ora ({n} aperte)',
  'delivery.history.show': 'Vedi',
  'delivery.history.empty': 'La tua prima consegna apparirà qui.',
  'delivery.history.more': 'Mostra tutte',
  'delivery.history.less': 'Mostra meno',
  'delivery.filter.prefix': 'Filtrato su:',
  'delivery.notif.ready.title': 'La tua consegna è arrivata: {n} aziende',
  'delivery.notif.ready.body': '{connected} con decisore, per {name}. Valutale e arriva la prossima.',
  'delivery.notif.paused.out_of_credits.title': 'Consegna in pausa: crediti esauriti',
  'delivery.notif.paused.out_of_credits.body': 'Con nuovi crediti riparte da sola.',
  'delivery.notif.paused.niche_exhausted.title': 'Consegna in pausa: target esaurito',
  'delivery.notif.paused.niche_exhausted.body': 'Allarga {name} con un clic per continuare.',
  'agent.delivery.tool.status': 'Controlla consegna',
  'agent.delivery.tool.set': 'Consegna settimanale',
  'agent.delivery.cost.enable': 'Fino a {credits} crediti per consegna: ogni settimana ~{n} nuove aziende, e per ognuna cerchiamo il decisore. Quel credito lo paghi solo se lo troviamo. Puoi disattivarla quando vuoi.',
};

export default it;
